// LINK DE VENDA DIRETA
import React from 'react';
import PropTypes from 'prop-types';
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { Link } from 'react-router';
import {Colors, Styles} from '../../../src/styles/theme';

import PaypalExpressBtn from 'react-paypal-express-checkout';
import { Alert, Container, Col, Row, Form, FormGroup, Label, Progress, Input, Button } from 'reactstrap';
import Cards from "react-credit-cards";
import Avatar from 'material-ui/Avatar';
import queryString from 'query-string';
import pdfResumoPropostaPF from '../relatorio/resumo_proposta_pf';

//import classNames from "classnames";


import {
	Step,
	Stepper,
	StepLabel,
} from 'material-ui/Stepper';
import '../../assets/css/cards.css';

// import AccountCircle from 'material-ui/icons/AccountCircle';
import axios from 'axios';
import InputMask from 'react-input-mask';
import urlBase from '../../url-base';
import * as Scroll from 'react-scroll';
import { MoipValidator } from 'moip-sdk-js';//validação de cartões de crédito
import moment from 'moment';
//import CurrencyInput from 'react-currency-input';
import '../../assets/css/checkout.css';
import Dialog from 'material-ui/Dialog';

import { browserHistory } from 'react-router';

const STYLE = {
	label: 'paypal',
	size: 'responsive',// small | medium | large | responsive
	shape: 'rect',      // pill | rect
	color: 'blue',      // gold | blue | silver | black
	tagline: false,
	height: 52
};

class FormPlan extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			cvc: '',
			expiry: '',
			focus: '',
			name: '',
			number: '',
			idEndereco:"",
			idCidade: "",
			listOfStates:[],
			dataNascimento:"",
			districtDescription:"",
			finished: false,
			formExtra: null,
			phasesForm: 1,
			open: false,
			cardQuestion: null,
			dateSignatureContract: null,
			modal: false,
			validateForm: false,
			validateFormCpfCard: false,
			habilitaCpfCartao: '',
			openTerms: false,
			cityList: [],
			openSuccess: false,
			modalNoDependent: false,
			modalValidateCard: false,
			modalPhases: false,
			modalPhasesResume: false,
			modalOpenUF:true,
			noDependents: false,
			resultValidateForm: [],
			plan: "",
			maturityDate: "",
			effectiveDate: "",
			payment_plan: "",
			unitary_value: "",
			unitary_value2: "",
			value_plan: "",
			value_total: "",
			type_plan: "",
			planoSelecionado:"",
			valueDescontIndividual: '',
			valueDescontTotal: '',
			totalNoDescont: '',
			progress: 0,
			objectPlan: {},
			valueIndividualPlan: "",
			city: "",
			idUf:"",
			cpfObligatoryDependent: false,
			cpfDependentIsValid: true,
			addressTypeList: [],
			stateList: [],
			cityListFinancialManager: [],
			cityListHolder: [],
			districtListFinancialManager: [],
			districtListHolder: [],
			resumeFinal: false,
			dental_v_i: "",
			flagCardPayment: '',
			isHiperCard: false,
			cardNumberFourFinal: '',
			chosenDateCard: '',
			dateExpirationCard: '',
			followProposal: '',
			nameSalesman: '',
			nameBroker: '',
			salesmanPagSeguroEmail: '',
			salesmanPagSeguroToken: '',
			salesmanPagSeguro: false,
			salesmanPaypalId: '',
			dataPagseguroPayment: {},
			combineWithSalesman: false,
			buttonPayPal: false,
			buttonPagSeguro: false,
			payPalApproved: false,
			payPalApprovedData: {},
			pagSeguroData: {
				transactionCode: '',
				success: false
			},
			payPalId: {
				sandbox: '',
				production: '',
			},

			financialManager: {
				firstName: "", lastName: "", susNumber: "", email: "", homePhone: "", nomeCidade:"",nomeEstado:"",
				cellPhone: "", cellPhone2: "", motherName: "", cpf: "", cpfCard: "", rg: "", rgEmitter: "", dateOfBirth: "",
				maritalStatus: "", gender: "", cep: "", addressType: "", address: "",
				addressNumber: "", addressComplement: "", district: "",  city: "", state: ""
			},
			holder: {
				firstName: "", lastName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
				maritalStatus: "", gender: "", isHolder: true
			},
			dependent: {
				firstName: "", lastName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
				maritalStatus: "", gender: "", parentage: "", isHolder: false
			},
			dependentsList: [],
			imagesDocs: {
				cnh: "", cpf: "", rg: "", address: "", cardCredit: ""
			},

			backgroundPage: '',
			buttonSubmitForm: true,

			currentTimeServer: null,
			vanityTicketValue: '-1',
			vanityTicketButton: false,

			creditCardNumberValid: false,
			dateCardValid: false,
			prepaidCard: false,
			messagesErrorCard: [],
			showMsgSuccessSalesman: false,

			editFinancialManagerId: '',
			editImagesDocId: '',
			editSalesId: '',

			openLoading: false,
			portability: false,
			validity: '',

			selectSalesMan: false,
			salesManName: '',
			btnFinishSales: 'enable',

			planSLZ: ["DENTAL SUPER SLZ TPC03", "DENTAL CLÍNICO SLZ VIP", "DENTAL DIGITAL SLZ", "DENTAL ORTOMAX"],
			planPB: ["DENTAL DIGITAL", "DENTAL VIP", "DENTAL ORTO PF TPC04 ( VIP )", "DENTAL SUPER TPC03", "DENTAL ORTO PF TPC05", "SPO PARCERIA MEI PB"],
			stateMASLZ: false,
			stateJPA: false,
			openCep: false,
			showCepError: false,
			cepNaoLocalizado: false,
			planAvaliable: true,
			planName: '',
			holderAvaliable: true,
			alertPlanNotAvaliable: false,
			alertCardAvaliable: false,
			alertBoleto: false,
			modalBoleto: false,
			modalPriorizarCadastro: false,
			planCodeS4E: '',
			contractFile: '',
			cobertura :{
				linha_1 :'',
				linha_2 :'',
				urgencia : '',
				dentistica:'',
				periodontia : '',
				endodontia : '',
				cirurgias : '',
				coroa : '180 DIAS'     
			},
			salesman :{
				name : '',
				codeS4 : '',
				user : {
					name : ''
				}
			},
			broker : {
				name : ''
			},
			dadosImpressao: {
				financialManager: '',
				holder: '',
				dependents : '' ,
				validity : '',				
			},
			sales : {
				status : ''
			},			  						  
			imagesDoc : {
				cpf : '',
				rg : '',
				rg2 : '',
				resid :'',
				credtFrontal :'',
				declarationPortability : ''
			}		  
		};

		this.styles = {
			modal: {
				width: '85%',
				maxWidth: 'none',
			},
			avatar: {
				div: {
					padding: '30px 0 20px 30px',
					backgroundColor: '#ffffff',
					height: 45,
					boxSizing: 'unset'
				},
				icon: {
					float: 'left',
					display: 'block',
					marginRight: 15,
					boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.15)'
				}
			}
		};
		this.downloadPDF = this.downloadPDF.bind(this);
		this.openPDF = this.openPDF.bind(this);	
	}
	downloadPDF()  {
		let state = this.state;
		pdfResumoPropostaPF(state.dadosImpressao, "download");
	}
	openPDF()  {
		this.setFinancialManager();

		this.state.holder = this.state.dependentsList[0];
		//this.state.holder.plans = plans;

		this.state.dadosImpressao = {
			financialManager: this.state.financialManager,
			holder: this.state.holder,
			dependents : this.state.dependentsList ,
			validity : this.state.effectiveDate,
			salesman : this.state.salesman,
			broker : this.state.broker,
			imagesDoc : this.state.imagesDoc,
			sales : this.state.sales,
			plan : this.state.planoSelecionado
		};		
		let day = this.state.currentTimeServer.day;
		let month = this.state.currentTimeServer.month;

		if (day < 10)
			day = '0' + day;
		if (month < 10)
			month = '0' + month;

		let adesao = day + '/' + month + '/' + this.state.currentTimeServer.year  ;		

		if (document.getElementById('validadeCartao') != undefined)
			this.state.dadosImpressao.financialManager.cardValidity = document.getElementById('validadeCartao').value.slice(0,2) + document.getElementById('validadeCartao').value.slice(3);

		this.state.dadosImpressao.financialManager.bairro = this.state.districtDescription;
		this.state.dadosImpressao.financialManager.municipio = this.state.dadosImpressao.financialManager.nomeCidade;
		this.state.dadosImpressao.financialManager.estado = this.state.dadosImpressao.financialManager.nomeEstado;
		this.state.dadosImpressao.financialManager.proposalNumber = '';
		this.state.dadosImpressao.financialManager.dateSignatureContract = adesao;
		this.state.dadosImpressao.financialManager.responsibility = this.state.value_total;
		this.state.dadosImpressao.financialManager.cardNumber = " XXXX.XXXX.XXXX." + this.state.cardNumberFourFinal;
		if (document.getElementById('cardHolderName') != undefined)
			this.state.dadosImpressao.financialManager.cardHolderName = document.getElementById('cardHolderName').value;
		this.state.dadosImpressao.financialManager.cardFlag = this.state.flagCardPayment;
		pdfResumoPropostaPF(this.state.dadosImpressao,"visualizar");
	}

	openModalHiper() {
		let state = this.state;
		state.openModalHiper = true;
		state.hiperMarter = "";
		this.setState(state);
	}

	//Abre modal que define se o cartão master é Hiper-Master
	handleHiperMasterOpen() {
		let state = this.state;
		state.modalHiperMaster = true;
		this.setState(state);
	}
	//Fecha modal que define se o cartão master é Hiper-Master

	handleHiperMasterClose() {
		this.setState({ hiperMarter: false })
		this.setState({ modalHiperMaster: false });
	}

	//Abre modal de alerta para priorização no cadastro dos beneficiários
	handlePriorizarCadastroOpen() {
		let state = this.state;
		// Para ativar colocar o true
		state.modalPriorizarCadastro = true;
		this.setState(state);
	}

	handlePriorizarCadastroClose() {
		this.setState({ modalPriorizarCadastro: false });
	}

	closeModalHiper() {
		let state = this.state;
		state.openModalHiper = false;
		state.hiperMarter = "";
		this.setState(state);
	}
	selectHiperMasterNao() {
		let state = this.state;
		state.openModalHiper = false;
		state.isHiperCard = false;
		this.dateValidityCredtCard()
		this.setState(state);

	}
	selectDiaVencimento() {
		let state = this.state;
		state.financialManager.cardDayExpiration = document.getElementById('fm_cardDayExpiration').value;
		state.chosenDateCard = document.getElementById('fm_cardDayExpiration').value;
		this.setState(state);
	}

	selectHiperMasterSim() {
		let state = this.state;
		state.openModalHiper = false;
		state.hiperMarter = "HIPERCARD";
		state.isHiperCard = true;
		this.setState(state);

		//    let date = this.state.dateSignatureContract;

		let chosenDate = this.state.currentTimeServer.day;

		this.state.flagCardPayment = 'HIPERCARD';

		if (chosenDate != null) {
			let dataSubmit = {
				city: sessionStorage.getItem("select_cities"),
				dayInclusion: chosenDate,
				type: 'CARTÃO',
				flag: this.state.flagCardPayment
			};
			//  this.validateSelect('fm_cardDayExpiration');
			axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
				.then((response) => {
					let state = this.state;
					// Seta as características da forma de pagameto no state para ser enviado posteriormente
					state.financialManager.formOfPaymentId = response.data.id;
					state.financialManager.contractNumberS4 = response.data.codeS4;
					state.financialManager.cardDayExpiration = response.data.validity
					// state.financialManager.cardDayExpiration = document.getElementById('fm_cardDayExpiration').value;
					//  state.chosenDateCard = document.getElementById('fm_cardDayExpiration').value;
					// Início da vigência:
					state.effectiveDate = response.data.validity;

					/* Regra dos 25 dias */
					let cartao = '';
					let cartaoMes = document.getElementById('validadeCartao').value.substring(0, 2);
					let cartaoAno = document.getElementById('validadeCartao').value.substring(3, 7);

					// Cálculo do mês do cartão
					cartaoMes = parseInt(cartaoMes) - 1;
					if (cartaoMes < 10)
						cartaoMes = '0' + cartaoMes;

					let day = this.state.currentTimeServer.day;
					let month = this.state.currentTimeServer.month;

					if (day < 10)
						day = '0' + day;
					if (month < 10)
						month = '0' + month;

					//let partDate = state.others.dateSignatureContract.split('/');
					let adesao = moment(this.state.currentTimeServer.year + '-' + month + '-' + day);

					cartao = moment(new Date(cartaoAno, cartaoMes, '01'));

					if (cartao.diff(adesao, 'days') >= 25) {
						state.maturityDate = moment(state.currentTimeServer.year + '-' +
							state.currentTimeServer.month + '-' +
							response.data.validity
						).add(1, 'M').format('DD/MM/YYYY');
					}
					else {
						//TODO
						state.maturityDate = moment(state.currentTimeServer.year + '-' +
							state.currentTimeServer.month + '-' +
							response.data.validity
						).add(2, 'M').format('DD/MM/YYYY');
					}
					/* Fim Regra dos 25 dias */


					this.setState(state);
				})
				.catch(function () {
					alert('2 Erro ao buscar Forma de Pagamento');
				});
		}

	}

	handleInputFocus(e) {
		this.setState({ focus: e.target.name });
	}

	handleInputChange(e) {
		const { name, value } = e.target;
		if (e.target.name == 'name') {
			this.inputToUpperCase(e.target.id);
		}

		this.setState({ [name]: value });
	}
	selecionaEstado(uf=null) {
		let param = queryString.parse(window.location.search);

		let estado;
		if (uf != null)
			estado = parseInt(uf);
		else
			estado = parseInt(document.getElementById('i_select_states').value);
		
		if ( (param.plano == "dental-super" || param.plano== "planodentalsuper" ) ) {
			window.location.href = "https://planodentalcenter.com.br/"
			//return;
		} 
			
		let state = this.state;
		state.modalOpenUF = false;
		state.combineWithSalesman = true;
		state.idUf = estado;
		this.getCity(estado);
		state.financialManager.state = estado;
		this.setState(state);
		localStorage.setItem('id_uf', state.estado);
        let idPlano="";
		let type_plan="";
		//let idSalesman = localStorage.getItem('dental_v_i');
		if (param.plano != undefined) {
			// payment_plan true (cartão) false (boleto)
			//idSalesman = '5b72d82c1195442302cd6c4a';
			localStorage.setItem("payment_plan", true);
			localStorage.setItem("show_card_flags", true);
			// planodentalvip
			if (param.plano == "dental-vvip" || param.plano == "planodentalvip" ) {
				type_plan = 'vip';
				//5b512e56a44a486a9aaf68f8 - 1072 (PB, PE, RN)
				//609c3f2204887d7bec1bec35 - 1100 (MA)
				
				switch (estado) {
					case 1: // ALAGOAS
					case 14: // PARAÍBA
						//idPlano = '65946d1c755b87362c84eaed';									
						idPlano = '5b512e56a44a486a9aaf68f8';									
						break;	
					case 15: // PERNAMBUCO
						//idPlano = '65946d69755b87362c84eaee';
						idPlano = '5b512e56a44a486a9aaf68f8';
				
						break;	
					case 9: // MARANHÃO
						//idPlano = '65946dbe755b87362c84eaf0';
						idPlano = '609c3f2204887d7bec1bec35';					
						break;	
					case 19: // RIO GRANDE DO NORTE
						//idPlano = '65946d95755b87362c84eaef';
						idPlano = '5b512e56a44a486a9aaf68f8';				
						break;	
				}
			}
			// planodentalorto
			if (param.plano == "dental-ortomax"  || param.plano == "planodentalorto") {
				type_plan = 'orto';
				//5b512e56a44a486a9aaf68f9 - 1068 (PB, PE, RN)
				//627a98a6c700f01961d6f79c - 1098 (MA)					
				switch (estado) {
					case 1: // ALAGOAS
					case 14:
						idPlano = '5b512e56a44a486a9aaf68f9'; 
						//localStorage.setItem("dental_plan", '6595bc33755b87362c84eb49');
						localStorage.setItem("type_plan", "orto");						
						break;	
					case 15:
						idPlano = '5b512e56a44a486a9aaf68f9';						
						break;	
					case 9:
						//idPlano = '6595bcda755b87362c84eb4c';
						idPlano = '627a98a6c700f01961d6f79c';						
						break;	
					case 19:
						idPlano = '5b512e56a44a486a9aaf68f9';						
						break;	
				}				
			
			}
			//planodentaldigital
			if (param.plano == "dental-digital" || param.plano == "planodentaldigital") {
				type_plan = 'digital';
				//5d76652517185e4be41e6ea3 - 1091 (PB, PE, RN)
				//6177048abb93c0e3ae1c6c3c - 1108 (MA)									
				switch (estado) {
					case 1: // ALAGOAS
					case 14:
						//idPlano = '6595b9ff755b87362c84eb45';
						idPlano = '5d76652517185e4be41e6ea3';

						break;	
					case 15:
						//idPlano = '6595ba26755b87362c84eb46';
						idPlano = '5d76652517185e4be41e6ea3';
						
						break;	
					case 9:
						//idPlano = '6595ba68755b87362c84eb48';
						idPlano = '6177048abb93c0e3ae1c6c3c';					
						break;	
					case 19:
						//idPlano = '6595ba46755b87362c84eb47';	
						idPlano = '5d76652517185e4be41e6ea3';					
					
						break;	
				}	
			}	   		   		   

		} else {

			idPlano = localStorage.getItem("dental_plan");
			type_plan = localStorage.getItem("type_plan");
			//idSalesman = localStorage.getItem('dental_v_i');

		}

		localStorage.setItem("type_plan", type_plan);
		localStorage.setItem("dental_plan", idPlano);
		this.state.payment_plan = localStorage.getItem("payment_plan");
		this.state.type_plan = localStorage.getItem("type_plan");		
		//	this.state.type_plan = type_plan;
		//localStorage.setItem("dental_v_i", idSalesman);
		// Pega características do plano
		axios.get(urlBase.loopBack + 'Plans/' +  idPlano )
			.then((result) => {
				// Implementar aqui a promoção de novembro

				const { familyTable, name, codeS4, contractFile } = result.data || {};
				const value = familyTable ? familyTable.value2 : 0; // Previne erro caso familyTable venha undefined				
				this.setState({
					value_plan: value,
					totalNoDescont: value,
					value_total: value,
					objectPlan: result.data,
					planName: name,
					planCodeS4E: codeS4,
					contractFile: contractFile,
					openCep: false,
					unitary_value : familyTable.value2,
					unitary_value2: familyTable.value3,
					planoSelecionado: result.data
				});	
			})
			.catch(function (erro) {
				console.log(erro);
			});

	}

	onCloseModalUF(){
		let state = this.state;
		state.modalOpenUF = false;
		this.setState(state);
	}	
	componentWillMount() {

		let state = this.state;
		state.listOfStates = [
			{Id: 1, Sigla : 'Alagoas'},
			{Id: 9, Sigla : 'Maranhão'},
			{Id: 14, Sigla : 'Paraíba'},
			{Id: 15, Sigla : 'Pernambuco'},
			{Id: 19, Sigla : 'Rio Grande do Norte'} 
	]
		this.setState(state);

		let idUf = localStorage.getItem('id_uf');

		this.state.btnFinishSales = 'enable';
		if (idUf == 14) {
			this.state.stateJPA = true;
			this.state.stateMASLZ = false;
		} else
			if (idUf == 19) {
				this.state.stateJPA = false;
				this.state.stateMASLZ = true;
			}

		// Pega a lista de tipos de endereço
		axios.get(urlBase.loopBack + 'APIS4s/tipoLogradouro')
			.then((result) => {
				let state = this.state;
				state.addressTypeList = result.data;
				this.setState(state);
			})
			.catch(function (erro) {
				console.log(erro);
			});

		// Pega a lista de estados
		axios.get(urlBase.loopBack + 'APIS4s/UFs')
			.then((result) => {
				let state = this.state;
				state.stateList = result.data;
				this.setState(state);
			})
			.catch(function (erro) {
				console.log(erro);
			});

		// Pega a data atual do servidor
		axios.post(urlBase.loopBack + 'Sales/currentTime')
			.then((response) => {
				let state = this.state;
				state.currentTimeServer = response.data;
				this.setState(state);
			})
			.catch(function () {
				console.log('Erro ao pegar data do servidor');
			});

	}

	componentDidMount() {
		let param = queryString.parse(window.location.search);

		if ( (param.plano == "dental-super" || param.plano== "planodentalsuper" ) ) {
			window.location.href = "https://institucional.planodentalcenter.com.br/"
			return;
		} 
		// Se for boleto
		if (localStorage.getItem('payment_plan') == 'false') {
			// Pega a data atual do servidor
			axios.post(urlBase.loopBack + 'Sales/currentTime')
				.then((response) => {
					let state = this.state;
					state.currentTimeServer = response.data;
					this.setState(state);
				})
				.catch(function () {
					console.log('Erro ao pegar data do servidor');
				});
		}

		if (localStorage.getItem('dental_v_name') == null) {
			this.state.selectSalesMan = false;
			this.setState(this.state);
		} else {
			this.state.selectSalesMan = true;
			this.state.salesManName = localStorage.getItem('dental_v_name');
			this.setState(this.state);
		}
	}

	scrollToTop() {
		let scroll = Scroll.animateScroll;
		scroll.scrollToTop();
	}

	onResumePrint() {
		window.print();
	}

	onOpenModalTerms() {
		this.setState({ openTerms: true });
	}

	onCloseModalTerms() {
		this.setState({ openTerms: false });
	}

	onOpenModalLoading() {
		this.setState({ openLoading: true });
	}

	onOpenModalSuccess() {
		this.setState({ openSuccess: true });
	}
	//  redirecionamento
	onCloseModalSuccess() {
		// paulo

		let state = this.state;
		state.openSuccess = false;
		this.setState(state);
		if (this.props.admin == false)
			window.location.href = urlBase.client + 'sucesso';
		else
			window.location.href = urlBase.client + 'panel/salesregistration';
	}

	onOpenModalPhases() {
		this.onCloseModalNoDependent();
		this.setState({ modalPhases: true });
	}

	onCloseModalPhases() {
		let state = this.state;
		state.modalPhases = false;
		this.setState(state);
	}
	//fim dos modais----------


	//funções de validação criar state boolean e setar dentro das funcoes para saber se sao validas ou fazer uma so que verifique todas
	validateCheckbox(id) {
		let state = this.state,
			checked = document.getElementById(id).checked;
		if (checked == false) {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		}
		this.setState(state);

	}

	verifyCheck(id) {
		let state = this.state,
			checked = document.getElementById(id).checked;
		if (checked == false) {
			state.followProposal = false;
		} else {
			state.followProposal = true;
		}
		this.setState(state);
	}

	validateLetters(id) {
		let state = this.state, name = document.getElementById(id).value;
		let nameReg = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

		if (name == "") {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			if (!nameReg.test(name)) {
				document.getElementById("alert_" + id).style.display = "block";
				state.resultValidateForm.push(false);
			} else {
				document.getElementById("alert_" + id).style.display = "none";
				state.resultValidateForm.push(true);
			}
		}
		this.setState(state);
	}

	validateSus(id) {
		let state = this.state,
			tam = document.getElementById(id).value.length;
		if (tam == 15 || tam == 0) {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		} else {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		}
		this.setState(state);
	}

	validateEmail(id) {
		let state = this.state,
			email = document.getElementById(id).value,
			emailReg = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

		if (this.props.admin == false) {
			if (!emailReg.test(email) || email == "") {
				document.getElementById("alert_" + id).style.display = "block";
				state.resultValidateForm.push(false);
			} else {
				document.getElementById("alert_" + id).style.display = "none";
				state.resultValidateForm.push(true);
			}
		}
		else {
			if (email != '') {
				if (!emailReg.test(email)) {
					document.getElementById("alert_" + id).style.display = "block";
					state.resultValidateForm.push(false);
				}
				else {
					document.getElementById("alert_" + id).style.display = "none";
					state.resultValidateForm.push(true);
				}
			}
			else {
				state.resultValidateForm.push(true);
				document.getElementById("alert_" + id).style.display = "none";
			}
		}

		this.setState(state);
	}

	validateNumberAddress(id) {
		let state = this.state,
			number = document.getElementById(id).value,
			numberAddress = /^[A-Za-z0-9/ ]+$/;

		if (number == "" || !numberAddress.test(number)) {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		}
		this.setState(state);
	}

	validateEmpty(id) {
		try {
			let state = this.state,
				empty = document.getElementById(id).value;

			if (empty == "") {
				document.getElementById("alert_" + id).style.display = "block";
				state.resultValidateForm.push(false);
				if (id == 'cardHolderName')
					state.validateForm = false;
			} else {
				document.getElementById("alert_" + id).style.display = "none";
				state.resultValidateForm.push(true);
				if (id == 'cardHolderName')
					state.validateForm = true;
			}
			this.setState(state);
		}
		catch (error) {
			//console.log(error);
		}

	}

	validateDateCpfDependent(id) {

		let part = id.split('/'),
			dateIs = new Date(),//data atual
			day = dateIs.getDate(),
			year = dateIs.getFullYear(),
			month = dateIs.getMonth() + 1;
		let age = '';
		age = year - part[2];
		if (month < parseInt(part[1]) || month == parseInt(part[1]) && day < parseInt(part[0])) {
			age--;
		}
		return age;
	}

	validatePlanAge(date) {

		if (this.validateDateCpfDependent(date) > 10 && this.state.planName == "DENTAL VIP SLZ TPC00 00-10") {
			this.state.alertPlanNotAvaliable = true;
			return false;
		}

	}

	validateDate(id) {

		let state = this.state;
		let date = document.getElementById(id).value;
		/*date = new Date(),*/
		let dateReg = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

		if (!dateReg.test(date) || date == "") {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		}
		this.setState(state);
	}

	validateDatePlan(id) {

		let state = this.state;
		let date = document.getElementById(id).value;
		/*date = new Date(),*/
		let dateReg = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

		if (!dateReg.test(date) || date == "") {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
			this.validatePlanAge(date);
		}
		this.setState(state);
	}

	checkAge(id) {

		let state = this.state;
		/* let part = document.getElementById(id).value.split('-');
		let date = (part[2]+"/"+part[1]+"/"+part[0]); */
		let date = document.getElementById(id).value;

		//Validar se a data é maior que 18 anos
		let nasc = date.split("/").map(Number);
		//construir data 18 anos a seguir a data dada pelo usuario
		let nascimento = new Date(nasc[2], nasc[1], nasc[0]);
		let agora = new Date();

		let yearsDiff = agora.getFullYear() - nascimento.getFullYear();

		if (yearsDiff >= 18) {
			//console.log("Maior de 18");
			state.resultValidateForm.push(true);
			document.getElementById("alert_" + id + '_18').style.display = "none";
		}
		else {
			//console.log("Menor de 18");
			state.resultValidateForm.push(false);
			document.getElementById("alert_" + id + '_18').style.display = "block";
		}

		this.setState(state);

	}

	validateDateAndAge(id) {

		this.validateDate(id);
		this.checkAge(id);

	}

	validateDateDependent(id) {
		// RETIRADA DO CÓDIO EM ATENDIMENTO A MELHORIA PARA OBRIGATORIEDADE DO CPF PARA QUALQUER IDADE
		// let part = document.getElementById(id).value.split('/'),
		// 	dateIs = new Date(),//data atual
		// 	day = dateIs.getDate(),
		// 	year = dateIs.getFullYear(),
		// 	month = dateIs.getMonth() + 1;
		// let state = this.state;
		//let date = (part[0]+"/"+part[1]+"/"+part[2]);
		let date = document.getElementById(id).value;
	//	let age = '';
		let dateReg = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

		// age = year - part[2];
		// if (month < parseInt(part[1]) || month == parseInt(part[1]) && day < parseInt(part[0])) {
		// 	age--;
		// }
		//verificacao da idade para obrigatoriedade do cpf
		/*
		if (age > 10) {

			this.validateCpfDependent('dp_cpf');
			if (!state.cpfDependentIsValid) {
				// setando  false para tirar desobrigatoriedade para menores de 10
				state.cpfObligatoryDependent = false;
				document.getElementById("alert_cpfObligatory").style.display = "block";
			} else {
				state.cpfObligatoryDependent = false;
				document.getElementById("alert_cpfObligatory").style.display = "none";
			}


		} else {

			let cpfDependente = document.getElementById("dp_cpf").value;
			if (cpfDependente == '') {
				document.getElementById("alert_cpfObligatory").style.display = "none";
				state.cpfObligatoryDependent = false;
			}

		}
		*/
		//validacao de data de nascimento
		let state = this.state;
		if (!dateReg.test(date) || date == "") {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
			/*
			let nascimento = new Date(part[2], part[1] - 1, part[0]);
			let now = new Date();

			if (nascimento < now) {
				document.getElementById("alert_" + id).style.display = "none";
				state.resultValidateForm.push(true);
			} else {
				document.getElementById("alert_" + id).style.display = "block";
				state.resultValidateForm.push(false);
			}
			*/
		}
		this.setState(state);
	}

	validateSelect(id) {//valida campos type: select
		if (document.getElementById(id) != null) {
			let state = this.state;
			if (document.getElementById(id).value == -1) {
				document.getElementById("alert_" + id).style.display = "block";
				state.resultValidateForm.push(false);

			} else {
				document.getElementById("alert_" + id).style.display = "none";
				state.resultValidateForm.push(true);
			}
			// colocado aqui para poder desabilitar campo dia do vencimento. Apagar em um próxima versão
			state.resultValidateForm.push(true);

			this.setState(state);
		}

	}
	// AQUI
	dateValidity(numberDay = null) {//data de vencimento boleto
		if (this.props.admin == false) {
			let state = this.state;
			let day = this.state.currentTimeServer.day;
			let year = this.state.currentTimeServer.year;
			let month = this.state.currentTimeServer.month;
			let chosenDate = null;

			if (numberDay == null)
				chosenDate = document.getElementById('vanity_ticket').value;//dia do vencimento escolhido
			else {
				chosenDate = numberDay;
			}

			state.vanityTicketValue = chosenDate;

			moment.locale('pt-BR');

			if (month < 10)
				month = '0' + month;

			// ###### Caso 1: Se a data escolhida for menor que a data atual ######
			if (chosenDate < day) {
				let dataSubmit = {
					city: sessionStorage.getItem("select_cities"),
					dayInclusion: chosenDate,
					type: 'BOLETO'
				};
				axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
					.then((response) => {
						let state = this.state;
						// Seta as características da forma de pagameto no state para ser enviado posteriormente
						state.financialManager.formOfPaymentId = response.data.id;
						state.financialManager.contractNumberS4 = response.data.codeS4;

						// Calcula data de vigência: 1º dia da tabela + 1 mês
						let dayInclusion = response.data.dayInclusion[0];
						if (dayInclusion < 10)
							dayInclusion = '0' + dayInclusion;

						state.effectiveDate = moment(year + '-' + month + '-' + dayInclusion).add(1, 'M').format('DD/MM/YYYY');

						// Calcula data de vencimento: dia escolhido + 2 mês
						if (chosenDate < 10)
							chosenDate = '0' + chosenDate;
						state.maturityDate = moment(year + '-' + month + '-' + chosenDate).add(1, 'M').format('DD/MM/YYYY');

						this.setState(state);
					})
					.catch(function () {
						alert('Erro ao buscar Forma de Pagamento');
					});
			}
			// ###### Caso 2: Se a data escolhida for maior ou igual que a data atual ######
			else if (chosenDate >= day) {
				let dataSubmit = {
					city: sessionStorage.getItem("select_cities"),
					dayInclusion: chosenDate,
					type: 'BOLETO'
				};
				axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
					.then((response) => {
						let state = this.state;
						// Seta as características da forma de pagamento no state para ser enviado posteriormente
						state.financialManager.formOfPaymentId = response.data.id;
						state.financialManager.contractNumberS4 = response.data.codeS4;

						let dayInclusion = response.data.dayInclusion;

						// Se o dia escolhido estiver dentro da tabela de data de inclusão
						if (dayInclusion.indexOf(parseInt(chosenDate)) > -1) {
							if (chosenDate < 10)
								chosenDate = '0' + chosenDate;

							// Regra para fevereiro
							if (chosenDate > 28 && month == '02')
								chosenDate = moment(year + '-' + month).endOf('month').format('DD');

							// Usa o dia escolhido
							state.effectiveDate = moment(year + '-' + month + '-' + chosenDate).format('DD/MM/YYYY');
						}
						else {
							dayInclusion = dayInclusion[0];

							if (dayInclusion < 10)
								dayInclusion = '0' + dayInclusion;

							// Usa o dia atual
							state.effectiveDate = moment(year + '-' + month + '-' + dayInclusion).format('DD/MM/YYYY');
						}

						// Calcula data de vencimento: dia escolhido + 1 mês
						state.maturityDate = moment(year + '-' + month + '-' + chosenDate).add(1, 'M').format('DD/MM/YYYY');

						this.setState(state);
					})
					.catch(function () {
						alert('Erro ao buscar Forma de Pagamento');
					});
			}

			this.setState(state);
		}
	}

	onChangeDateSignatureContract() {
		let state = this.state;
		state.dateSignatureContract = document.getElementById('fm_dateSignatureContract').value;
		this.setState(state);
	}

	dateValiditySalesman() {
		let date = this.state.dateSignatureContract;
		date = date.split('-');
		date = new Date(date[0], date[1], date[2]);
		let day = date.getDate();
		let year = date.getFullYear();
		let month = date.getMonth() + 1;
		/* let chosenDate = document.getElementById(id).value; */

		if (day < 10)
			day = '0' + day;
		if (month < 10)
			month = '0' + month;

		moment.locale('pt-BR');
		let dataSubmit = {
			city: sessionStorage.getItem("select_cities"),
			dayInclusion: day,
			type: 'BOLETO'
		};
		axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
			.then((response) => {
				let state = this.state;
				// Seta as características da forma de pagamento no state para ser enviado posteriormente
				state.financialManager.formOfPaymentId = response.data.id;
				state.financialManager.contractNumberS4 = response.data.codeS4;

				if (this.props.admin) {
					// Início da vigência:
					state.effectiveDate = day + '/' + month + '/' + year;
					// Calcula data de vencimento
					state.maturityDate = moment(year + '-' +
						month + '-' +
						response.data.validity).add(1, 'M').format('DD/MM/YYYY');
				}
				else {
					// Início da vigência:
					state.effectiveDate = moment(year + '-' + month + '-' + day).format('DD/MM/YYYY');
					// Calcula data de vencimento
					state.maturityDate = moment(year + '-' + month + '-' + day).add(1, 'M').format('DD/MM/YYYY');
				}

				this.setState(state);
			})
			.catch(function () {
				alert('Erro ao buscar Forma de Pagamento');
			});
	}

	dateValidityCredtCard(id = null) {//data de vencimento cartão de crédito
		let chosenDate = id;

		chosenDate = this.state.currentTimeServer.day;
        // paulo tratar erro
		if (chosenDate != null) {
			let dataSubmit = {
				city: sessionStorage.getItem("select_cities"),
				dayInclusion: chosenDate,
				type: 'CARTÃO',
				flag: MoipValidator.cardType(document.getElementById('numeroCartao').value.replace(/\D/g, '')).brand
			};
			// this.validateSelect('fm_cardDayExpiration');
			axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
				.then((response) => {
					let state = this.state;
					// Seta as características da forma de pagameto no state para ser enviado posteriormente
					state.financialManager.formOfPaymentId = response.data.id;
					state.financialManager.contractNumberS4 = response.data.codeS4;
					state.financialManager.cardDayExpiration = response.data.validity;

					//  state.financialManager.cardDayExpiration = document.getElementById('fm_cardDayExpiration').value;
					// Paulo verificar document.getElementById('fm_cardDayExpiration').value;
					//state.chosenDateCard = document.getElementById('fm_cardDayExpiration').value;
					// Início da vigência:
					state.effectiveDate = response.data.validity;

					/* Regra dos 25 dias */
					let cartao = '';
					let cartaoMes = document.getElementById('validadeCartao').value.substring(0, 2);
					let cartaoAno = document.getElementById('validadeCartao').value.substring(3, 7);
					// Cálculo do mês do cartão
					cartaoMes = parseInt(cartaoMes) - 1;
					if (cartaoMes < 10)
						cartaoMes = '0' + cartaoMes;

					let day = this.state.currentTimeServer.day;
					let month = this.state.currentTimeServer.month;

					if (day < 10)
						day = '0' + day;
					if (month < 10)
						month = '0' + month;

					//let partDate = state.others.dateSignatureContract.split('/');
					let adesao = moment(this.state.currentTimeServer.year + '-' + month + '-' + day);

					cartao = moment(new Date(cartaoAno, cartaoMes, '01'));

					if (cartao.diff(adesao, 'days') >= 25) {
						state.maturityDate = moment(state.currentTimeServer.year + '-' +
							state.currentTimeServer.month + '-' +
							response.data.validity
						).add(1, 'M').format('DD/MM/YYYY');
					}
					else {
						//TODO
						state.maturityDate = moment(state.currentTimeServer.year + '-' +
							state.currentTimeServer.month + '-' +
							response.data.validity
						).add(2, 'M').format('DD/MM/YYYY');
					}
					/* Fim Regra dos 25 dias */

					// Calcula data de vencimento: dia escolhido + 1 mês
					/* state.maturityDate = moment(state.currentTimeServer.year + '-' +
																state.currentTimeServer.month + '-' +
																response.data.validity).add(1, 'M').format('DD/MM/YYYY'); */

					this.setState(state);
				})
				.catch(function () {
					alert('1- Erro ao buscar Forma de Pagamento');
				});
		}

	}
	cardUsuarioQuestionS() {
		let state = this.state;
		state.habilitaCpfCartao = false;
		state.financialManager.cpfCard = ""
		this.setState(state);
		document.getElementById("alert_questionUsuarioCpfCard").style.display = "none";


	}

	cardUsuarioQuestionN() {
		let state = this.state;
		state.habilitaCpfCartao = true;
		this.setState(state);
		document.getElementById("alert_questionUsuarioCpfCard").style.display = "none";

	}


	formCardQuestionS() {
		let state = this.state;
		state.cardQuestion = true;
		this.setState(state);
		this.validatecardQuestion();
	}

	formCardQuestionN() {
		let state = this.state;
		state.cardQuestion = false;
		this.setState(state);
		this.validatecardQuestion();
	}

	validateCardNumber(id, number = null) {//valida o numero do cartão
		let creditCardNumber,
			state = this.state;
		state.creditCardNumberValid = false;

		if (number == null) {
			creditCardNumber = document.getElementById(id).value;
		} else {
			creditCardNumber = number.replace(/\D/g, '');
		}
		if (MoipValidator.isValidNumber(creditCardNumber)) {//valida o numero do cartão
			this.flagOfCard(creditCardNumber);//função que exibe a bandeira do cartão
			document.getElementById("alert_" + id).style.display = "none";//cartao válido
			state.resultValidateForm.push(true);
			state.creditCardNumberValid = true;
			this.state.btnFinishSales = "enable";
			this.validarCartaoCreditoCardBin();
			if (MoipValidator.cardType(creditCardNumber).brand == "MASTERCARD") {
				this.selectHiperMasterNao();

				/*
				if (localStorage.getItem('dental_y') == null) {
					this.selectHiperMasterNao();
				} else {
				 this.openModalHiper();        
				}
				*/

			} else {
				this.dateValidityCredtCard();
			}

		}
		else {
			document.getElementById("alert_" + id).style.display = "block";//cartão inválido
			document.getElementById("alert_" + id).innerHTML = '*Cartão inválido!'
			//esconde a bandeira, caso ela ja tenha sido exibida ao digitar um cartao valido e depois um invalido
			document.getElementById("flag_master").style.display = "none";
			document.getElementById("flag_visa").style.display = "none";//
			document.getElementById("flag_elo").style.display = "none";//
			document.getElementById("flag_hiper").style.display = "none";//
			state.resultValidateForm.push(false);
			state.creditCardNumberValid = false;

		}
		this.setState(state);
		//this.dateValidityCredtCard(null);
	}

	validateExpirationDateCard(id) {// valida a data de validade do cartão
		let dateExpiration = document.getElementById(id).value.split('/');
		let state = this.state;
		if (parseInt(dateExpiration[1]).toString().length != 4) {
			document.getElementById("alert_" + id).style.display = "block";//data inválida
			state.resultValidateForm.push(false);
			state.dateCardValid = false;
		} else {
			if (MoipValidator.isExpiryDateValid(dateExpiration[0], dateExpiration[1])) {//valida da data de validade do cartão
				document.getElementById("alert_" + id).style.display = "none";//data válida
				state.resultValidateForm.push(true);
				state.dateCardValid = true;
				state.dateExpirationCard = document.getElementById(id).value;
			} else {
				document.getElementById("alert_" + id).style.display = "block";//data inválida
				state.resultValidateForm.push(false);
				state.dateCardValid = false;
			}
		}
		this.setState(state);

		//this.dateValidityCredtCard(null);
	}

	validatecardQuestion() {// valida cardQuestion titular
		let state = this.state;
		// Caso a pergunta do titular do cartao nao esteja respondida e o usuário tente avançar
		if (this.state.cardQuestion == null) {
			//dispara o alerta na pergunta do titular do cartão
			document.getElementById("alert_questionHolderCard").style.display = "block";
			state.resultValidateForm.push(false);
		} else {
			document.getElementById("alert_questionHolderCard").style.display = "none";
			state.resultValidateForm.push(true);
		}
		this.setState(state);
	}

	flagOfCard(numberCard) {//função que exibe a bandeira do cartão
		let state = this.state;

		if (MoipValidator.cardType(numberCard).brand == "MASTERCARD") {//return [Object]MASTERCARD
			document.getElementById("flag_master").style.display = "block";
			document.getElementById("flag_visa").style.display = "none";
			document.getElementById("flag_elo").style.display = "none";
			document.getElementById("flag_hiper").style.display = "none";
			document.getElementById("alert_flagCard").style.display = "none";

			state.flagCardPayment = "MASTERCARD";
			let num = numberCard.replace(/\D/g, '');
			state.cardNumberFourFinal = num.toString().substr(num.toString().length - 4);

		}
		else if (MoipValidator.cardType(numberCard).brand == "VISA") {//return [Object]VISA
			document.getElementById("flag_visa").style.display = "block";
			document.getElementById("flag_master").style.display = "none";
			document.getElementById("flag_hiper").style.display = "none";
			document.getElementById("flag_elo").style.display = "none";
			document.getElementById("alert_flagCard").style.display = "none";

			state.flagCardPayment = "VISA";
			let num = numberCard.replace(/\D/g, '');
			state.cardNumberFourFinal = num.toString().substr(num.toString().length - 4);
		}
		else if (MoipValidator.cardType(numberCard).brand == "HIPERCARD") {//return [Object]HIPERCARD
			document.getElementById("flag_hiper").style.display = "block";
			document.getElementById("flag_visa").style.display = "none";
			document.getElementById("flag_elo").style.display = "none";
			document.getElementById("flag_master").style.display = "none";
			document.getElementById("alert_flagCard").style.display = "none";

			state.flagCardPayment = "HIPERCARD";
			let num = numberCard.replace(/\D/g, '');
			state.cardNumberFourFinal = num.toString().substr(num.toString().length - 4);
		}
		else if (MoipValidator.cardType(numberCard).brand == "ELO") {//return [Object]ELO
			document.getElementById("flag_elo").style.display = "block";
			document.getElementById("flag_visa").style.display = "none";
			document.getElementById("flag_hiper").style.display = "none";
			document.getElementById("flag_master").style.display = "none";
			document.getElementById("alert_flagCard").style.display = "none";

			state.flagCardPayment = "ELO";
			let num = numberCard.replace(/\D/g, '');
			state.cardNumberFourFinal = num.toString().substr(num.toString().length - 4);
		}
		else {
			document.getElementById("alert_flagCard").style.display = "block";
			document.getElementById("flag_elo").style.display = "none";
			document.getElementById("flag_visa").style.display = "none";
			document.getElementById("flag_hiper").style.display = "none";
			document.getElementById("flag_master").style.display = "none";
		}

		this.setState(state);
		//MoipValidator.cardType('6370950000000005');    //return [Object]HIPER
	}

	// validateTel(id){
	//   let state = this.state;
	//   let tel = document.getElementById(id).value.replace(/[^0-9]/g,'').length;
	//   if (tel == 10 || tel == 0) {
	//     document.getElementById("alert_"+id).style.display="none";
	//     state.resultValidateForm.push(true);
	//   }else{
	//     document.getElementById("alert_"+id).style.display="block";
	//     state.resultValidateForm.push(false);
	//   }
	//   this.setState(state);
	// }

	validateCell(id) {
		let state = this.state;
		let tel = document.getElementById(id).value.replace(/[^0-9]/g, '').length;
		if (tel == 11) {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		} else {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		}
		this.setState(state);
	}

	validateCell2(id) {
		let state = this.state;
		let tel = document.getElementById(id).value.replace(/[^0-9]/g, '').length;
		if (tel == 11 || tel == 0) {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		} else {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);
		}
		this.setState(state);
	}

	validateCpfDependent(id) {
		this.validateCpf(id);
	}

	validateCpf(id) {
		let alertId = "alert_" + id;
		let state = this.state;
		let cpf = document.getElementById(id).value.replace(/[^0-9]/g, '');
		let test = true;
		let add = 0, i = 0, rev = 0;
		state.cpfDependentIsValid = true;

		//state.resultValidateForm = [];

		if (cpf.length != 11 ||
			cpf == "00000000000" ||
			cpf == "11111111111" ||
			cpf == "22222222222" ||
			cpf == "33333333333" ||
			cpf == "44444444444" ||
			cpf == "55555555555" ||
			cpf == "66666666666" ||
			cpf == "77777777777" ||
			cpf == "88888888888" ||
			cpf == "99999999999") {
			test = false;
		}
		else {
			// Valida 1° digito
			for (i = 0; i < 9; i++)
				add += parseInt(cpf.charAt(i)) * (10 - i);
			rev = 11 - (add % 11);
			if (rev == 10 || rev == 11) {
				rev = 0;
			}
			if (rev != parseInt(cpf.charAt(9))) {
				test = false;
			}
			// Valida 2° digito
			add = 0;
			for (i = 0; i < 10; i++) {
				add += parseInt(cpf.charAt(i)) * (11 - i);
			}
			rev = 11 - (add % 11);
			if (rev == 10 || rev == 11) {
				rev = 0;
			}
			if (rev != parseInt(cpf.charAt(10))) {
				test = false;
			}
		}
		if (test == true) {
			if (id === "fm_cpfCard") {
				this.state.validateFormCpfCard = true;
				document.getElementById("alert_fm_cpfCard").innerHTML = ""

			}			
			document.getElementById("alert_" + id).style.display = "none";
			//document.getElementById("alert_cpfObligatory").style.display="none";
			state.resultValidateForm.push(true);
			if (alertId != 'alert_dp_cpf') {
				this.countFinancialManager();
			}

			if (alertId == 'alert_dp_cpf') {
				document.getElementById("alert_cpfObligatory").style.display = "none";
				state.cpfDependentIsValid = true;
			} else {
				document.getElementById("alert_" + id).style.display = "none";
			}

		} else {
			if (this.state.cpfObligatoryDependent) {
				if (alertId != 'alert_dp_cpf') {
					document.getElementById("alert_" + id).style.display = "none";
				} else {
					document.getElementById("alert_cpfObligatory").style.display = "block";
					state.cpfDependentIsValid = false;
				}

			} else {
				if (alertId != 'alert_dp_cpf') {
					if (id == "fm_cpfCard") {
						document.getElementById("alert_fm_cpfCard").innerHTML = "* CPF Inválido"

						this.state.validateFormCpfCard = false;
					}
					document.getElementById("alert_" + id).style.display = "block";
				} else {
					document.getElementById("alert_cpfObligatory").style.display = "block";
					state.cpfDependentIsValid = false;
				}

			}
			state.resultValidateForm.push(false);
		}
		this.setState(state);
	}


	validateformPayment() {
		// Se o formulário estiver sendo exibido no Panel
		if (this.props.admin == false) {
			let state = this.state;
			state.resultValidateForm = [];
			// Caso a pergunta do titular do cartao nao esteja respondida e o usuário tente avançar
			if (this.state.cardQuestion == null) {
				//dispara o alerta na pergunta do titular do cartão
				document.getElementById("alert_questionHolderCard").style.display = "block";
				state.validateForm = false;
			}
			//se não achar nenhum campo invalido retorna -1
			if (state.resultValidateForm.indexOf(false) == -1)
				state.validateForm = true;
			else
				state.validateForm = false;

			this.setState(state);
		}
		else {
			let state = this.state;
			//state.resultValidateForm = [];
			//se não achar nenhum campo invalido retorna -1
			if (state.resultValidateForm.indexOf(false) == -1)
				state.validateForm = true;
			else
				state.validateForm = false;
			this.setState(state);
		}

		//serve para validar e disparar os alertas para os campos vazios
		this.validateCardNumber('numeroCartao', document.getElementById('numeroCartao').value);
		this.validateExpirationDateCard('validadeCartao', document.getElementById('validadeCartao').value);//TODO
		this.validateEmpty("cardHolderName");//nome do titular do cartão
	}
	//fim das validações
	//faz o controle das etapas do formulário
	countFinancialManager() {
		let cpf = document.getElementById('fm_cpf').value;
		let url = urlBase.loopBack + 'APIS4s/ValidarCPF';
		let dataSubmit = {
			cpf: cpf
		};

		document.getElementById('loading_cpf').style.display = 'inline-block';

		if (cpf.length > 0) {
			axios.post(url, dataSubmit)
				.then((response) => {
					let state = this.state;

					if (response.data != null) {
						if (response.data.length > 0) {
							for (let i = 0; i < response.data.length; i++) {
								if (response.data[i].situacaoDescricao != "ATIVO" && response.data[i].situacaoDescricao != "CANCELADO") {
									state.editFinancialManagerId = '';
									state.editImagesDocId = '';
									document.getElementById("alert_fm_cpf").innerHTML = "Possui dívida ativa";
									document.getElementById("alert_fm_cpf").style.display = "block";
									state.resultValidateForm.push(false);
									alert('Esse CPF consta como "usuário com dívida ativa" em nosso sistema, por isso o cadastro não será permitido. Entre em contato com a Dental Center para a resolução desse problema.');
								} else {
									document.getElementById("alert_fm_cpf").style.display = "none";
									state.resultValidateForm = [];
								}
							}
						}
						else {
							document.getElementById("alert_fm_cpf").style.display = "none";
							state.resultValidateForm = [];
						}
					}
					else {
						document.getElementById("alert_fm_cpf").style.display = "none";
						state.resultValidateForm = [];
					}

					this.setState(state);
					document.getElementById('loading_cpf').style.display = 'none';
				})
				.catch(function () {
					let state = this.state;
					state.editFinancialManagerId = '';
					state.editImagesDocId = '';
					document.getElementById('loading_cpf').style.display = 'none';
					document.getElementById("alert_fm_cpf").innerHTML = "Erro ao pesquisar CPF";
					document.getElementById("alert_fm_cpf").style.display = "block";
					state.resultValidateForm.push(false);
					this.setState(state);
				}.bind(this));
		}



	}

	payment_card_select() {//mostra cartão de crédito selecionado
		if (document.getElementById("master").checked) {
			document.getElementById("master1").style.outline = '5px solid #F57E54';
			document.getElementById("visa1").style.outline = '0px';
			document.getElementById("hiper1").style.outline = '0px';
			document.getElementById("elo1").style.outline = '0px';
		}
		if (document.getElementById("visa").checked) {
			document.getElementById("visa1").style.outline = '5px solid #F57E54';
			document.getElementById("master1").style.outline = '0px';
			document.getElementById("hiper1").style.outline = '0px';
			document.getElementById("elo1").style.outline = '0px';
		}
		if (document.getElementById("hiper").checked) {
			document.getElementById("hiper1").style.outline = '5px solid #F57E54';
			document.getElementById("visa1").style.outline = '0px';
			document.getElementById("master1").style.outline = '0px';
			document.getElementById("elo1").style.outline = '0px';
		}
		if (document.getElementById("elo").checked) {
			document.getElementById("elo1").style.outline = '5px solid #F57E54';
			document.getElementById("visa1").style.outline = '0px';
			document.getElementById("hiper1").style.outline = '0px';
			document.getElementById("master1").style.outline = '0px';
		}
	}

	validatePaymentCard() {
		let state = this.state;
		state.resultValidateForm = [];

		this.validateCardNumber("numeroCartao", null);//valida number
		this.validateExpirationDateCard("validadeCartao"); //valida vencimento do cartao
		if (this.props.admin == false) {
			this.validatecardQuestion();//valida pergunta
		}
		if (this.state.creditCardNumberValid == true) {//so valida se o select de dia do vencimento ja existir na pagina
			this.dateValidityCredtCard('fm_cardDayExpiration');
		}
		if (state.resultValidateForm.indexOf(false) == -1)
			state.validateForm = true;
		else
			state.validateForm = false;
		this.setState(state);
	}

	form_payment_accession() {// boleto

		let pagseguroExists = document.getElementById("pagseguroCard");
		let paypalExists = document.getElementById("paypalCard");
		if (pagseguroExists) {
			if (document.getElementById("pagseguro").checked) {
				let state = this.state;
				state.buttonPagSeguro = true;
				state.buttonPayPal = false;
				state.combineWithSalesman = false;
				this.setState(state);
				document.getElementById("pagseguro1").style.border = '5px solid #72B842';
				if (paypalExists) {
					document.getElementById("paypalCard1").style.border = '0px';
				}
				document.getElementById("avista1").style.border = '0px';
			}
		}

		if (paypalExists) {
			if (document.getElementById("paypal").checked) {
				let state = this.state;
				state.buttonPagSeguro = false;
				state.buttonPayPal = true;
				state.combineWithSalesman = false;
				this.setState(state);
				if (pagseguroExists) {
					document.getElementById("pagseguroCard1").style.border = '0px';
					document.getElementById("pagseguro1").style.border = '0px';
				}

				document.getElementById("avista1").style.border = '0px';
			}
		}
		if (document.getElementById("avista").checked) {
			let state = this.state;
			state.buttonPagSeguro = false;
			state.buttonPayPal = false;
			state.combineWithSalesman = true;
			this.setState(state);
			document.getElementById("avista1").style.border = '5px solid #F57E54';
			if (paypalExists) {
				document.getElementById("paypal1").style.border = '0px';
			}
			if (pagseguroExists) {
				document.getElementById("pagseguro1").style.border = '0px';
			}

		}
	}

	form_payment_accession2() {//cartao de credito
		let state = this.state;

		this.validatePaymentCard();
		this.validateformPayment();

		if (this.state.validateForm == true) {//verifica se esta válido apos as validacoes
			let pagseguroExists = document.getElementById("pagseguroCard");
			let paypalExists = document.getElementById("paypalCard");

			if (pagseguroExists) {
				if (document.getElementById("pagseguroCard").checked) {
					state.buttonPagSeguro = true;
					state.buttonPayPal = false;
					state.combineWithSalesman = false;
					this.setState(state);
					document.getElementById("pagseguroCard1").style.border = '5px solid #72B842';
					if (paypalExists) {
						document.getElementById("paypalCard1").style.border = '0px';
					}
					document.getElementById("avistaCard1").style.border = '0px';
				}
			}
			if (paypalExists) {
				if (document.getElementById("paypalCard").checked) {
					state.buttonPayPal = true;
					state.buttonPagSeguro = false;
					state.combineWithSalesman = false;
					this.setState(state);
					document.getElementById("paypalCard1").style.border = '5px solid #009CDE';
					if (pagseguroExists) {
						document.getElementById("pagseguroCard1").style.border = '0px';
					}
					document.getElementById("avistaCard1").style.border = '0px';
				}
			}

			if (document.getElementById("avistaCard").checked) {
				state.combineWithSalesman = true;
				state.buttonPagSeguro = false;
				state.buttonPayPal = false;
				this.setState(state);
				document.getElementById("avistaCard1").style.border = '5px solid #F57E54';
				if (paypalExists) {
					document.getElementById("paypalCard1").style.border = '0px';
				}
				if (pagseguroExists) {
					document.getElementById("pagseguroCard1").style.border = '0px';
				}
			}
		} else {
			this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
		}

	}

	form_file() {
		if (document.getElementById("radioCpf").checked) {
			document.getElementById("file_hidden_cpf").style.display = 'block';
			document.getElementById("file_hidden_cnh").style.display = 'none';
			document.getElementById("file_hidden_rg").style.display = 'block';
			document.getElementById("file_hidden_compResid").style.display = 'block';
			if (this.state.payment_plan === "true") {
				document.getElementById("file_hidden_cartCred").style.display = 'block';
				document.getElementById("container_height").style.height = "auto!important";
			} else {
				document.getElementById("container_height").style.height = "auto!important";
			}

		}
		if (document.getElementById("radioCnh").checked) {
			document.getElementById("file_hidden_cpf").style.display = 'none';
			document.getElementById("file_hidden_cnh").style.display = 'block';
			document.getElementById("file_hidden_rg").style.display = 'none';
			document.getElementById("file_hidden_compResid").style.display = 'block';
			if (this.state.payment_plan === "true") {
				document.getElementById("file_hidden_cartCred").style.display = 'block';
				document.getElementById("container_height").style.height = "auto!important";
			} else {
				document.getElementById("container_height").style.height = "auto!important";
			}
		}
	}

	handleChangeSelectField(id, event, index, value){
		let state = this.state;
		if(id === "fm_state"){
			state.financialManager.state = value;
			document.getElementById('fm_ciy').value = this.state.financialManager.district;
			this.getCity(value);
		}
		if(id === "fm_city"){
			state.financialManager.city = value;
			document.getElementById("alert_fm_city").style.display = "none"

			this.getDistrict(value);
		}	
		if(id === "fm_district"){
			this.state.financialManager.district = value;
			document.getElementById('fm_district').value = this.state.financialManager.district;
			document.getElementById("alert_fm_district").style.display = "none"
            if (index>0) {
				this.state.districtDescription = state.districtListFinancialManager[index-1].Nome;
			}

		}				
		this.setState(state);
	}

  //APIS4s/Municipios
  getCity(idState) {
    let dataPost = {
      'idUF': idState
    };
    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      let state = this.state;
      state.financialManager.city = null;
      state.cityList = [];
      console.log("Erro ao buscar cidades : "+ erro);
      this.setState(state);

    });
  }

	getDistrict(idCity) {

		let dataPost = {
			'idCity': parseInt(idCity)
		};

		// Pega a lista de bairros
		axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
			.then((result) => {

				let state = this.state;
				state.districtListFinancialManager = result.data;
				this.setState(state);

				axios.get(urlBase.loopBack + 'Cities?filter={"where":{"codeS4":"' + document.getElementById('fm_city').value + '"}}')
					.then((result2) => {
						document.getElementById('fm_addressNumber').focus();
						document.getElementById('loading_address').style.display = 'none';

						if (result2.data[0] != undefined) {
							sessionStorage.setItem('select_cities', result2.data[0].id);
						}
						else {
							axios.get(urlBase.loopBack + 'Cities?filter={"where":{"default":true}}')
								.then((result3) => {
									// Padrão João Pessoa
									sessionStorage.setItem('select_cities', result3.data[0].id);
								})
								.catch(function (erro) {
									alert('Erro ao buscar cidade padrão: ' + erro);
								});// Fim centro de custo padrão
						}
					})
					.catch(function (erro) {
						alert('Erro ao buscar cidades: ' + erro);
					});// Fim centro de custo
			})
			.catch(function (erro) {
				console.log(erro);
			});
	}

	validateCep(id) {

		let state = this.state;
		let cep = document.getElementById(id).value.replace(/[^0-9]/g, '').length;
		if (cep !== 8 || document.getElementById(id).value.replace(/[^0-9]/g, '') === '00000000') {
			document.getElementById("alert_" + id).style.display = "block";
			state.resultValidateForm.push(false);			
			state.financialManager.state = state.idUf;
			state.financialManager.addressType = "";
			state.financialManager.address = "";
			state.financialManager.city = "";
			state.financialManager.district = "";	
			//state.financialManager.districtDescription = "";
			state.financialManager.nomeCidade = "";
			state.financialManager.nomeEstado = "";	
		} else {
			document.getElementById("alert_" + id).style.display = "none";
			state.resultValidateForm.push(true);
		}
		this.setState(state);
	}
	// Analisar e apagar (não está sendo usado)
	validateCepModal() {
		let state = this.state;
		let cep = document.getElementById('buscacep').value.replace(/[^0-9]/g, '').length;

		if (cep == 8) {
			state.showCepError = false;
			state.resultValidateForm.push(true);
		} else {
			state.showCepError = true;
			state.resultValidateForm.push(false);
		}
		this.setState(state);
	}


	getAddress() {
		this.validateCep("fm_cep");//chama a função de validação
		let valueCep = '';
		document.getElementById('loading_address').style.display = 'inline-block';
		valueCep = this.state.financialManager.cep;
		// Verifica o tamanho do cep
		if (valueCep.length >= 8) {
			let dataPost = {
				'cep': valueCep
			};
			// Pega o endereço
			axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
				.then((result) => {
					if (result.data != null) {
						// Atualiza a   lista de cidades e de bairros
						let state = this.state;
						if (result.data.IdUf != state.idUf ) {
							//state.planAvaliable = false;
							alert("Cep não pertecente ao estado selecionado.")
							state.financialManager.state = state.idUf;
							state.financialManager.addressType = "";
							state.financialManager.address = "";
							state.financialManager.city = "";
							state.financialManager.district = "";	
							//state.financialManager.districtDescription = "";
							state.financialManager.nomeCidade = "";
							state.financialManager.nomeEstado = "";	
							this.state.financialManager.cep="";												
						} else {
							//this.getCity(result.data.IdUf);
							this.getDistrict(result.data.IdMunicipio);
							//state.cityListFinancialManager = [];
							//state.districtListFinancialManager = [];
							state.financialManager.state = result.data.IdUf;
							state.financialManager.addressType = result.data.IdTipoLogradouro;
							state.financialManager.address = result.data.Logradouro;
							state.financialManager.city = result.data.IdMunicipio;
							state.financialManager.district = result.data.IdBairro;
							state.districtDescription = result.data.Bairro;

							state.financialManager.nomeCidade = result.data.Municipio;
							state.financialManager.nomeEstado = result.data.Uf;
							document.getElementById('fm_city').value = result.data.IdMunicipio;
							document.getElementById('fm_district').value = result.data.IdBairro;

						}						
						this.setState(state);
						document.getElementById('loading_address').style.display = 'none';

					}
					else
						document.getElementById('loading_address').style.display = 'none';
				})
				.catch(function (erro) {
					document.getElementById('loading_address').style.display = 'none';
					console.log(erro);
				});
		}
		else
			document.getElementById('loading_address').style.display = 'none';
	}

	// analisar para possivel deleção
	getAddressModal() {
		let cep = document.getElementById('buscacep').value.replace(/[^0-9]/g, '').length;
		if (cep == 8) {
			this.state.showCepError = false;
			//this.state.cepNaoLocalizado = true;
			this.state.resultValidateForm.push(true);
			this.setState(this.state);
		} else {

			this.state.cepNaoLocalizado = false;
			this.state.showCepError = true;
			this.state.planAvaliable = true;
			this.state.resultValidateForm.push(false);
			this.setState(this.state);

			return false;

		}


		let valueCep = '';

		document.getElementById('loading_address').style.display = 'inline-block';
		valueCep = this.state.financialManager.cep;

		// Verifica o tamanho do cep
		if (valueCep.length >= 8) {
			let dataPost = {
				'cep': valueCep
			};
			// Pega o endereço
			axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
				.then((result) => {
					if (result.data != null) {
						// Atualiza a lista de cidades e de bairros
						let state = this.state, prop;
						state.cityListFinancialManager = [];
						state.districtListFinancialManager = [];
						state.financialManager.state = result.data.IdUf;
						state.financialManager.addressType = result.data.IdTipoLogradouro;
						state.financialManager.address = result.data.Logradouro;
						state.financialManager.city = result.data.IdMunicipio;
						state.districtDescription = result.data.Bairro;
						state.financialManager.district = result.data.IdBairro;

						state.financialManager.nomeCidade = result.data.Municipio;
						state.financialManager.nomeEstado = result.data.Uf;

						state.cepNaoLocalizado = false;
						if (state.planSLZ.includes(state.planName) && result.data.Uf != "MARANHÃO") {
							state.planAvaliable = false;
						}

						if (state.planSLZ.includes(state.planName) && result.data.Uf == "MARANHÃO") {
							state.planAvaliable = true;
							state.openCep = false;
							state.combineWithSalesman = true;
							state.buttonPagSeguro = false;
							state.buttonPayPal = false;
							state.stateMASLZ = true;

							// Verificar se o plano aceita maior de idade
							if (state.planName == "DENTAL VIP SLZ TPC00 00-10") {
								state.holderAvaliable = false;
								state.formExtra = true;
								for (prop in this.state.holder) {
									state.holder[prop] = "";
								}
							}

						}

						if (state.planPB.includes(state.planName) && ( result.data.Uf != "PARAIBA" || result.data.Uf != "PERNAMBUCO" || result.data.Uf != "RIO GRANDE DO NORTE"  ) ) {
							state.planAvaliable = false;
						}

						if (state.planPB.includes(state.planName) && ( result.data.Uf == "PARAIBA" || result.data.Uf == "PERNAMBUCO" || result.data.Municipio == "NATAL") ) {
							state.planAvaliable = true;
							state.openCep = false;
							state.combineWithSalesman = true;
						}

						this.setState(state);
						// this.getCity(result.data.IdMunicipio);
						// this.getDistrict();
					}
					else {
						document.getElementById('loading_address').style.display = 'none';
						let state = this.state;
						state.cepNaoLocalizado = true;
						state.planAvaliable = true;
						this.setState(state);

					}
				})
				.catch(function (erro) {
					document.getElementById('loading_address').style.display = 'none';
					console.log(erro);
				});
		}
		else
			document.getElementById('loading_address').style.display = 'none';
	}

	addHolderListDependent() {
		let state = this.state;

		// Se o responsável financeiro não for participar do plano
		// Pega os dados do formulário de Titular
		if (this.state.formExtra == true) {
			state.holder.firstName = document.getElementById('hd_firstName').value;
			state.holder.lastName = document.getElementById('hd_lastName').value;
			state.holder.susNumber = document.getElementById('hd_susNumber').value;
			state.holder.motherName = document.getElementById('hd_motherName').value;
			state.holder.cpf = document.getElementById('hd_cpf').value;
			state.holder.dateOfBirth = document.getElementById('hd_dateOfBirth').value;
			state.holder.maritalStatus = document.getElementById('hd_maritalStatus').value;
			state.holder.gender = document.getElementById('hd_gender').value;
			state.holder.isHolder = true;
		}
		// Pega os dados do formulário de Responsável Financeiro
		if (this.state.formExtra == false) {
			state.holder.firstName = document.getElementById('fm_firstName').value;
			state.holder.lastName = document.getElementById('fm_lastName').value;
			state.holder.susNumber = document.getElementById('fm_susNumber').value;
			state.holder.motherName = document.getElementById('fm_motherName').value;
			state.holder.cpf = document.getElementById('fm_cpf').value;
			state.holder.dateOfBirth = document.getElementById('fm_dateOfBirth').value;
			state.holder.maritalStatus = document.getElementById('fm_maritalStatus').value;
			state.holder.gender = document.getElementById('fm_gender').value;
			state.holder.isHolder = true;
		}
		state.dependentsList.unshift(state.holder);
		this.setState(state);
	}

	deleteDependentList(index) {
		let state = this.state;
		state.dependentsList.splice(index, 1);
		this.setState(state);
		this.updateValueTotal();//atualiza valor do plano.
	}

	setDefaultDependent() {
		document.getElementById('dp_firstName').value = '';
		document.getElementById('dp_lastName').value = '';
		document.getElementById('dp_susNumber').value = '';
		document.getElementById('dp_motherName').value = '';
		document.getElementById('dp_maritalStatus').value = '-1';
		document.getElementById('dp_cpf').value = '';
		document.getElementById('dp_dateOfBirth').value = "";
		this.state.dependent.dateOfBirth = "";
		document.getElementById('dp_gender').value = '-1';
		document.getElementById('dp_parentage').value = '-1';
	}

	fileToBase64(typeDoc) {
		/*
		* @type pode ser: "cnh", "cpf", "rg", "rg2", "address", cardCredit
		*/

		let reader = new FileReader();
		let file = document.getElementById('doc_' + typeDoc).files[0];

		// Os arquivos só são obrigatórios no ambiente externo
		if (this.props.admin == false)
			this.validateEmpty('doc_' + typeDoc);
		else {
			let file = document.getElementById('doc_' + typeDoc).files[0];
			let ext = file.name.split('.').pop().toLowerCase();

			if (ext == 'pdf') {
				document.getElementById('name_file_pdf_' + typeDoc).style.display = 'inherit';
				document.getElementById('name_file_' + typeDoc).style.display = 'none';
			}
			else {
				document.getElementById('name_file_pdf_' + typeDoc).style.display = 'none';
				document.getElementById('name_file_' + typeDoc).style.display = 'inherit';
				document.getElementById('name_file_' + typeDoc).src = window.URL.createObjectURL(file);
			}
		}

		reader.onloadend = function () {
			document.getElementById('imagem_' + typeDoc).value = reader.result;
		}.bind(this);
		reader.readAsDataURL(file);
	}

	onCLickVanityTicket() {
		let state = this.state;
		state.vanityTicketButton = !state.vanityTicketButton;
		this.setState(state);
	}

	validaDadosCartao() {
		let state = this.state;

		let mensagens = [];
		state.messagesErrorCard = [];

		state.alertCardAvaliable = true;
		if (state.cardQuestion == null) {
			state.alertCardAvaliable = true;
			mensagens.push("Indique se o titular do cartão participa do plano!");
		}
		if (state.creditCardNumberValid == false) {
			state.alertCardAvaliable = true;
			mensagens.push("Número do Cartão inválido!");
		}
		if (state.dateCardValid == false) {
			state.alertCardAvaliable = true;
			mensagens.push("Data de validade do cartão inválida!");
		}

		if (document.getElementById("cardHolderName").value == "") {
			state.alertCardAvaliable = true;
			mensagens.push("Nome do titular do cartão em branco!");
		}
		if (document.getElementById('fm_cardDayExpiration') != null)
			if (document.getElementById('fm_cardDayExpiration').value == "-1") {
				state.alertCardAvaliable = true;
				mensagens.push("Informe o dia do vencimento do cartão de crédito!");
			}
		if (state.prepaidCard == true) {
			state.alertCardAvaliable = true;
			mensagens.push("A forma de pagamento pré-pago não é aceita! Tente novamente utilizando um cartão de crédito ou entre em contato com a Dental Center.");
		}
		state.messagesErrorCard = mensagens.map(msg =>
			<li>{msg}</li>
		)
		this.setState(state);

	}

	validarCartaoCreditoCardBin() {
		let state = this.state;
		document.getElementById("alert_numeroCartao").style.display = "none";
		document.getElementById("alert_numeroCartao").innerHTML = '';
		let header = {
			headers: {
				'Content-Type': 'application/json',
				'MerchantId': 'a7c2650a-5852-4444-a83a-f4435b1813f0',
				'MerchantKey': 'qbwnD2t4nhEGEgOYC42HkL8UdhEVNRUvtgqBdkHl'
			}
		}
		let cardNumber = document.getElementById('numeroCartao').value.replace(/\D/g, '').substring(0, 6);
		//  let numeroCartao = document.getElementById('numeroCartao').value.substring(0,6);
		// axios.get("https://apiquerysandbox.cieloecommerce.cielo.com.br/1/cardBin/444458",

		axios.get("https://apiquery.cieloecommerce.cielo.com.br/1/cardBin/" + cardNumber,
			header
		)
			.then((response) => {
				// let state = this.state;
				state.messagesErrorCard = [];
				//Prepaid
				state.prepaidCard = response.data.Prepaid;
				if (response.data.CardType == "Débito") {
					state.alertCardAvaliable = true;
					state.messagesErrorCard = "A forma de pagamento débido não é aceita! Tente novamente utilizando um cartão de crédito ou entre em contato com a Dental Center.";
					document.getElementById("alert_numeroCartao").style.display = "block";
					document.getElementById("alert_numeroCartao").innerHTML = "A forma de pagamento débido não é aceita!";//cartão inválido
					//cartão inválido
					state.resultValidateForm.push(false);
					state.creditCardNumberValid = false;
					this.setState(state);

				} else {
					//if (state.prepaidCard == true && response.data.Provider != 'VISA') {
					if (state.prepaidCard == true ) {
						state.alertCardAvaliable = true;
						state.messagesErrorCard = "A forma de pagamento pré-pago não é aceita! Tente novamente utilizando um cartão de crédito ou entre em contato com a Dental Center.";
						document.getElementById("alert_numeroCartao").style.display = "block";
						document.getElementById("alert_numeroCartao").innerHTML = "A forma de pagamento pré-pago não é aceita!";//cartão inválido
						//cartão inválido
						state.resultValidateForm.push(false);
						state.creditCardNumberValid = false;
						this.setState(state);

					} else {
						let state = this.state;
						state.alertCardAvaliable = false;
						state.resultValidateForm.push(true);
						state.creditCardNumberValid = true;
						document.getElementById("alert_numeroCartao").style.display = "none";//cartão inválido
						document.getElementById("alert_numeroCartao").innerHTML = '';
						this.setState(state);

					}
				}

			})
			.catch(function (error) {
				let state = this.state;
					state.alertCardAvaliable = false;
					state.resultValidateForm.push(true);
					state.creditCardNumberValid = true;
					document.getElementById("alert_numeroCartao").style.display = "none";//cartão inválido
					document.getElementById("alert_numeroCartao").innerHTML = '';
					this.setState(state);		
					console.log(error);	

			});
		this.setState(state);

	}

	afterSubmitForm() {
	
			this.state.btnFinishSales = "enable";
			// Se o form não estiver no Panel
			// COLOCAR ESSE TRECHO NO FINAL DO SUBMIT
			if (this.props.admin == false) {
				let state = this.state;
				state.resumeFinal = true;
				state.dental_v_i = localStorage.getItem('dental_v_i');
				this.setState(state);
				//this.onOpenModalPhasesResume();
			}
			// Se o form estiver no Panel

	}
	/**
	 * Novo método criado para mudar o fluxo de confirmação
	 * @param {*} idSalesman 
	 */
	onSubmitFormNew(idSalesman, action) {   
		let state = this.state;
		
		if (!document.getElementById("checkAccession1").checked) {
			this.onOpenModal();
			return
		} 

		if (action == 'cartao') {
			this.validatecardQuestion();
			if (this.state.dateCardValid == false || this.state.creditCardNumberValid == false || document.getElementById("cardHolderName").value == "" || this.state.cardQuestion == null) { //|| document.getElementById('fm_cardDayExpiration').value == '-1'
				this.onOpenModal();
				return false;
			} else {
				if (this.state.habilitaCpfCartao != true && this.state.habilitaCpfCartao != false ) {
					document.getElementById("alert_questionUsuarioCpfCard").style.display = "block";
					return false;
				} else {
					if ((this.state.habilitaCpfCartao == true && this.state.validateFormCpfCard == false) || (this.state.habilitaCpfCartao == true && this.state.financialManager.cpfCard == '')) {
						this.onOpenModal();
						return false;	
					} 
				}
			}
		}
		//this.state.openSuccess = true;
		//return;

		state.resultValidateForm = [];
		this.state.btnFinishSales = "no-active";
		this.setState(this.state);
		this.updateValueTotal();//atualiza valor do plano.

		if (state.payment_plan == 'true')
			this.validateSelect('fm_cardDayExpiration');

		// Se não achar nenhum campo invalido retorna -1
		if (state.resultValidateForm.indexOf(false) == -1) {
			state.validateForm = true;			
			let partDate;
			for (let i = 0; i < this.state.dependentsList.length; i++) {
				if (state.dependentsList[i].isHolder) {
					// Ajuste realizado após equipe de Juliana - state.dependentsList[i].valuePlan = this.state.objectPlan.value;
					state.dependentsList[i].valuePlan = this.state.valueIndividualPlan;
				}					
				else
					state.dependentsList[i].valuePlan = this.state.valueIndividualPlan;

				if (state.dependentsList[i].dateOfBirth.substring(2,3) == "/") {
					partDate = state.dependentsList[i].dateOfBirth.split('/');
					state.dependentsList[i].dateOfBirth = partDate[2] + '-' + partDate[1] + '-' + partDate[0];
				}

			}
			if (this.state.financialManager.dateOfBirth.substring(2,3) == "/") {
				partDate = this.state.financialManager.dateOfBirth.split('/');
				this.state.financialManager.dateOfBirth = partDate[2]+'-'+partDate[1]+'-'+partDate[0];				
			}


			this.setState(state);

			let dataSubmit = {
				idSalesman: idSalesman,
				plansId: localStorage.getItem("dental_plan"),
				financialManagerId: this.state.editFinancialManagerId,
				imagesDocId: this.state.editImagesDocId,
				salesId: this.state.editSalesId,
				frontAdmin: false,

				financialManager: state.financialManager,
				tipoVenda: 'link_direto',
				planServer : false,
				dependents: this.state.dependentsList,
				imagesDocs: {
					cnh: '',
					cpf: document.getElementById('imagem_cpf').value,
					rg: document.getElementById('imagem_rg').value,
					rg2: document.getElementById('imagem_rg2').value,
					address: document.getElementById('imagem_address').value,
					credtFrontal: document.getElementById('imagem_cardCredit').value,
					physicalContract: document.getElementById('imagem_physicalContract').value,
					adtive: document.getElementById('imagem_adtive').value,
					declarationPortability: document.getElementById('imagem_declarationPortability').value,
				}
			};
			dataSubmit.financialManager.responsibility = this.state.value_total;
			dataSubmit.financialManager.portability = this.state.portability;


			// Pega a data de adesão
			if (this.props.admin == true)
				dataSubmit.financialManager.dateSignatureContract = this.state.dateSignatureContract;
			else {
				let day = this.state.currentTimeServer.day;
				let month = this.state.currentTimeServer.month;
				if (day < 10) {
					day = '0' + day;
				}
				if (month < 10) {
					month = '0' + month;
				}
				dataSubmit.financialManager.dateSignatureContract = this.state.currentTimeServer.year + '-' +
					month + '-' + day;
			}


			// Quando for pagamento no cartão
			if (localStorage.getItem('payment_plan') != null &&
				localStorage.getItem('payment_plan') == 'true') {
				this.validateformPayment();//valida os campos de pagamento
				dataSubmit.financialManager.cardNumber = document.getElementById('numeroCartao').value;
				dataSubmit.financialManager.cardValidity = document.getElementById('validadeCartao').value;
				dataSubmit.financialManager.cardHolderName = document.getElementById('cardHolderName').value;
				if (state.isHiperCard == true)
					dataSubmit.financialManager.cardFlag = 'HIPERCARD'
				else
					dataSubmit.financialManager.cardFlag = MoipValidator.cardType(document.getElementById('numeroCartao').value.replace(/\D/g, '')).brand;
			}
			dataSubmit.financialManager.state = this.state.idUf;
			dataSubmit.financialManager.district = this.state.idEndereco;
			dataSubmit.financialManager.city = this.state.idCidade;

			axios.post(urlBase.loopBack + 'FinancialManagers/saveProposal', dataSubmit)
				.then((response) => {
					//modal de SUCESSO!

					this.onOpenModalLoading();
					//efeito fake - conclusão do formulario
					document.getElementById('modal_success').style.display = 'block';

					setTimeout(function () {
						let state = this.state;
						state.progress = 25;
						this.setState(state);
						document.getElementById('modal_success').style.display = 'none';
						document.getElementById('modal_success2').style.display = 'block';

						let dataSend = {
							id: response.data.sales.id
						};
						axios.post(urlBase.loopBack + 'Sales/SendEmailProposalCreate', dataSend)
							.then(() => {
								setTimeout(function () {
									let state = this.state;
									state.progress = 70;
									this.setState(state);
									document.getElementById('modal_success').style.display = 'none';
									document.getElementById('modal_success2').style.display = 'none';
									document.getElementById('modal_success3').style.display = 'block';

								}.bind(this), 1500);

								setTimeout(function () {
									let state = this.state;
									//document.getElementById('close_success').style.display = 'block';
									state.progress = 100;
									state.openLoading = false;
									state.openSuccess = true;
									this.setState(state);
								}.bind(this), 3000);
								//fim do efeito fake
								// Enviar formuláro do webhook
								if (localStorage.getItem("type_plan") == 'vip' || localStorage.getItem("type_plan") == 'orto' 
										|| localStorage.getItem("type_plan") == 'digital' ) {
									let forms = {
										nome 		: this.state.financialManager.firstName,
										cpf  		: this.state.financialManager.cpf,
										data_nasc	: this.state.financialManager.dateOfBirth,
										sexo		: this.state.financialManager.gender,
										nome_mae	: this.state.financialManager.motherName,
										celular		: this.state.financialManager.cellPhone,
										email		: this.state.financialManager.email,
										endereco	: this.state.financialManager.address,
										numero		: this.state.financialManager.addressNumber,
										cidade		: this.state.financialManager.nomeCidade,
										bairro		: this.state.districtDescription,
										estado		: this.state.financialManager.nomeEstado,
										cep			: this.state.financialManager.cep
									}; 		
									localStorage.removeItem('dental_v_i');
									localStorage.removeItem('dental_v_name');					  							  
									axios.post("https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTY5MDYzMjA0MzE1MjZiNTUzYzUxMzci_pc", forms)
									.then(() => {
										}).catch(function (erro) {
										console.log(erro)
										}.bind(this)
										);									

								}
								// Mostrar tela de resumo (Verificar com )
								this.afterSubmitForm();
							})
							.catch(function (error) {
								alert(error);
							});
					}.bind(this), 700);

				})
				.catch(() => {
					let state = this.state;
					state.buttonSubmitForm = true;
					this.setState(state);
					alert('Erro ao salvar a proposta');
				});
			this.setState(state);

		}
		else {
			state.validateForm = false;
			//state.buttonSubmitForm = false;
			this.setState(state);
			this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
		}
	}	

	beforeSubmitForm(action) {

		if (action == 'cartao') {
			this.validatecardQuestion();
			if (this.state.dateCardValid == false || this.state.creditCardNumberValid == false || document.getElementById("cardHolderName").value == "" || this.state.cardQuestion == null) { //|| document.getElementById('fm_cardDayExpiration').value == '-1'
				this.onOpenModal();
				return false;
			} else {
				if (this.state.habilitaCpfCartao != true && this.state.habilitaCpfCartao != false ) {
					document.getElementById("alert_questionUsuarioCpfCard").style.display = "block";
					return false;
				} else {
					if ((this.state.habilitaCpfCartao == true && this.state.validateFormCpfCard == false) || (this.state.habilitaCpfCartao == true && this.state.financialManager.cpfCard == '')) {
						this.onOpenModal();
						return false;	
					} 
				}
			}
		}
		this.state.btnFinishSales = "enable";
		// Se o form não estiver no Panel
		// COLOCAR ESSE TRECHO NO FINAL DO SUBMIT
		if (this.props.admin == false) {
			let state = this.state;
			state.resumeFinal = true;
			state.dental_v_i = localStorage.getItem('dental_v_i');
			this.setState(state);
			this.onOpenModalPhasesResume();
		}
		// Se o form estiver no Panel
		else {

			if (localStorage.getItem('dental_y') == 'SALESMAN') {
				let filter = 'Salesmans?filter={"where":{"userId":"' + localStorage.getItem('dental_u') + '"}}';

				axios.get(urlBase.loopBack + filter)
					.then((response) => {
						if (this.state.payment_plan == "true") {
							this.validatePaymentCard();
							if (this.state.validateForm == true) {
								this.onSubmitForm(response.data[0].id);
							} else {
								this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
							}
						} else {
							this.onSubmitForm(response.data[0].id);
						}
					})
					.catch(() => {
						let state = this.state;
						state.buttonSubmitForm = true;
						this.setState(state);
						alert('Erro ao buscar o vendedor');
					});
			}
			else
				this.onSubmitForm(localStorage.getItem('dental_v_i'));
		}
	}


	onSubmitForm(idSalesman) {   
    
		let state = this.state;
		state.resultValidateForm = [];
		this.state.btnFinishSales = "no-active";
		this.setState(this.state);
		this.updateValueTotal();//atualiza valor do plano.

		if (state.payment_plan == 'true')
			this.validateSelect('fm_cardDayExpiration');

		// Se não achar nenhum campo invalido retorna -1
		if (state.resultValidateForm.indexOf(false) == -1) {
			state.validateForm = true;			
			let partDate;
			for (let i = 0; i < this.state.dependentsList.length; i++) {
				if (state.dependentsList[i].isHolder) {
					// Ajuste realizado após equipe de Juliana - state.dependentsList[i].valuePlan = this.state.objectPlan.value;
					state.dependentsList[i].valuePlan = this.state.valueIndividualPlan;
				}					
				else
					state.dependentsList[i].valuePlan = this.state.valueIndividualPlan;

				if (state.dependentsList[i].dateOfBirth.substring(2,3) == "/") {
					partDate = state.dependentsList[i].dateOfBirth.split('/');
					state.dependentsList[i].dateOfBirth = partDate[2] + '-' + partDate[1] + '-' + partDate[0];
				}

			}
			if (this.state.financialManager.dateOfBirth.substring(2,3) == "/") {
				partDate = this.state.financialManager.dateOfBirth.split('/');
				this.state.financialManager.dateOfBirth = partDate[2]+'-'+partDate[1]+'-'+partDate[0];				
			}


			this.setState(state);

			let dataSubmit = {
				idSalesman: idSalesman,
				plansId: localStorage.getItem("dental_plan"),
				financialManagerId: this.state.editFinancialManagerId,
				imagesDocId: this.state.editImagesDocId,
				salesId: this.state.editSalesId,
				frontAdmin: false,

				financialManager: state.financialManager,
				tipoVenda: 'link_direto',
				dependents: this.state.dependentsList,
				imagesDocs: {
					cnh: '',
					cpf: document.getElementById('imagem_cpf').value,
					rg: document.getElementById('imagem_rg').value,
					rg2: document.getElementById('imagem_rg2').value,
					address: document.getElementById('imagem_address').value,
					credtFrontal: document.getElementById('imagem_cardCredit').value,
					physicalContract: document.getElementById('imagem_physicalContract').value,
					adtive: document.getElementById('imagem_adtive').value,
					declarationPortability: document.getElementById('imagem_declarationPortability').value,
				}
			};
			dataSubmit.financialManager.responsibility = this.state.value_total;
			dataSubmit.financialManager.portability = this.state.portability;


			// Pega a data de adesão
			if (this.props.admin == true)
				dataSubmit.financialManager.dateSignatureContract = this.state.dateSignatureContract;
			else {
				let day = this.state.currentTimeServer.day;
				let month = this.state.currentTimeServer.month;
				if (day < 10) {
					day = '0' + day;
				}
				if (month < 10) {
					month = '0' + month;
				}
				dataSubmit.financialManager.dateSignatureContract = this.state.currentTimeServer.year + '-' +
					month + '-' + day;
			}


			// Quando for pagamento no cartão
			if (localStorage.getItem('payment_plan') != null &&
				localStorage.getItem('payment_plan') == 'true') {
				this.validateformPayment();//valida os campos de pagamento
				dataSubmit.financialManager.cardNumber = document.getElementById('numeroCartao').value;
				dataSubmit.financialManager.cardValidity = document.getElementById('validadeCartao').value;
				dataSubmit.financialManager.cardHolderName = document.getElementById('cardHolderName').value;
				if (state.isHiperCard == true)
					dataSubmit.financialManager.cardFlag = 'HIPERCARD'
				else
					dataSubmit.financialManager.cardFlag = MoipValidator.cardType(document.getElementById('numeroCartao').value.replace(/\D/g, '')).brand;
			}
			dataSubmit.financialManager.state = this.state.idUf;
			dataSubmit.financialManager.district = this.state.idEndereco;
			dataSubmit.financialManager.city = this.state.idCidade;

			axios.post(urlBase.loopBack + 'FinancialManagers/saveProposal', dataSubmit)
				.then((response) => {
					//modal de SUCESSO!

					this.onOpenModalLoading();
					//efeito fake - conclusão do formulario
					document.getElementById('modal_success').style.display = 'block';

					setTimeout(function () {
						let state = this.state;
						state.progress = 25;
						this.setState(state);
						document.getElementById('modal_success').style.display = 'none';
						document.getElementById('modal_success2').style.display = 'block';

						let dataSend = {
							id: response.data.sales.id
						};
						axios.post(urlBase.loopBack + 'Sales/SendEmailProposalCreate', dataSend)
							.then(() => {
								setTimeout(function () {
									let state = this.state;
									state.progress = 70;
									this.setState(state);
									document.getElementById('modal_success').style.display = 'none';
									document.getElementById('modal_success2').style.display = 'none';
									document.getElementById('modal_success3').style.display = 'block';

								}.bind(this), 1500);

								setTimeout(function () {
									let state = this.state;
									//document.getElementById('close_success').style.display = 'block';
									state.progress = 100;
									state.openLoading = false;
									state.openSuccess = true;
									this.setState(state);
								}.bind(this), 3000);
								//fim do efeito fake
								// Enviar formuláro do webhook
								if (localStorage.getItem("type_plan") == 'vip' || localStorage.getItem("type_plan") == 'orto' 
										|| localStorage.getItem("type_plan") == 'digital' ) {
									let forms = {
										nome 		: this.state.financialManager.firstName,
										cpf  		: this.state.financialManager.cpf,
										data_nasc	: this.state.financialManager.dateOfBirth,
										sexo		: this.state.financialManager.gender,
										nome_mae	: this.state.financialManager.motherName,
										celular		: this.state.financialManager.cellPhone,
										email		: this.state.financialManager.email,
										endereco	: this.state.financialManager.address,
										numero		: this.state.financialManager.addressNumber,
										cidade		: this.state.financialManager.nomeCidade,
										bairro		: this.state.districtDescription,
										estado		: this.state.financialManager.nomeEstado,
										cep			: this.state.financialManager.cep
									}; 							  							  
									axios.post("https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTY5MDYzMjA0MzE1MjZiNTUzYzUxMzci_pc", forms)
									.then(() => {
							}).catch(function (erro) {
										console.log(erro)
									}.bind(this)
									);									

								}
								
							})
							.catch(function (error) {
								alert(error);
							});
					}.bind(this), 700);

				})
				.catch(() => {
					let state = this.state;
					state.buttonSubmitForm = true;
					this.setState(state);
					alert('Erro ao salvar a proposta');
				});
			this.setState(state);

		}
		else {
			state.validateForm = false;
			//state.buttonSubmitForm = false;
			this.setState(state);
			this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
		}
	}

	onSuccess(payment) {
		let state = this.state;
		state.payPalApproved = true;
		state.payPalApprovedData = payment;
		this.setState(state);
		this.beforeSubmitForm();
	}

	onCancel(data) {
		alert("Pagamento cancelado! ", data);
	}
	onError(err) {
		alert(err);
	}

	addressNumberMaskChange(event, maskedvalue, floatvalue) {
		let state = this.state;
		state.financialManager.addressNumber = floatvalue;
		this.setState(state);
	}

	//novo design abaixo -- funçoes
	// Seta os valores dos campos do Responsável Financeiro no State
	// ANALISAR VALORES DESCONTOS
	preparaInformacoesCarencia() {
		let state = this.state;

		let codeS4 = state.planCodeS4E ;
	
			if (codeS4 == 1072 || codeS4 == 1100) {
				state.cobertura.linha_1 = 'Urgência e emergência';
				state.cobertura.urgencia = 'Atendimento imediato';
				state.cobertura.linha_2 = 'Dentística, extração simples, radiologia, diagnóstico e odontologia preventiva (limpeza)';
				state.cobertura.dentistica = 'Atendimento imediato';
				state.cobertura.periodontia = '30 DIAS';
				state.cobertura.endodontia = '30 DIAS';
				state.cobertura.cirurgias = '60 DIAS';
	
			}
	
			if ( codeS4 == 1108) {
				state.cobertura.linha_1 = 'Urgência, emergência, consultas e restaurações';
				state.cobertura.urgencia = '1 MINUTO';
				state.cobertura.linha_2 = 'Dentística, extração simples, radiologia, diagnóstico e odontologia preventiva (limpeza)';
				state.cobertura.dentistica = '30 DIAS';			
				state.cobertura.periodontia = '60 DIAS';
				state.cobertura.endodontia = '60 DIAS';
				state.cobertura.cirurgias = '90 DIAS';
	
			}
			if (codeS4 == 1091) {
					state.cobertura.linha_1 = 'Urgência, emergência, consultas e restaurações';
					state.cobertura.urgencia = 'Sem carência';
					state.cobertura.linha_2 = 'Dentística, extração simples, radiologia, diagnóstico e odontologia preventiva (limpeza)';
					state.cobertura.dentistica = '30 DIAS';			
					state.cobertura.periodontia = '60 DIAS';
					state.cobertura.endodontia = '60 DIAS';
					state.cobertura.cirurgias = '90 DIAS';      


			}			
			if (codeS4 == 1068) {
				state.cobertura.linha_1 = "Urgência e emergência"
				state.cobertura.urgencia = '1 MINUTO';
	
				state.cobertura.linha_2 = "Dentística(restauração e extração), radiologia, diagnóstico e odontologia preventiva(limpeza)"
				state.cobertura.dentistica = '1 MINUTO';
				
				state.cobertura.periodontia = '30 DIAS';
				state.cobertura.endodontia = '30 DIAS';
				state.cobertura.cirurgias = '60 DIAS';
	
			}
			if (codeS4 == 1098) {
				state.cobertura.linha_1 = "Urgência e emergência";
				state.cobertura.urgencia = '24HR';
				state.cobertura.linha_2 = "Dentística, radiologia, diagnóstico e odontologia preventiva"
				state.cobertura.dentistica = '24HR';			
				state.cobertura.periodontia = '60 DIAS';
				state.cobertura.endodontia = '30 DIAS';
				state.cobertura.cirurgias = '60 DIAS';
	
			}
			if (codeS4 == 1061 || codeS4 == 1094) {
				state.cobertura.linha_1 = "Urgência e emergência";
				state.cobertura.urgencia = '1 MINUTO';
				state.cobertura.linha_2 = "Dentística(restauração e extração), Radiologia, diagnóstico e odontologia preventiva(limpeza)"
				state.cobertura.dentistica = '30 DIAS';
				state.cobertura.periodontia = '90 DIAS';
				state.cobertura.endodontia = '90 DIAS';
				state.cobertura.cirurgias = '180 DIAS';
			}
	this.setState(state);

	}
	updateValueTotal() {
		let state = this.state;
        // aqui o 
		state.value_total = state.objectPlan.familyTable.value2;
		state.totalNoDescont = (parseFloat(this.state.value_plan.replace(',', '.')) * this.state.dependentsList.length);
		state.totalNoDescont = state.totalNoDescont.toFixed(2).replace('.', ',');

		if (this.state.dependentsList.length == 1) {
			state.value_total = state.objectPlan.familyTable.value2;
			state.valueIndividualPlan = state.objectPlan.familyTable.value2;
			state.valueDescontIndividual = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) - parseFloat(state.objectPlan.familyTable.value2.replace(',', '.'));
			state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
			state.valueDescontTotal = 0;//parseFloat(state.objectPlan.value.replace(',', '.')) - parseFloat(state.objectPlan.value.replace(',', '.'));
			state.valueDescontTotal = 0;//state.valueDescontTotal.toFixed(2).replace('.', ',');
		}
		else if (this.state.dependentsList.length == 2) {
			if (state.objectPlan.familyTable.value3) {
				// depois de justate.value_total = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) + parseFloat(state.objectPlan.value.replace(',', '.')) ;
				state.value_total = parseFloat(state.objectPlan.familyTable.value3.replace(',', '.')) * 2;
				state.value_total = state.value_total.toFixed(2).replace('.', ',');
				state.valueIndividualPlan = state.objectPlan.familyTable.value3;
				state.valueDescontIndividual = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) - parseFloat(state.valueIndividualPlan.replace(',', '.'));
				state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
				state.valueDescontTotal =  parseFloat(state.valueDescontIndividual.replace(',', '.')) * 2;
				state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',') ;
			}
			else {
				state.value_total = parseFloat(state.objectPlan.value.replace(',', '.')) * 2;
				//state.value_total = (parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) * 2 ) + state.objectPlan.value;
				state.value_total = state.value_total.toFixed(2).replace('.', ',');
				state.valueIndividualPlan = state.objectPlan.value;				
				state.valueDescontIndividual = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) - parseFloat(state.valueIndividualPlan.replace(',', '.'));
				state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
				state.valueDescontTotal = 0; //(parseFloat(state.valueDescontIndividual.replace(',', '.')) * 2);
				state.valueDescontTotal = 0; state.valueDescontTotal.toFixed(2).replace('.', ',');
			}
		}
		else if (this.state.dependentsList.length >= 3) {
			if (state.objectPlan.familyTable.value4) {
				state.value_total = parseFloat(state.objectPlan.familyTable.value4.replace(',', '.')) * this.state.dependentsList.length;
				//state.value_total = (parseFloat(state.objectPlan.familyTable.value3.replace(',', '.')) * (this.state.dependentsList.length-1))  + parseFloat(state.objectPlan.value.replace(',', '.')) ;
				state.value_total = state.value_total.toFixed(2).replace('.', ',');
				state.valueIndividualPlan = state.objectPlan.familyTable.value4;
				state.valueDescontIndividual = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) - parseFloat(state.valueIndividualPlan.replace(',', '.')) ;
				//state.valueDescontIndividual = state.valueDescontIndividual * (this.state.dependentsList.length -1);
				state.valueDescontIndividual = state.valueDescontIndividual * (this.state.dependentsList.length );
			//	state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
				state.valueDescontTotal = state.valueDescontIndividual //(parseFloat(state.valueDescontIndividual.replace(',', '.')) * this.state.dependentsList.length);
				state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');
			}
			else {
				state.value_total = parseFloat(state.objectPlan.value.replace(',', '.')) * this.state.dependentsList.length;
				state.value_total = state.value_total.toFixed(2).replace('.', ',');
				state.valueIndividualPlan = state.objectPlan.value;
				state.valueDescontIndividual = parseFloat(state.objectPlan.familyTable.value2.replace(',', '.')) - parseFloat(state.valueIndividualPlan.replace(',', '.'));
				state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
				state.valueDescontTotal = 0; // (parseFloat(state.valueDescontIndividual.replace(',', '.')) * this.state.dependentsList.length);
				state.valueDescontTotal = 0; //state.valueDescontTotal.toFixed(2).replace('.', ',');
			}
		}
		this.setState(state);
		//state.totalNoDescont = state.value_total;
		// Impressão

	}

	setDependentList() {
		let dependent = {}, prop;
		let state = this.state;
		state.resultValidateForm = [];

		//valida o dependente
		this.validateLetters("dp_firstName");//nome completo
		//if (this.state.cpfObligatoryDependent) {
			this.validateCpf("dp_cpf");//cpf
		//}
		this.validateDate("dp_dateOfBirth");//data nasc
		this.validateSelect("dp_maritalStatus");
		this.validateSelect("dp_gender");
		this.validateLetters("dp_motherName");//mae
		this.validateSus("dp_susNumber");//sus
		if (state.resultValidateForm.indexOf(false) == -1) {//se não achar nenhum campo invalido retorna -1
			state.validateForm = true;

			for (prop in this.state.dependent) {
				if ("dp_" + prop != "dp_isHolder")
					dependent[prop] = document.getElementById("dp_" + prop).value;
				else
					dependent[prop] = false;

			}
			let position = null;
			for (let i=0; i<this.state.dependentsList.length; i++){//serve para saber se o cpf ja foi add na lista de dependetes ou eh do titular
				if (document.getElementById("dp_cpf").value === this.state.dependentsList[i].cpf) {
					position = i;
					break;
				}
			}
			if(position != null) {
				if(position == 0)
					alert("CPF informado é do titular. Informe outro CPF válido");
				else
					alert("CPF já adicionado. Favor, informar outro");
				return;
			}

		//	for (let i = 0; i < state.dependentsList.length; i++) {
				//if (document.getElementById("dp_cpf").value === state.dependentsList[i].cpf)
					//alert("CPF igual = " + state.dependentsList[i].cpf);
				//else    
					//alert("CPF diferente = " + state.dependentsList[i].cpf);
					//alert(state.dependentsList[i])
		//	}
			state.dependentsList.push(dependent);
			state.dependent.cpf = "";
			this.setState(state);
			this.setDefaultDependent();
			this.updateValueTotal();//atualiza valor do plano.
		} else {
			state.validateForm = false;
			this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
		}
	}

	setFinancialManager() {
		let keys = Object.keys(this.state.financialManager);
		let state = this.state;

		for (let i = 0; i < keys.length; i++) {
			if (document.getElementById('fm_' + keys[i]) != null)
				state.financialManager[keys[i]] = document.getElementById('fm_' + keys[i]).value;
		}
		this.setState(state);
	}

	validateform() {
		let state = this.state;
		//state.resultValidateForm = [];
		if (this.state.formExtra == null) {
			document.getElementById("alert_questionFinancial").style.display = "block";//dispara o alerta na pergunta do responsavel financeiro
			state.validateForm = false;
			//serve para disparar os alertas para os campos vazios
			this.validateLetters("fm_firstName");//nome completo
			this.validateSus("fm_susNumber");//sus
			this.validateEmail("fm_email");//email
			//this.validateTel("fm_homePhone");//tel
			this.validateCell("fm_cellPhone");//cell
			this.validateLetters("fm_motherName");//mae
			this.validateCpf("fm_cpf");//cpf
			this.validateEmpty("fm_rg");//rg
			this.validateEmpty("fm_rgEmitter");//orgao exp
			this.validateDate("fm_dateOfBirth");//data nasc
			this.validateCep("fm_cep");//cep
			this.validateLetters("fm_address");//rua
			this.validateEmpty("fm_addressNumber");//numero
			this.validateSelect("fm_maritalStatus");
			this.validateSelect("fm_gender");
			this.validateSelect("fm_addressType");
			this.validateSelect("fm_state");
			this.validateSelect("fm_city");
			this.validateSelect("fm_district");
			if (this.props.admin == true) {
				this.validateDate("fm_dateSignatureContract");//data de adesao
			}
		}
		//caso a pergunta nao esteja respondida e o user tente avançar
		if (this.state.formExtra == false) {//validação completa para os campos do responsavel financeiro
			document.getElementById("alert_questionFinancial").style.display = "none";//esconde o alerta na pergunta do responsavel financeiro
			this.validateLetters("fm_firstName");//nome completo
			this.validateSus("fm_susNumber");//sus
			this.validateEmail("fm_email");//email
			//this.validateTel("fm_homePhone");//tel
			this.validateCell("fm_cellPhone");//cell
			this.validateLetters("fm_motherName");//mae
			this.validateCpf("fm_cpf");//cpf
			this.validateEmpty("fm_rg");//rg
			this.validateEmpty("fm_rgEmitter");//orgao exp
			this.validateDate("fm_dateOfBirth");//data nasc
			this.validateCep("fm_cep");//cep
			this.validateLetters("fm_address");//rua
			this.validateEmpty("fm_addressNumber");//numero
			this.validateSelect("fm_maritalStatus");
			this.validateSelect("fm_gender");
			this.validateSelect("fm_addressType");
			this.validateSelect("fm_state");
			this.validateSelect("fm_city");
			this.validateSelect("fm_district");
			if (this.props.admin == true) {
				this.validateDate("fm_dateSignatureContract");//data de adesao
			}
			// Se não achar nenhum campo inválido retorna -1
			if (state.resultValidateForm.indexOf(false) == -1)
				state.validateForm = true;
			else
				state.validateForm = false;
		}
		if (this.state.formExtra == true) {//validação completa para os campos do responsavel financeiro e do titular
			//valida o responsavel financeiro
			this.validateLetters("fm_firstName");//nome completo
			this.validateSus("fm_susNumber");//sus
			this.validateEmail("fm_email");//email
			//this.validateTel("fm_homePhone");//tel
			this.validateCell("fm_cellPhone");//cell
			this.validateLetters("fm_motherName");//mae
			this.validateCpf("fm_cpf");//cpf
			this.validateEmpty("fm_rg");//rg
			this.validateEmpty("fm_rgEmitter");//orgao exp
			this.validateDate("fm_dateOfBirth");//data nasc
			this.validateCep("fm_cep");//cep
			this.validateLetters("fm_address");//rua
			this.validateEmpty("fm_addressNumber");//numero
			this.validateSelect("fm_maritalStatus");
			this.validateSelect("fm_gender");
			this.validateSelect("fm_addressType");
			this.validateSelect("fm_state");
			this.validateSelect("fm_city");
			this.validateSelect("fm_district");
			if (this.props.admin == true) {
				this.validateDate("fm_dateSignatureContract");//data de adesao
			}
			//valida o titular -> 1° dependente
			this.validateLetters("hd_firstName");//nome completo
			this.validateCpf("hd_cpf");//cpf
			this.validateDate("hd_dateOfBirth");//data nasc
			this.validateSelect("hd_maritalStatus");
			this.validateSelect("hd_gender");
			this.validateLetters("hd_motherName");//mae
			this.validateSus("hd_susNumber");//sus

			//se não achar nenhum campo invalido retorna -1
			if (state.resultValidateForm.indexOf(false) == -1)
				state.validateForm = true;
			else
				state.validateForm = false;
		}
		this.setState(state);
	}

	onChangeState(id) {
		let state = this.state, prop;
		for (prop in this.state.financialManager) {
			if (id == "fm_" + prop) {
				state.financialManager[prop] = document.getElementById(id).value.toUpperCase();
			}
		}
		for (prop in this.state.holder) {
			if (id == "hd_" + prop) {
				state.holder[prop] = document.getElementById(id).value.toUpperCase();
			}
		}
		for (prop in this.state.dependent) {
			if (id == "dp_" + prop) {
				state.dependent[prop] = document.getElementById(id).value.toUpperCase();
				let value = document.getElementById(id).value.toUpperCase();
				document.getElementById(id).value = value;
			}
		}
		for (prop in this.state.financialManager) {
			if (id == "fm_" + prop) {
				state.financialManager[prop] = document.getElementById(id).value.toUpperCase();
				let value = document.getElementById(id).value.toUpperCase();
				document.getElementById(id).value = value;
			}
		}			

		this.setState(state);
	}

	onChangeStateBuscaCep(id) {
		let state = this.state, prop;
		console.log(prop);
		for (prop in this.state.financialManager) {
			if (id == "buscacep") {
				this.state.financialManager.cep = document.getElementById(id).value.toUpperCase();
				this.setState(state);
			}
		}
	}

	formExtraOn() {
		document.getElementById("alert_questionFinancial").style.display = 'none';
		let state = this.state;
		state.formExtra = false;
		this.setState(state);
	}

	formExtraOff() {
		document.getElementById("alert_questionFinancial").style.display = 'none';
		let state = this.state, prop;
		state.formExtra = true;
		this.handlePriorizarCadastroOpen();
		for (prop in this.state.holder) {
			state.holder[prop] = "";
		}
		this.setState(state);
	}

	phasesFormNext(index) {
		let state = this.state;
		state.phasesForm = index;
		this.setState(state);
		document.getElementById('form').scrollIntoView();
	}

	back_holder() {//remove o titular quando o botão voltar da tela de dependentes eh clicado
		let state = this.state;
		state.dependentsList.shift();
		state.financialManager.dateOfBirth = state.dataNascimento
		this.setState(state);
		this.phasesFormNext(1);
	}

	back_dependents() {//remove o titular quando o botão voltar da tela de dependentes eh clicado
		let state = this.state;
		state.noDependents = false;//torna falso para que o modal, de plano sem dependentes, seja exibido.
		state.resumeFinal = false;//evita q o resumo final seja monstrado no resumo parcial, caso o usuario volte a tela
		this.setState(state);		// MUDOU AQUI
		this.phasesFormNext(2);
	}

	back_docs() {//remove o titular quando o botão voltar da tela de dependentes eh clicado
		this.phasesFormNext(2);
	}

	validarAlertaBoleto() {

		if (this.state.stateMASLZ && this.state.payment_plan == "false" && this.state.alertBoleto == false) {
			this.setState({ modalBoleto: true });
			return false;
		} else {
			return true;
		}

	}
	validaEndereco () {
		let  resultado = true;

		if ((this.state.financialManager.district == undefined || this.state.financialManager.district == null || this.state.financialManager.district == "")
		) {
			document.getElementById("alert_fm_district").style.display = "block"
			resultado = false;
		} else {
			document.getElementById("alert_fm_district").style.display = "none"
		}
		if ((this.state.financialManager.city == undefined || this.state.financialManager.city == null ||  this.state.financialManager.city == "")
		) {
			document.getElementById("alert_fm_city").style.display = "block"
			resultado = false;
		} else {
			document.getElementById("alert_fm_city").style.display = "none"
		}
		return resultado;

	}
    // FASE 2
	form_phases2() {
		this.state.dataNascimento = this.state.financialManager.dateOfBirth;
		this.state.idEndereco = this.state.financialManager.district;
		this.state.idCidade = this.state.financialManager.city;
			
		if (!this.validaEndereco()) {
			this.onOpenModal();
			return;
		}


		this.validateform();
		this.setFinancialManager();
		let check = true;
		check = this.validarAlertaBoleto();

		if (this.state.validateForm && check) {//verifica se o state de controle de validação esta válido
			// Add titular na lista de dependentes
			this.addHolderListDependent();
			//avança para proxima etapa do form
			this.phasesFormNext(2);
		} else {
			this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
		}
		this.updateValueTotal();
	}
	// fase 3
	// form_phases3() {

	// 	// checkSLZ Payment    

	// 	if (this.state.dependentsList.length == 1) {
	// 		this.onOpenModalNoDependent();
	// 	} else {
	// 		this.onOpenModalPhases();
	// 	}


	// }

	phases3NoDependentModal() {
		let state = this.state;
		state.noDependents = true;
		this.setState(state);
		this.phasesFormNext(3);
		this.onCloseModalPhases();
		this.onCloseModalNoDependent();
	}
    // Antiga faase 4
	form_phases3() {
		// seta valores default para SLZ
		if (this.state.stateMASLZ) {
			this.state.combineWithSalesman = true;
			this.state.buttonPagSeguro = false;
			this.state.buttonPayPal = false;
			this.setState(this.state);
		}


		//verifica se o vendedor tem dados do pagseguro
		if (this.state.salesmanPagSeguroEmail == undefined || this.state.salesmanPagSeguroEmail == '' || this.state.salesmanPagSeguroToken == '' || this.state.salesmanPagSeguroToken == undefined) {
			let state = this.state;
			state.salesmanPagSeguro = false;
			this.setState(state);
		} else {
			let state = this.state;
			state.salesmanPagSeguro = true;
			this.setState(state);
		}

		// Atualiza Próximas Mensalidades no Boleto Bancário
		if (localStorage.getItem('payment_plan') == 'false') {
			let dataSubmit = {
				city: sessionStorage.getItem("select_cities"),
				dayInclusion: this.state.currentTimeServer.day,
				type: 'BOLETO'
			};
			axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
				.then((response) => {
					this.dateValidity(response.data.validity);
				})
				.catch(function () {
					alert('Erro ao buscar Forma de Pagamento');
				});
		}
		if (this.props.admin == true)
			this.dateValiditySalesman();

		//dados para pagseguro
		// Paulo
		let dataPayment = {
			itemAmount1: "", //parseFloat(this.state.value_total.replace(',', '.')).toFixed(2),
			itemDescription1: 'Plano ' + this.state.type_plan,
			salesmanId: localStorage.getItem('dental_v_i'),
		};
		let state = this.state;
		state.dataPagseguroPayment = dataPayment;
		state.resultValidateForm = [];
		this.setState(state);
		//valida a tela de documentos
		this.validateEmpty("doc_cpf");//doc cpf
		this.validateEmpty("doc_rg");//doc rg
		this.validateEmpty("doc_address");//doc comp resid

		if (state.portability == true)
			this.validateEmpty("doc_declarationPortability");//doc portabilidade

		if (localStorage.getItem('payment_plan') == 'true')
			this.validateEmpty("doc_cardCredit");//doc comp resid

		//	this.validateCheckbox("checkAccession1");//termo1
		//this.validateCheckbox("checkAccession13");//termo3

		if (state.resultValidateForm.indexOf(false) == -1) {
			this.phasesFormNext(3);
			/* if (this.state.payment_plan === "true") {//tela de cartao de credito
 
			 }else{//tela de boleto
				 //boleto
			 }*/
		}
		else {
			if (this.state.payment_plan === "true") {//tela de cartao de credito
				this.onOpenModal();//modal de alerta para campos vazios ou dados invalidos!
			} else {//tela de boleto
				//modal do boleto
			}
		}

	}

	//modais
	onOpenModal() {
		let state = this.state;
		state.open = true;
		this.setState(state);
	}

	onCloseModal() {
		let state = this.state;
		state.open = false;
		this.setState(state);
	}

	onCloseModalCep() {
		let state = this.state;
		state.openCep = false;
		this.setState(state);
	}

	onOpenModalNoDependent() {
		this.setState({ modalNoDependent: true });
	}

	onCloseModalNoDependent() {
		this.setState({ modalNoDependent: false });
	}
	onCloseModalValidateCard() {
		this.setState({ alertCardAvaliable: false });
	}
	onOpenModalValidateCard() {
		this.setState({ alertCardAvaliable: true });
	}
	onOpenModalPhasesResume() {
		this.updateValueTotal();
		this.preparaInformacoesCarencia();
		this.setState({ modalPhasesResume: true, modalPhases: false });
	}

	onCloseModalPhasesResume() {
		this.setState({ modalPhasesResume: false });
	}

	portabilityOn() {
		let state = this.state;
		state.portability = true;
		this.setState(state);
	}

	portabilityOff() {
		let state = this.state;
		state.portability = false;
		this.setState(state);
	}

	inputToUpperCase(idInput) {
		document.getElementById(idInput).value = document.getElementById(idInput).value.toUpperCase();
	}

	redirectPlans() {
		browserHistory.push("/foryouandyourfamily");
	}

	setAlertBoleto() {
		if (this.state.alertBoleto == false) {
			this.setState({ alertBoleto: true });
		} else {
			this.setState({ alertBoleto: false });
		}
	}


	closeAlertBoleto() {
		this.setState({ modalBoleto: false });
	}

	render() {

		return (
			<div>
				{this.props.admin == false ? (

					<div>

						<Container>
							<Row>
								<Col className="text_center">
									<Stepper activeStep={this.state.phasesForm - 1} >
										<Step>
											<StepLabel className='dados' ></StepLabel>
											{/* <StepLabel className='dados' >DADOS PESSOAIS</StepLabel> */}
										</Step>
										<Step>
											<StepLabel className='dados' ></StepLabel>
											{/* <StepLabel className='dados' >DEPENSENTES</StepLabel> */}
										</Step>
										<Step>
											<StepLabel className='dados' ></StepLabel>
											{/* <StepLabel className='dados' >FINANCEIRO</StepLabel> */}
										</Step>										
										{/* <Step>
											<StepLabel className='dados' ></StepLabel> */}
											{/* <StepLabel className='dados' >DOCUMENTOS</StepLabel> */}
										{/* </Step> */}
	
									</Stepper>
								</Col>
							</Row>
						</Container>


					</div>
				) : ('')}

				<Form id="form">
					<input id="imagem_cpf" type="hidden" />
					<input id="imagem_rg" type="hidden" />
					<input id="imagem_rg2" type="hidden" />
					<input id="imagem_address" type="hidden" />
					<input id="imagem_cardCredit" type="hidden" />
					<input id="imagem_physicalContract" type="hidden" />
					<input id="imagem_adtive" type="hidden" />
					<input id="imagem_declarationPortability" type="hidden" />
					<div>
						{/** FASE 1*/}
						{this.state.phasesForm == 1 ? (
							<div>

								<Container className="form_container2">
									<Container className="form_container_internal">

										{this.state.selectSalesMan ?
											<Row style={{ marginTop: '22px', marginLeft: '-4px' }}>
												<Col className="col_layout" xs="2" sm="2" md="1" lg="1">
													<Avatar
														src='assets/images/panel/user.png'
														size={60}
														style={this.styles.avatar.icon}
													/>
												</Col>
												<Col className="col_layout" xs="10" sm="3" md="4" lg="4" style={{ marginBottom: '28px' }}>
													<div style={{ marginLeft: '18px' }}>
														<h6>Seu Vendedor:</h6>
													</div>
													<p className='text_plans_family' style={{ fontSize: '11px', marginLeft: '20px', marginTop: '4px', textAlign: 'left' }}>
														{this.state.salesManName}
													</p>
												</Col>

												<Col className="col_layout" xs="10" sm="3" md="4" lg="4">
													<img onClick={() => window.open("https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fplanodentalcenter.com.br%2F&hl=pt_BR", "_blank")} style={{ width: '180px', marginTop: '-4px' }} src={urlBase.client + "assets/images2/google.jpg"} />
												</Col>

											</Row> : null}

										{!this.state.selectSalesMan ?
											// <Row>
											//     <Col className="col_layout" xs="10" sm="3" md="4" lg="4">
											//     <img onClick={() => window.open("https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fplanodentalcenter.com.br%2F&hl=pt_BR", "_blank")} style={{width:'200px'}} src={urlBase.client + "assets/images2/google.jpg"} />
											//     </Col> 
											//     <Col className="col_layout" xs="10" sm="3" md="4" lg="4">
											//       <div className="div_text_footer">
											//         <p  className="text_payments">PAGAMENTOS ACEITOS</p>
											//         <p className="text_footer3">
											//           <img className='bandeiras' src={urlBase.client + "assets/images2/pagamentos.png"} />
											//         </p>
											//       </div>
											//     </Col>                       
											// </Row>
											''
											: null}

										<hr />

										{/************* PRIMEIRA etapa do formulário *******************/}
										<Row className="form_p_client" style={{ justifyContent: 'space-between', margin: 'auto' }}>
											<p className="form_p_client">Responsável Financeiro</p>
											<div>
												{
													localStorage.getItem('show_card_flags') == "true" ? (
														<p className="text_footer3">
															<img style={{ width: '50%', margin: 'auto', display: 'block' }} className='bandeiras' src={urlBase.client + "assets/images2/cartoes2.png"} />
														</p>
													) : (
														<p className="text_footer3">
															<img style={{ width: '50%', margin: '2%', display: 'block', marginLeft: '50%' }} className='bandeiras' src={urlBase.client + "assets/images2/boletoPag.png"} />
														</p>
													)
												}
											</div>
										</Row>
										{
											localStorage.getItem('type_plan') == 'digitalLLL' ? (
												<div>
													<p className="form_p_title">Portabilidade?</p>
													{
														this.state.portability == true ? (
															<div>
																<div style={{ height: '20px' }}></div>
																<Button className="form_extra_s_true" onClick={this.portabilityOn.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n" onClick={this.portabilityOff.bind(this)}>NÃO</Button>
															</div>
														) : (
															<div>
																<div style={{ height: '20px' }}></div>
																<Button className="form_extra_s" onClick={this.portabilityOn.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n_false" onClick={this.portabilityOff.bind(this)}>NÃO</Button>
															</div>
														)
													}
												</div>
											) : ('')
										}

										<p className="form_p_title">Dados Pessoais</p>
										<p className='alert-info'>Atenção os campos marcados com * são obrigatórios</p>
										<Row>
											<Col xs="12" sm="6" md="3" lg="3">
												<FormGroup className="form_group">

													<i id="loading_cpf"
														style={{ display: 'none', marginLeft: 5, width: 16 }}
														className="fa fa-spinner fa-spin">
														&nbsp;
													</i>
													<InputMask
														id="fm_cpf"
														className='form-control'
														placeholder='*CPF'
														mask="999.999.999-99"
														maskChar=" "
														type="tel"
														value={this.state.financialManager.cpf}
														onBlur={this.validateCpf.bind(this, "fm_cpf")}
														onChange={this.onChangeState.bind(this, "fm_cpf")}
													/>
													<Alert id="alert_fm_cpf">*CPF inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="12" md="9" lg="9">
												<FormGroup className="form_group">

													<Input

														id="fm_firstName"
														placeholder='*Nome Completo'
														type="text"
														name="fm_firstName" required
														value={this.state.financialManager.firstName}
														onBlur={this.validateLetters.bind(this, "fm_firstName")}
														onChange={this.onChangeState.bind(this, "fm_firstName")}
													/>
													<Input id="fm_lastName" type="hidden" />
													<Alert id="alert_fm_firstName">*Campo inválido!</Alert>
												</FormGroup>
											</Col>

											<Col xs="12" sm="6" md="6" lg="4">
												{
													this.props.admin == false ? (
														<FormGroup className="form_group">
															<Input id="fm_email"
																className='form-control'
																placeholder='*Email'
																type="email" name="fm_email"
																value={this.state.financialManager.email}
																onBlur={this.validateEmail.bind(this, "fm_email")}
																onChange={this.onChangeState.bind(this, "fm_email")}
															/>
															<Alert id="alert_fm_email">*Email inválido!</Alert>
														</FormGroup>
													) : (
														<FormGroup className="form_group">
															<Input id="fm_email" className="input_form" type="email"
																name="fm_email"
																value={this.state.financialManager.email}
																onBlur={this.validateEmail.bind(this, "fm_email")}
																onChange={this.onChangeState.bind(this, "fm_email")}
															/>
															<Alert id="alert_fm_email">*Email inválido!</Alert>
														</FormGroup>
													)
												}
											</Col>

											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="form_group">
													<InputMask
														id="fm_cellPhone"
														className='ant-input form-control'
														placeholder='*Celular 1'
														mask="(99) \9 9999-9999"
														maskChar=" "
														type="tel"
														value={this.state.financialManager.cellPhone}
														onBlur={this.validateCell.bind(this, "fm_cellPhone")}
														onChange={this.onChangeState.bind(this, "fm_cellPhone")}
													/>
													<Alert id="alert_fm_cellPhone">*Campo inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="form_group">
													<InputMask
														id="fm_cellPhone2"
														className="ant-input form-control"
														placeholder='Celular 2'
														mask="(99) \9 9999-9999"
														maskChar=" "
														type="tel"
														value={this.state.financialManager.cellPhone2}
														onBlur={this.validateCell2.bind(this, "fm_cellPhone2")}
														onChange={this.onChangeState.bind(this, "fm_cellPhone2")}
													/>
													<Alert id="alert_fm_cellPhone2">*Campo inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="2">
												<FormGroup className="form_group">
													{/* <Label className="label_form">*RG:</Label> */}
													<Input name="fm_rg" id="fm_rg"
														className='form-control'
														placeholder='*RG'
														type="tel" required
														value={this.state.financialManager.rg}
														//onBlur={this.validateEmpty.bind(this, "fm_rg")}
														onChange={this.onChangeState.bind(this, "fm_rg")}
													/>
													<Alert id="alert_fm_rg">*Rg obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="form_group">
													<Input id="fm_rgEmitter"
														className='form-control'
														placeholder='*Orgão Expedidor'
														type="text" name="fm_rgEmitter" required
														value={this.state.financialManager.rgEmitter}
														onBlur={this.validateEmpty.bind(this, "fm_rgEmitter")}
														onChange={this.onChangeState.bind(this, "fm_rgEmitter")}
													/>
													<Alert id="alert_fm_rgEmitter">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="form_group">
													<InputMask
														id="fm_dateOfBirth"
														className='ant-input form-control'
														placeholder='*Data de Nasc'
														mask="99/99/9999"
														maskChar=" "
														type="tel"
														value={this.state.financialManager.dateOfBirth}
														//onBlur={this.validateDate.bind(this, "fm_dateOfBirth"),this.checkAge.bind(this, "fm_dateOfBirth")}
														onBlur={this.validateDateAndAge.bind(this, "fm_dateOfBirth")}
														onChange={this.onChangeState.bind(this, "fm_dateOfBirth")}
													/>
													<Alert id="alert_fm_dateOfBirth">*Data inválida!</Alert>
													<Alert id="alert_fm_dateOfBirth_18">*Necessário idade maior que 18!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="4">
												<FormGroup className="form_group">
													<Input id="fm_motherName"
														className='ant-input form-control'
														placeholder='*Nome da Mãe'
														type="text" name="fm_motherName"
														value={this.state.financialManager.motherName}
														onBlur={this.validateLetters.bind(this, "fm_motherName")}
														onChange={this.onChangeState.bind(this, "fm_motherName")}
													/>
													<Alert id="alert_fm_motherName">*Campo inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="5" lg="3">
												<FormGroup className="arrow_form form_group">
													{/* <Label className="label_form">*Estado Civil:</Label> */}
													<Input id="fm_maritalStatus"

														className='form-control'
														type="select"
														name="fm_maritalStatus" required
														value={this.state.financialManager.maritalStatus}
														onChange={this.onChangeState.bind(this, "fm_maritalStatus")}
														onBlur={this.validateSelect.bind(this, "fm_maritalStatus")}
													>
														<option value="-1">*Estado Civil</option>
														<option value="SOLTEIRO">SOLTEIRO</option>
														<option value="CASADO">CASADO</option>
														<option value="VIÚVO">VIÚVO</option>
														<option value="SEPARADO">SEPARADO</option>
														<option value="DIVORCIADO">DIVORCIADO</option>
														<option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
													</Input>
													<Alert id="alert_fm_maritalStatus">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="2" md="2" lg="2">
												<FormGroup className="arrow_form form_group">
													{/* <Label className="label_form">*Sexo:</Label> */}
													<Input id="fm_gender"
														className='form-control'
														type="select" name="select" required
														value={this.state.financialManager.gender}
														onChange={this.onChangeState.bind(this, "fm_gender")}
														onBlur={this.validateSelect.bind(this, "fm_gender")}
													>
														<option value="-1">*Sexo</option>
														<option value="1">M</option>
														<option value="0">F</option>
													</Input>
													<Alert id="alert_fm_gender">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="5" md="5" lg="3">
												<FormGroup className="form_group">
													{/* <Label className="label_form">Cartão do SUS:</Label> */}
													<Input id="fm_susNumber"
														className='form-control'
														placeholder='Cartão do SUS'
														type="tel" name="fm_susNumber"
														value={this.state.financialManager.susNumber}
														onBlur={this.validateSus.bind(this, "fm_susNumber")}
														onChange={this.onChangeState.bind(this, "fm_susNumber")}
													/>
													<Alert id="alert_fm_susNumber">*O número do SUS tem 15 dígitos!</Alert>
												</FormGroup>
											</Col>
										</Row>
										<p className="form_p_title">Endereço</p>
										<Row>
											<Col xs="12" sm="4" md="6" lg="2">
												<FormGroup className="form_group">
													{/* <Label className="label_form">*CEP: </Label> */}
													<i id="loading_address"
														style={{ display: 'none', marginLeft: 5, width: 16 }}
														className="fa fa-spinner fa-spin">
														&nbsp;
													</i>
													<InputMask
														id="fm_cep"
														className='ant-input form-control'
														placeholder='*CEP'
														mask="99.999-999"
														maskChar=" "
														type="tel"
														value={this.state.financialManager.cep}
														onBlur={this.getAddress.bind(this)}
														onChange={this.onChangeState.bind(this, "fm_cep")}
													/>
													<Alert id="alert_fm_cep">*Cep inválido!</Alert>
													{/*<Input className="input_form" type="text" id="fm_cep"
														onBlur={this.getAddress.bind(this, 'financialManager')} />*/}
												</FormGroup>
											</Col>
											<Col xs="12" sm="4" md="6" lg="3">
												<FormGroup className="arrow_form form_group">
													<Input id="fm_addressType"
														type="select" name="select"
														className='form-control'
														placeholder='*Logradouro'
														value={this.state.financialManager.addressType}
														onChange={this.onChangeState.bind(this, "fm_addressType")}
														onBlur={this.validateSelect.bind(this, "fm_addressType")}>
														<option value={-1}>*Escolha um tipo</option>
														{this.state.addressTypeList.map(item =>
															<option key={item.Id} value={item.Id}>{item.Nome}</option>
														)}
													</Input>
													<Alert id="alert_fm_addressType">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="4" md="6" lg="5">
												<FormGroup className="form_group">
													<Input id="fm_address"
														className='form-control'
														placeholder='*Rua'
														type="text"
														name="fm_address"
														value={this.state.financialManager.address}
														onBlur={this.validateLetters.bind(this, "fm_address")}
														onChange={this.onChangeState.bind(this, "fm_address")}
													/>
													<Alert id="alert_fm_address">*Campo inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="2" md="3" lg="1">
												<FormGroup className="form_group">
													<Input
														id="fm_addressNumber"
														type="tel"
														// precision="0"
														className="form-control"
														placeholder='*Número:'

														// decimalSeparator=""
														// thousandSeparator=""
														name="fm_addressNumber"
														onBlur={this.validateEmpty.bind(this, "fm_addressNumber")}
														value={this.state.financialManager.addressNumber}
														onChange={this.onChangeState.bind(this, "fm_addressNumber")}
													// prefix=""
													/>
													<Alert id="alert_fm_addressNumber">*Campo inválido!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="3" md="3" lg="1">
												<FormGroup className="arrow_form form_group">
												<SelectField
													id="fm_state"
													// hintText="UF"
													// floatingLabelText="UF *"
													underlineStyle={{ display: 'none' }}
													className="input_style form-control"
													name="fm_state"
													value={this.state.financialManager.state}
													disabled
													onChange={this.handleChangeSelectField.bind(this,"fm_state")}
												>
														<MenuItem value={""} label="UF *" primaryText="UF *"/>
													{this.state.stateList.map(item =>
													<MenuItem key={item.Id} value={item.Id} label={item.Sigla}  primaryText={item.Sigla} />
													)}
												</SelectField>
													<Alert id="alert_fm_state">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="7" md="6" lg="4">
												<FormGroup className="form_group">
													<Input id="fm_addressComplement"
														className="form-control"
														placeholder='Complemento'
														type="text"
														onChange={this.onChangeState.bind(this, "fm_addressComplement")}
														value={this.state.financialManager.addressComplement}
													/>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="arrow_form form_group">
														<SelectField
															id="fm_city"
															// hintText="UF"
															// floatingLabelText="UF *"
															underlineStyle={{ display: 'none' }}
															className="input_style form-control"
															name="fm_city"
															value={this.state.financialManager.city}
															onChange={this.handleChangeSelectField.bind(this,"fm_city")}
														>
																<MenuItem value={""} label="*Cidade" primaryText="Cidade *"/>
															{this.state.cityList.map(item =>
															<MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
															)}
														</SelectField>													
				
													<Alert id="alert_fm_city">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											<Col xs="12" sm="6" md="6" lg="3">
												<FormGroup className="arrow_form form_group">

												<SelectField
													id="fm_district"
													// hintText="BAIRRO"
													// floatingLabelText="BAIRRO *"
													// className="input_style"
													placeholder='BAIRRO *'
													underlineStyle={{ display: 'none' }}
													className="input_style form-control"
													name="fm_district"
													value={this.state.financialManager.district}
													
													onChange={this.handleChangeSelectField.bind(this,"fm_district")}
												>
														<MenuItem value={""} label="BAIRRO *" primaryText="BAIRRO *"/>
													{this.state.districtListFinancialManager.map(item =>
													<MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
													)}
												</SelectField> 													
						
													<Alert id="alert_fm_district">*Campo obrigatório!</Alert>
												</FormGroup>
											</Col>
											{
												this.props.admin == true ? (
													<Col xs="12" sm="5" md="5" lg="3">
														<FormGroup className="form_group">
															<Label className="label_form">*Data de Adesão:</Label>
															<Input
																id="fm_dateSignatureContract"
																className="form-control"
																type="date"
																name="dateSignatureContract"
																title="Use DD/MM/AAAA"
																value={this.state.dateSignatureContract}
																onChange={this.onChangeDateSignatureContract.bind(this)}
																onBlur={this.validateDate.bind(this, "fm_dateSignatureContract")}
															/>
															<Alert id="alert_fm_dateSignatureContract">*Data inválida!</Alert>
														</FormGroup>
													</Col>
												) : ('')
											}
										</Row>


									{/* 	{this.state.stateMASLZ && this.state.payment_plan == "false" ? ( */}
									{this.state.payment_plan == "false" ? (
											<Row style={{ marginTop: 20 }}>
												<Col md="12">
													<Alert color="warning">
														IMPORTANTE: O documento para pagamento ( Boleto) será enviado exclusivamente por SMS, EMAIL OU APLICATIVO.  NÃO enviamos BOLETO para a residência ou qualquer outro endereço.
													</Alert>
													<label className="form_radio_accession" >
														<input
															id="checkBoleto"
															className="style_check" type="checkbox"
															name="checkBoleto"
															defaultChecked={this.state.alertBoleto}
															onClick={this.setAlertBoleto.bind(this)}
														/>
														<span className="red_text">ESTOU CIENTE</span> SOBRE O NÃO ENVIO DE BOLETOS PARA MINHA RESIDÊNCIA!
														<Alert id="alert_checkAccession1">*É necessário aceitar!</Alert>
													</label>
												</Col>
											</Row>
										) : ('')}

										<Row
												// className={classNames("hidde_session", {
												//   active: !this.holderAvaliable
												// })}
										>
											<Col lg="12">
												<div className="form_div_titular">
													<p className="form_p_title">TITULAR DO PLANO</p>
													{this.state.formExtra == false ? (
														<Row style={{ marginLeft: 0, marginBottom: 20 }}>
															<div className="form_titular">O RESPONSÁVEL FINANCEIRO VAI PARTICIPAR COMO TITULAR DO PLANO?</div>
															<Button className="form_extra_s_true" onClick={this.formExtraOn.bind(this)}>SIM</Button>{''}
															<Button className="form_extra_n" onClick={this.formExtraOff.bind(this)}>NÃO</Button>{''}
														</Row>
													) : (
														this.state.formExtra == true ? (
															<Row style={{ marginLeft: 0, marginBottom: 20 }}>
																<div className="form_titular">O RESPONSÁVEL FINANCEIRO VAI PARTICIPAR COMO TITULAR DO PLANO?</div>
																<Button className="form_extra_s" onClick={this.formExtraOn.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n_false" onClick={this.formExtraOff.bind(this)}>NÃO</Button>{''}
															</Row>
														) : (
															<Row style={{ marginLeft: 0, marginBottom: 20 }}>
																<div className="form_titular">O RESPONSÁVEL FINANCEIRO VAI PARTICIPAR COMO TITULAR DO PLANO?</div>
																<Button className="form_extra_s" onClick={this.formExtraOn.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n" onClick={this.formExtraOff.bind(this)}>NÃO</Button>{''}
															</Row>
														)
													)}
													<Alert id="alert_questionFinancial">Escolha uma opção!</Alert>
												</div>
											</Col>
										</Row>
										{/** Form extra, se o responsavel NAO participar como titular**/}
										{this.state.formExtra == true ? (
											<div>
												<p className="form_p_title">DADOS DO TITULAR</p>
												<Row>
													<Col xs="12" sm="12" md="6" lg="6">
														<FormGroup className="form_group">
															<Input id="hd_firstName"
																className="form-control"
																placeholder='*Nome Completo'
																type="text"
																value={this.state.holder.firstName}
																onBlur={this.validateLetters.bind(this, "hd_firstName")}
																onChange={this.onChangeState.bind(this, "hd_firstName")}
															/>
															<Input id="hd_lastName" className="form-control" type="hidden" />
															<Alert id="alert_hd_firstName">*Campo inválido!</Alert>
														</FormGroup>
													</Col>
													<Col xs="12" sm="6" md="6" lg="3">
														<FormGroup className="form_group">
															{/* <Label className="label_form">*CPF:</Label> */}
															<InputMask
																id="hd_cpf"
																className="form-control ant-input"
																placeholder='*CPF'
																mask="999.999.999-99"
																maskChar=" "
																type="cel"
																value={this.state.holder.cpf}
																onBlur={this.validateCpf.bind(this, "hd_cpf")}
																onChange={this.onChangeState.bind(this, "hd_cpf")}
															/>
															<Alert id="alert_hd_cpf">*Cpf inválido!</Alert>
															<Alert id="alert_hd_cpf">*Cpf Obrigatório</Alert>
															{/*<Input id="hd_cpf" className="form-control" type="number" />*/}
														</FormGroup>
													</Col>
													<Col xs="12" sm="6" md="6" lg="3">
														<FormGroup className="form_group">
															{/* <Label className="label_form">*Data de Nasc.:</Label> */}
															<InputMask
																id="hd_dateOfBirth"
																placeholder='*Data de Nasc'
																className="ant-input form-control"
																mask="99/99/9999"
																maskChar=" "
																type="tel"
																value={this.state.holder.dateOfBirth}
																onBlur={this.validateDatePlan.bind(this, "hd_dateOfBirth")}
																onChange={this.onChangeState.bind(this, "hd_dateOfBirth")}
															/>
															{/* <Input id="hd_dateOfBirth" className="form-control" type="date"
															value={this.state.holder.dateOfBirth}
															onBlur={this.validateDate.bind(this, "hd_dateOfBirth")}
															onChange={this.onChangeState.bind(this, "hd_dateOfBirth")}
														/> */}
															<Alert id="alert_hd_dateOfBirth">*Data inválida!</Alert>
														</FormGroup>
													</Col>
													<Col xs="12" sm="8" md="6" lg="3">
														<FormGroup className="arrow_form form_group">
															<Input
																id="hd_maritalStatus"
																className="form-control"
																type="select" name="select"
																value={this.state.holder.maritalStatus}
																onChange={this.onChangeState.bind(this, "hd_maritalStatus")}
																onBlur={this.validateSelect.bind(this, "hd_maritalStatus")}
															>
																<option value="-1">*Estado Civil</option>
																<option value="SOLTEIRO">SOLTEIRO</option>
																<option value="CASADO">CASADO</option>
																<option value="VIÚVO">VIÚVO</option>
																<option value="SEPARADO">SEPARADO</option>
																<option value="DIVORCIADO">DIVORCIADO</option>
																<option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
															</Input>
															<Alert id="alert_hd_maritalStatus">*Campo obrigatório!</Alert>
														</FormGroup>
													</Col>
													<Col xs="12" sm="4" md="3" lg="3">
														<FormGroup className="arrow_form form_group">
															<Input
																id="hd_gender"
																className="form-control"
																type="select"
																name="select"
																value={this.state.holder.gender}
																onChange={this.onChangeState.bind(this, "hd_gender")}
																onBlur={this.validateSelect.bind(this, "hd_gender")}>

																<option value="-1">*Sexo</option>
																<option value="1">M</option>
																<option value="0">F</option>
															</Input>
															<Alert id="alert_hd_gender">*Campo obrigatório!</Alert>
														</FormGroup>
													</Col>
													<Col xs="12" sm="12" md="5" lg="4">
														<FormGroup className="form_group">
															<Input id="hd_motherName"
																placeholder='*Nome da Mãe'
																className="form-control" type="text"
																value={this.state.holder.motherName}
																onBlur={this.validateLetters.bind(this, "hd_motherName")}
																onChange={this.onChangeState.bind(this, "hd_motherName")}
															/>
															<Alert id="alert_hd_motherName">*Campo inválido!</Alert>
														</FormGroup>
													</Col>
													<Col xs="12" sm="6" md="5" lg="3">
														<FormGroup className="form_group">
															<Input id="hd_susNumber"
																placeholder='Cartão do SUS'
																className="form-control"
																type="tel"
																value={this.state.holder.susNumber}
																onBlur={this.validateSus.bind(this, "hd_susNumber")}
																onChange={this.onChangeState.bind(this, "hd_susNumber")}
															/>
															<Alert id="alert_hd_susNumber">*O número do SUS tem 15 dígitos!</Alert>
														</FormGroup>
													</Col>
												</Row>
												{/* <Alert className="alerta_dep_cpf" color="warning">
												*Campo Obrigatório!
											</Alert> */}
											</div>
										) : ("")}

										{/** Valor do plano e botão avançar **/}
										<div style={{ textAlign: "center" }}>
											<p className="form_p_title_plan">VALOR DO PLANO</p>
											<div className="form_value_top">
												<p>PLANO DENTAL {this.state.type_plan} R$ {this.state.value_plan}</p>
											</div>
											<div className="form_value_bottom">
												<p>TOTAL DO PLANO R$ {this.state.value_plan}</p>
											</div>
										</div>
										<div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>

											<Button 
												onClick={this.form_phases2.bind(this)} 
												style={{
												...Styles.buttonSuccess,
												fontWeight: 'bold',
												textTransform: 'none'
												}} >
												AVANÇAR
											</Button>{''}											

										</div>
									</Container>
								</Container>
							</div>
						) : ("")}
						{/** FASE 2*/}
						{this.state.phasesForm == 2 ? (
							<div>
								{/* <div id="form_img2">&nbsp;</div> */}
								{/* <Container className="container_text_img">
									<Row>
										<Col className="text_center">
											<p className="form_img_text">Dados Pessoais</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text cor_phases">Dependentes</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text">Documentos</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text">Financeiro</p>
										</Col>
									</Row>
								</Container> */}
								<Container className="form_container2">
									<Container className="form_container_internal">
										{/************** SEGUNDA etapa do formulario - Dependentes **********/}
										<div>
											<p className="form_p_client">Adicionar Dependentes</p>
											{/* <div className="subtitle_dependents" style={{ textAlign:'left'}}>
												Podem participar do plano: cônjuges, filhos(as) com
												até 24 anos de idade, enteados e pais do titular ou do cônjuge
											</div> */}
											<p className='alert-info'>Para adicionar dependentes preencha os dados abaixo e clique em 'Adicionar Dependente' </p>
											<p className="form_p_title">Dados Pessoais do Dependente</p>

											<Row>
												<Col xs="12" sm="5" md="4" lg="2">
													<FormGroup className="arrow_form form_group">
														<Input id="dp_parentage" className="form-control" type="select" name="select"
															onChange={this.onChangeState.bind(this, "dp_parentage")}
															onBlur={this.validateSelect.bind(this, "dp_parentage")}>

															<option value="-1">Parentesco</option>
															<option value="CÔNJUGE">CÔNJUGE</option>
															<option value="FILHO">FILHO</option>
															<option value="PAI/MÃE">PAI/MÃE</option>
															<option value="OUTRO">OUTRO</option>
														</Input>
														<Alert id="alert_dp_parentage">*Campo obrigatório!</Alert>
													</FormGroup>
												</Col >
												<Col xs="12" sm="7" md="8" lg="5">
													<FormGroup className="form_group">
														<Input id="dp_firstName"
															placeholder='*Nome completo'
															className="form-control" type="text"
															onBlur={this.validateLetters.bind(this, "dp_firstName")}
															onChange={this.onChangeState.bind(this, "dp_firstName")}
														/>
														<Input id="dp_lastName" className="form-control" type="hidden" />
														<Alert id="alert_dp_firstName">*Campo inválido!</Alert>
													</FormGroup>
												</Col>
												<Col xs="12" sm="6" md="6" lg="2">
													<FormGroup className="form_group">
														<InputMask
															id="dp_cpf"
															mask="999.999.999-99"
															maskChar={null}
															className="form-control"
															placeholder='*CPF'
															type="tel"
															value={this.state.dependent.cpf}
															onBlur={this.validateCpf.bind(this, "dp_cpf")}
															onChange={this.onChangeState.bind(this, "dp_cpf")}
														/>
														<Alert id="alert_dp_cpf">*Cpf inválido!</Alert>
														<Alert id="alert_cpfObligatory">Cpf obridp_dateOfBirthgatório!</Alert>
													</FormGroup>
												</Col>
												<Col xs="12" sm="6" md="6" lg="3">
													<FormGroup className="form_group">
														<InputMask
															id="dp_dateOfBirth" 
															className="ant-input form-control"
															placeholder='*Data de Nasc'
															mask="99/99/9999"
															maskChar=" "
															type="tel"
															value={this.state.dependent.dateOfBirth}														
															onBlur={this.validateDateDependent.bind(this, "dp_dateOfBirth")}
															onChange={this.onChangeState.bind(this, "dp_dateOfBirth")}
														/>

														<Alert id="alert_dp_dateOfBirth">*Data inválida!</Alert>
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" sm="6" md="6" lg="3">
													<FormGroup className="arrow_form form_group">

														<Input id="dp_maritalStatus" type="select"
															name="select"
															className="form-control"
															onBlur={this.validateSelect.bind(this, "dp_maritalStatus")}
															onChange={this.onChangeState.bind(this, "dp_maritalStatus")}
														>
															<option value="-1">*Estado Civil</option>
															<option value="SOLTEIRO">SOLTEIRO</option>
															<option value="CASADO">CASADO</option>
															<option value="VIÚVO">VIÚVO</option>
															<option value="SEPARADO">SEPARADO</option>
															<option value="DIVORCIADO">DIVORCIADO</option>
															<option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
														</Input>
														<Alert id="alert_dp_maritalStatus">*Campo obrigatório!</Alert>
													</FormGroup>
												</Col>
												<Col xs="12" sm="6" md="6" lg="3">
													<FormGroup className="arrow_form form_group">

														<Input id="dp_gender" type="select"
															name="select" className="form_control"
															onChange={this.onChangeState.bind(this, "dp_gender")}
															onBlur={this.validateSelect.bind(this, "dp_gender")}
														>
															<option value="-1">SEXO</option>
															<option value="1">M</option>
															<option value="0">F</option>
														</Input>
														<Alert id="alert_dp_gender">*Campo obrigatório!</Alert>
													</FormGroup>
												</Col>
												<Col xs="12" sm="6" md="6" lg="4">
													<FormGroup className="form_group">

														<Input id="dp_motherName"
															className="form_control"
															placeholder='*Nome da Mãe'
															type="text"
															onBlur={this.validateLetters.bind(this, "dp_motherName")}
															onChange={this.onChangeState.bind(this, "dp_motherName")}
														/>
														<Alert id="alert_dp_motherName">*Campo inválido!</Alert>
													</FormGroup>
												</Col>
												<Col xs="12" sm="6" md="6" lg="3">
													<FormGroup className="form_group">

														<Input id="dp_susNumber"
															className="form-control"
															placeholder='Cartão do SUS'
															type="tel"
															onBlur={this.validateSus.bind(this, "dp_susNumber")}
															onChange={this.onChangeState.bind(this, "dp_susNumber")}
														/>
														<Alert id="alert_dp_susNumber">*O número do SUS tem 15 dígitos!</Alert>
													</FormGroup>
												</Col>
											</Row>
{/* 
											<Alert className="alerta_dep_cpf" color="warning">
												**CPF Obrigatório para pessoas acima de 10 anos!
											</Alert> */}

												<div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
													<Button
														variant="contained"
														color="primary"
														fullWidth
														style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
														onClick={this.setDependentList.bind(this)}
														>
														ADICIONAR DEPENDENTE
													</Button> 
												</div>
											<Row style={{ margin: 0 }}>
												<p className="form_p_title">Lista de Membros do Plano</p>
												<table className="table_dependents" >
													<thead className="tr_dependents">
														<tr>
															<th className=" col_table">Nomes</th>
															<th >Tipo</th>
															<th >Valor Unitário</th>
															<th className="right_radius">Ação</th>
														</tr>
													</thead>
													<tbody>
														{this.state.dependentsList.map((item, index) =>
															this.state.dependentsList.length != index + 1 ? (
																<tr className="color_tr" key={index}>
																	<td className="padding_row_table border_td_row">{item.firstName + ' ' + item.lastName}</td>
																	<td className="border_td_row">
																		{item.isHolder ? ('Titular') : ('Dependente')}
																	</td>
																	<td className="border_td_row">R$ {this.state.valueIndividualPlan }
																			{/**
																	{(item.isHolder ) ? (' ' + this.state.value_plan)
																			: (' ' + this.state.unitary_value) }
																			*/}	

																	{/**
																		{(this.state.dependentsList.length == 1) ? (' ' + this.state.value_plan)
																			: (this.state.dependentsList.length < 3) ? (' ' + this.state.unitary_value) : (' ' + this.state.unitary_value2)}
																	*/}			
																	</td>
																	<td className="border_td_row">
																		{item.isHolder ? ('') : (
																			<div className="icon_lixo" onClick={this.deleteDependentList.bind(this, index)}>
																				{''}
																			</div>
																		)}
																	</td>
																</tr>
															) : (
																/**Necessario para que o border bottom nao apareça na ultima linha */
																<tr className="color_tr" key={index}>
																	<td className="padding_row_table border_td_radius_left">{item.firstName + ' ' + item.lastName}</td>
																	<td >
																		{item.isHolder ? ('Titular') : ('Dependente')}
																	</td>
																	<td >R$ { this.state.valueIndividualPlan}
																		{/** 
																		{(this.state.dependentsList.length == 1) ? (' ' + this.state.value_plan)
																			: (this.state.dependentsList.length < 3) ? (' ' + this.state.unitary_value) : (' ' + this.state.unitary_value2)}
																			*/}
																	</td>
																	<td className="border_td_radius_right">
																		{item.isHolder ? ('') : (
																			<div className="icon_lixo" onClick={this.deleteDependentList.bind(this, index)}>
																				{''}
																			</div>
																		)}
																	</td>
																</tr>
															)
														)}
													</tbody>
												</table>
											</Row>
											<div className="row_margin_dep">
												<p className="form_p_dependent_list">VALOR DO PLANO</p>
												<div className="color_value_plan">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan">{this.state.dependentsList.length}X PLANO DENTAL {this.state.type_plan}</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan2">R${this.state.value_plan}</Col>
													</Row>
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan3">SUBTOTAL</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan4">R${this.state.totalNoDescont}</Col>
													</Row>
													<hr className="hr_value_plans" />
													{/* 
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan5">DESCONTO DEPENDENTES</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan6">-R${this.state.valueDescontIndividual}</Col>
													</Row>
													*/}
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan5">DESCONTO</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan6">-R${this.state.valueDescontTotal}</Col>
													</Row>													
												</div>
												<div className="color_value_plan_gradient">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan7">TOTAL DO PLANO</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan8">R${this.state.value_total}</Col>
													</Row>
												</div>
											</div>
											<div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
													<Button
														variant="contained"
														color="primary"
														fullWidth
														style={{
															...Styles.buttonCancel,
															backgroundColor: Colors.textLight,
															textTransform: 'none'
														}}
														onClick={this.back_holder.bind(this)}
														>
														Voltar
													</Button>   
													<Button
													variant="contained"
													color="primary"
													fullWidth
													style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
														onClick={this.form_phases3.bind(this)}
													>
													Avançar
												</Button>  
											</div>
 
												{/** 																																					
												<div className="button_back_dependents" onClick={this.back_holder.bind(this)}>
													<span >VOLTAR</span>
												</div>

												<div className="button_next_dependents" onClick={this.form_phases3.bind(this)}>
													<span >AVANÇAR</span>
												</div>	
												*/}
										</div>
									</Container>
								</Container>
							</div>
						) : ("")}

						
						{/** FASE 3*/}
						{this.state.phasesForm == 3 ? (
							<div>
								{/**************QUARTA etapa do formulario - Formas de pagamento e pagamento da Adesão**********/}
								{/* <div id="form_img4">&nbsp;</div> */}
								<Container className="form_container2">
									{/* <Container className="container_text_img">
									<Row>
										<Col className="text_center">
											<p className="form_img_text">Dados Pessoais</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text">Dependentes</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text">Documentos</p>
										</Col>
										<Col className="text_center">
											<p className="form_img_text cor_phases">Financeiro</p>
										</Col>
									</Row>
								</Container> */}
									{this.state.payment_plan == "true" ? (
										//CARTAO DE CREDITO
										<Container className="form_container_internal">
											<p className="form_p_client">Dados Financeiros</p>
											<div className="subtitle_dependents" style={{ textAlign: 'left' }}>
												INSIRA SEUS DADOS FINANCEIROS PARA COBRANÇA DAS PRÓXIMAS MENSALIDADES
											</div>


											{/** Participa DO PLANO- pergunta! **/}
											{this.props.admin == false ? (
												<div>
													<p className="form_p_title">TITULAR DO CARTÃO DE CRÉDITO</p>
													{this.state.cardQuestion == true ? (
														<Row style={{ marginLeft: 0, marginBottom: 20 }}>
															<div className="form_titular">O TITULAR DO CARTÃO PARTICIPA DO PLANO?</div>
															<Button className="form_extra_s_true" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
															<Button className="form_extra_n" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}
														</Row>
													) : (
														this.state.cardQuestion == false ? (
															<Row style={{ marginLeft: 0, marginBottom: 20 }}>
																<div className="form_titular">O TITULAR DO CARTÃO PARTICIPA DO PLANO?</div>

																<Button className="form_extra_s" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n_false" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}

															</Row>
														) : (
															<Row style={{ marginLeft: 0, marginBottom: 20 }}>
																<div className="form_titular">O TITULAR DO CARTÃO PARTICIPA DO PLANO?</div>
																<Button className="form_extra_s" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
																<Button className="form_extra_n" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}
															</Row>
														)
													)}
													<Row style={{ marginLeft: 500, marginBottom: 20 }}>
														<Alert id="alert_questionHolderCard">*Escolha uma opção, SIM OU NÃO!</Alert>
													</Row>
												</div>
											) : ('')}
											{/* <Row>
												<Col xs="12" sm="12" md="12" lg="12">
													<p className="form_p_title">DADOS DO CARTÃO</p>
												</Col>
										</Row> */}
											{/* Cartão */}
											<div style={{ height: 50 }} ></div>
											<Row>
												<Col md="4" style={{ marginBottom: 20 }}>
													<Cards cvc={this.state.cvc} expiry={this.state.expiry} focused={this.state.focus} name={this.state.name} number={this.state.number} />
												</Col>

												<Col md="8">
													<Row>
														<Col md="6">
															<Row className='credit_card'>
																<Col md="12">
																	<InputMask className="form-control"
																		type="tel"
																		id="numeroCartao"
																		name="number"
																		placeholder='*Número do Cartão'
																		onChange={this.handleInputChange.bind(this)}
																		onFocus={this.handleInputFocus.bind(this)}
																		onBlur={this.validateCardNumber.bind(this, "numeroCartao", null)} />

																	<label id="flag_master" className="payment_layout master">&nbsp;</label>
																	<label id="flag_visa" className="payment_layout visa">&nbsp;</label>
																	<label id="flag_hiper" className="payment_layout hiper">&nbsp;</label>
																	<label id="flag_elo" className="payment_layout elo">&nbsp;</label>
																	<Alert id="alert_numeroCartao">*Cartão inválido!</Alert>
																	<Alert id="alert_flagCard">Bandeira do cartão não aceita!</Alert>
																</Col>
															</Row>
															<Row className='credit_card'>
																<Col md="12">
																	<InputMask
																		placeholder='*VALIDADE: EX.: 01/2099'
																		className="form-control"
																		type="tel"
																		id="validadeCartao"
																		title="Use MM/AAAA"
																		name="expiry"
																		onChange={this.handleInputChange.bind(this)}
																		onFocus={this.handleInputFocus.bind(this)}
																		mask="99/9999"
																		// maskChar=" "
																		onBlur={this.validateExpirationDateCard.bind(this, "validadeCartao")}
																	/>
																	<Alert id="alert_validadeCartao">*Campo inválido!</Alert>
																</Col>
															</Row>
														</Col>
														<Col md="6">
															<Row className='credit_card'>
																<Col md="12">
																	<Input
																		id="cardHolderName"
																		className="form-control"
																		placeholder='*NOME DO TITULAR DO CARTÃO'
																		type="text"
																		name="name"
																		onChange={this.handleInputChange.bind(this)}
																		onFocus={this.handleInputFocus.bind(this)}
																		onBlur={this.validateEmpty.bind(this, "cardHolderName")}
																	// onChange={this.inputToUpperCase.bind(this, 'cardHolderName')}
																	// 

																	/>

																	<Alert id="alert_cardHolderName">*Campo obrigatório!</Alert>
																</Col>
															</Row>
															<Row>
																<Col md="12" style={{ textAlign: 'center' }}>
																	<img className='bandeiras' src={urlBase.client + "assets/images2/bandeiras.png"} />
																</Col>
															</Row>


														</Col>
													</Row>
												</Col>
											</Row>
											<Row >    
												<Col lg="12">
													{this.state.habilitaCpfCartao === '' ? (
														<Row style={{ marginLeft: 0, marginBottom: 20 }}>
													<div className="form_titular">O cartão pertence a algum usuário do plano? </div>
															<Button className="form_extra_s" onClick={this.cardUsuarioQuestionS.bind(this)}>SIM</Button>{''}
															<Button className="form_extra_n" onClick={this.cardUsuarioQuestionN.bind(this)}>NÃO</Button>{''}
														</Row>
													):(
													this.state.habilitaCpfCartao == true? (
														<Row style={{ marginLeft: 0, marginBottom: 20 }}>
														<div className="form_titular">O cartão pertence a algum usuário do plano?</div>
														<Button className="form_extra_s" onClick={this.cardUsuarioQuestionS.bind(this)}>SIM</Button>{''}
														<Button className="form_extra_n_false" onClick={this.cardUsuarioQuestionN.bind(this)}>NÃO</Button>{''}
													</Row>                                    
													): (
													<Row style={{ marginLeft: 0, marginBottom: 20 }}>
													<div className="form_titular">O cartão pertence a algum usuário do plano?</div>
														<Button className="form_extra_s_true" onClick={this.cardUsuarioQuestionS.bind(this)}>SIM</Button>{''}
														<Button className="form_extra_n" onClick={this.cardUsuarioQuestionN.bind(this)}>NÃO</Button>{''}

													</Row>                                     
													)
													) }   
													<Row >
														<Col lg="5"  > 
																{""}
														</Col>   														
														<Col lg="5">
															<Alert id="alert_questionUsuarioCpfCard" color="danger">*Escolha uma opção, SIM OU NÃO!</Alert>
														</Col>	
													</Row>														

																		
												</Col>
											</Row>  
											<Row >
											<Col lg="5"> {""} </Col>                   
												<Col >
													{this.state.habilitaCpfCartao ? (

														<FormGroup className="form_group">
															<InputMask
																id="fm_cpfCard"
																name="fm_cpfCard"
																mask="999.999.999-99"
																maskChar={null}
																className="form-control"
																placeholder='*CPF'
																type="tel"
																value={this.state.financialManager.cpfCard}
																onBlur={this.validateCpf.bind(this, "fm_cpfCard")}
																onChange={this.onChangeState.bind(this, "fm_cpfCard")}
															/>
															<Alert id="alert_fm_cpfCard" color="danger">* Informe um CPF válido!</Alert>
														</FormGroup>

													) : ("")}
												</Col>

											</Row>


											{this.state.financialManager.cardDayExpiration > -1 ? (
												<div style={{ textAlign: 'center', marginTop: 20 }}>
													{/*                           <p className="vanity_ticket">
														O lançamento da parcela em sua fatura será todo dia
														<strong> {this.state.effectiveDate}</strong>
													</p> */}
													{/* <p className="vanity_ticket">
														Com o primeiro lançamento no dia
														<strong> {this.state.maturityDate}</strong>
													</p> */}
												</div>
											) : ('')}

											{/**valor do plano */}
											<div className="row_margin_dep">
												<p className="form_p_dependent_list">VALOR DO PLANO</p>
												<div className="color_value_plan">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan">{this.state.dependentsList.length}X PLANO DENTAL {this.state.type_plan}</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan2">R${this.state.value_plan}</Col>
													</Row>
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan3">SUBTOTAL</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan4">R${this.state.totalNoDescont}</Col>
													</Row>
													<hr className="hr_value_plans" />
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan5">DESCONTO TABELA FAMÍLIA</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan6">-R${this.state.valueDescontTotal}</Col>
													</Row>
												</div>
												<div className="color_value_plan_gradient">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan7">TOTAL DO PLANO</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan8">R${this.state.value_total}</Col>
													</Row>
												</div>
												<div  >
													<Row>
														<Col  className="col_plan7">
														<FormGroup className="margin_terms">
															<fieldset className="fieldset_accession">
																<label className="form_check_contrato" ><input id="checkAccession1" className="style_check" type="checkbox" name="checkAccession1"
																	onClick={this.onOpenModalTerms.bind(this)}
																	onBlur={this.validateCheckbox.bind(this, "checkAccession1")} />
																	LI E ACEITO OS <span className="red_text">TERMOS DE CONTRATAÇÃO</span>
																	<Alert id="alert_checkAccession1">*É necessário aceitar o termo!</Alert>
																</label>

															</fieldset>
														</FormGroup>															
														</Col>
													</Row>
												</div>												
											</div>

		
											{/** Valor do plano e botão avançar **/}
											<div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
												<Button
														variant="contained"
														color="primary"
														fullWidth
														style={{
															...Styles.buttonCancel,
															backgroundColor: Colors.textLight,
															textTransform: 'none'
														}}
														onClick={this.back_dependents.bind(this)}
														>
														Voltar
													</Button> 												

												{this.state.buttonSubmitForm == true ? (
													this.state.combineWithSalesman == true ? (
														<Button
															variant="contained"
															color="primary"
															fullWidth
															style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
																onClick={this.onSubmitFormNew.bind(this, localStorage.getItem('dental_v_i'), "cartao")}
															>
															Concluir
														</Button>  		
								
													) : (
														this.state.buttonPayPal == true ? (
															this.state.salesmanPaypalId != "" ? (
																<div id="paypalStyle2">
																	<PaypalExpressBtn
																		style={STYLE}
																		env={'production'}
																		client={this.state.payPalId}
																		currency={'BRL'}
																		total={parseFloat(this.state.value_total.replace(',', '.')).toFixed(2)}
																		onSuccess={this.onSuccess.bind(this)}
																		onCancel={this.onCancel.bind(this)}
																		onError={this.onError.bind(this)}
																	/>
																</div>
															) : ('')
														) : (
															this.state.buttonPagSeguro == true ? (
																this.state.salesmanPagSeguro != false ? (
																	<div id="pagseguroStyle2">
																		<Button 
																			style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }} 
																			onClick={this.pagSeguro.bind(this)} >
																			PagSeguro
																		</Button>
																	</div>
																) : ('')
															) : (
																this.props.admin == true ? (
																	<div className="button_next_dependents" onClick={this.beforeSubmitForm.bind("h")}>
																		<span >CONCLUIR</span>
																	</div>
																) : ('')
															)
														)
													)
												) : (
													this.state.combineWithSalesman == true ? (
												<Button
													variant="contained"
													color="primary"
													fullWidth
													style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
														onClick={this.beforeSubmitForm.bind(this)}
													>
													CONCLUIR
												</Button>  														

													) : (
														this.props.admin == true ? (
															<Button
																variant="contained"
																color="primary"
																fullWidth
																style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
																onClick={this.beforeSubmitForm.bind(this)}
																>
																CONCLUIR
															</Button> 															

														) : ('')
													)
												)}

											</div>
										</Container>
									) : (

										//BOLETO BANCARIO
										<Container className="form_container_internal">
											<p className="form_p_client">Dados Financeiros</p>
											<div className="subtitle_dependents">
												Próximas Mensalidades no Boleto Bancário
											</div>
											<Row>
												<Col>
													<div style={{ textAlign: 'center', marginTop: 20 }}>
														<p className="vanity_ticket">
															O início da vigência de seu plano será no dia
															<strong> {this.state.effectiveDate}</strong>
														</p>
														<p className="vanity_ticket">
															Com a primeira parcela para o dia
															<strong> {this.state.maturityDate}</strong>
														</p>
														{/* 
														{
															this.props.admin == false ? (
																<p className="vanity_ticket">
																	Para escolher outra data de vencimento&nbsp;
																	<strong
																		className="vanity_ticket_button_show"
																		onClick={this.onCLickVanityTicket.bind(this)}
																	>
																		clique aqui!
																	</strong>
																</p>
															) : ('')
														}
															*/}
													</div>
												</Col>
											</Row>

											{this.props.admin == false ? (
												this.state.vanityTicketButton == true ? (
													<Row style={{ margin: "auto", width: "40%" }}>
														<Col xs="12" sm="12" md="12" lg="12" >
															<FormGroup className="arrow_form form_group_payment2" style={{ marginTop: 40 }}>
																<Label className="label_form">*Escolha o vencimento do boleto:</Label>
																<Input
																	id="vanity_ticket"
																	className="input_form"
																	type="select" name="select"
																	value={this.state.vanityTicketValue}
																	onChange={this.dateValidity.bind(this, null)}
																>
																	<option value="-1">Selecionar</option>
																	<option value="5">5</option>
																	<option value="10">10</option>
																	<option value="15">15</option>
																	<option value="20">20</option>
																	<option value="25">25</option>
																	<option value="30">30</option>
																</Input>
																<Alert id="alert_vanity_ticket">*Campo obrigatório!</Alert>
															</FormGroup>
														</Col>
													</Row>
												) : ('')
											) : ('')}

											{/**valor do plano */}
											<div className="row_margin_dep">
												<p className="form_p_dependent_list">VALOR DO PLANO</p>
												<div className="color_value_plan">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan">{this.state.dependentsList.length}X PLANO DENTAL {this.state.type_plan}</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan2">R${this.state.value_plan}</Col>
													</Row>
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan3">SUBTOTAL</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan4">R${this.state.totalNoDescont}</Col>
													</Row>
													<hr className="hr_value_plans" />
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan5">DESCONTO TABELA FAMÍLIA</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan6">-R${this.state.valueDescontTotal}</Col>
													</Row>
												</div>
												<div className="color_value_plan_gradient">
													<Row>
														<Col xs="7" sm="9" md="9" lg="9" className="col_plan7">TOTAL DO PLANO</Col>
														<Col xs="5" sm="3" md="3" lg="3" className="col_plan8">R${this.state.value_total}</Col>
													</Row>
												</div>
											</div>
											
											{/** Valor do plano e botão avançar **/}
											<Row className="row_action">
												<div className="button_back_dependents" onClick={this.back_docs.bind(this)}>
													VOLTAR
												</div>
												{this.state.buttonSubmitForm == true ? (
													this.state.combineWithSalesman == true ? (
														<div onClick={this.onSubmitFormNew.bind(this, 'boleto')} className="button_next_dependents">
															CONCLUIR
														</div>
													) : (
														this.state.buttonPayPal == true ? (
															this.state.salesmanPaypalId != "" ? (
																<div id="paypalStyle2">
																	<PaypalExpressBtn
																		style={STYLE}
																		env={'production'}
																		client={this.state.payPalId}
																		currency={'BRL'}
																		total={parseFloat(this.state.value_total.replace(',', '.')).toFixed(2)}
																		onSuccess={this.onSuccess.bind(this)}
																		onCancel={this.onCancel.bind(this)}
																		onError={this.onError.bind(this)}
																	/>
																</div>
															) : ('')
														) : (
															this.state.buttonPagSeguro == true ? (
																this.state.salesmanPagSeguro != false ? (
																	<div id="pagseguroStyle2">
																		<Button className="buttonPagseguro" onClick={this.pagSeguro.bind(this)}>PagSeguro</Button>
																	</div>
																) : ('')
															) : (
																this.props.admin == true ? (
																	<div className="button_next_dependents" onClick={this.beforeSubmitForm.bind(this)}>
																		<span >CONCLUIR</span>
																	</div>
																) : ('')
															)
														)
													)
												) : (
													this.state.combineWithSalesman == true ? (
														<div disabled className="button_next_dependents" onClick={this.beforeSubmitForm.bind(this)}>
															<span >CONCLUIR</span>
														</div>
													) : (
														this.props.admin == true ? (
															<div disabled className="button_next_dependents" onClick={this.beforeSubmitForm.bind(this)}>
																<span >CONCLUIR</span>
															</div>
														) : ('')
													)
												)}

											</Row>
										</Container>
									)}
								</Container>
							</div>
						) : ("")}
					</div>
				</Form>

				{this.props.admin == false ? (
					<div>
						<hr className="hr_img_form2" />
						{/* Removido Rodolfo */}
						{/* <Contact/>
						<Footer/> */}

					</div>
				) : ('')}

				<Dialog
					modal={false}
					open={this.state.modalPriorizarCadastro}
					onRequestClose={this.handlePriorizarCadastroClose.bind(this)}
				>
					<p className="modal_title">ATENÇÃO</p>
					<div className="modal_error_text">
						Agora que vai cadastrar os demais beneficiários do plano, a PREFERÊNCIA é que COMECE por um dependente maior de idade sendo o primeiro titular. Caso não tenha, prossiga normalmente.
					</div>
					<div style={{ textAlign: "center" }}>
						<Button onClick={this.handlePriorizarCadastroClose.bind(this)} className="modal_button1" >FECHAR</Button>{''}
					</div>
				</Dialog>
				{/* Modal cep */}

				<Dialog
					open={this.state.openCep}
					onRequestClose={this.onCloseModalCep.bind(this)}
					modal={true}
				>
					<p className="form_p_client">DIGITE SEU CEP</p>
					<p>Validaremos se o plano escolhido está disponível na sua região</p>
					<div className="subtitle_dependents">
						<Row>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
							<Col xs="12" sm="8" md="8" lg="8">
								<FormGroup className="form_group">
									{/* <Label className="label_form">*CEP: </Label> */}
									<i id="loading_address"
										style={{ display: 'none', marginLeft: 5, width: 16 }}
										className="fa fa-spinner fa-spin">
										&nbsp;
									</i>
									<InputMask
										id="buscacep"
										className='ant-input form-control'
										placeholder='*CEP'
										mask="99.999-999"
										maskChar=" "
										type="tel"
										value={this.state.financialManager.cep}
										//onBlur={this.getAddressModal.bind(this, 'buscacep')}
										onChange={this.onChangeStateBuscaCep.bind(this, "buscacep")}
									/>

									{this.state.showCepError ? (
										<Alert color="danger">*CEP inválido!</Alert>
									) : ('')}
									{this.state.cepNaoLocalizado ? (
										<Alert id="alert_buscacpe" color="danger">*CEP inexistente!</Alert>
									) : ('')}

									{!this.state.planAvaliable ? (
										<Alert color="danger">Plano selecionado indisponível para seu Estado</Alert>
									) : ('')}


									{/*<Input className="input_form" type="text" id="fm_cep" onBlur={this.getAddress.bind(this, 'financialManager')} />*/}
								</FormGroup>
							</Col>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
						</Row>
					</div>
					<br/><br/>
					<Row style={{ marginTop: '-40px' }}>
						<Col xs="10" sm="12" md="2" lg="4" ></Col>
						<Col xs="10" sm="12" md="8" lg="5">
							{!this.state.planAvaliable ? (
								<div className="button_plans" onClick={this.redirectPlans.bind(this)}>
									<span>SELECIONAR OUTRO PLANO</span>
								</div>
							) : (
								<div className="button_plans" onClick={this.getAddressModal.bind(this, 'buscacep')}>
									<span>BUSCAR</span>
								</div>
							)}
						</Col>
						<Col xs="10" sm="12" md="2" lg="2">{''}</Col>

					</Row>

				</Dialog>


				{/*        Dialog da verificação do cartao de crédito */}
				{/* DESABILIDADO 
<Dialog
					modal={false}
					open={this.state.openModalHiper}
					onRequestClose={this.handleHiperMasterClose.bind(this)}
				>
					<p className="modal_title">ATENÇÃO</p>
					<div className="modal_error_text">
					{/**  O cartão cadastrado é do tipo Hiper-Master? */}
				{/*  Confirme a bandeira do cartão: 
					</div>
					<div style={{textAlign:"center"}}>
						<Button onClick={this.selectHiperMasterSim.bind(this)} className="modal_button1" >HIPER</Button>{''}            
						<Button onClick={this.selectHiperMasterNao.bind(this)} className="modal_button1" >MASTER</Button>{''}

					</div>
				</Dialog>
			*/}
				<Dialog
					open={this.state.alertCardAvaliable}
					modal={true}
				>
					<p className="form_p_client">ATENÇÃO!</p>
					<div className="subtitle_dependents">
						<Row>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
							<Col xs="12" sm="8" md="8" lg="8">

								<div style={{ fontSize: '14px', marginLeft: '20px', marginTop: '4px', textAlign: 'left' }}>
									<ul>
										{this.state.messagesErrorCard}
									</ul>

								</div>              </Col>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
						</Row>
					</div>
					<Row style={{ marginTop: '-40px' }}>
						<Col md="3" lg="3"></Col>
						<Col xs="12" sm="12" md="6" lg="6">
							<div className="button_plans" onClick={this.onCloseModalValidateCard.bind(this)}>
								<span>Fechar</span>
							</div>
						</Col>
						<Col md="3" lg="3"></Col>
					</Row>

				</Dialog>

				<Dialog
					open={this.state.alertPlanNotAvaliable}
					modal={true}
				>
					<p className="form_p_client">AVISO!</p>
					<div className="subtitle_dependents">
						<Row>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
							<Col xs="12" sm="8" md="8" lg="8">
								<Alert color="danger">*O plano selecionado não atende a sua faixa de idade!</Alert>
							</Col>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
						</Row>
					</div>
					<Row style={{ marginTop: '-40px' }}>
						<Col md="3" lg="3"></Col>
						<Col xs="12" sm="12" md="6" lg="6">
							<div className="button_plans" onClick={this.redirectPlans.bind(this)}>
								<span>SELECIONAR OUTRO PLANO</span>
							</div>
						</Col>
						<Col md="3" lg="3"></Col>
					</Row>

				</Dialog>


				<Dialog
					open={this.state.modalBoleto}
					modal={true}
				>
					<p className="form_p_client">AVISO!</p>
					<div className="subtitle_dependents">
						<Row>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
							<Col xs="12" sm="8" md="8" lg="8">
								<h3>*Você precisa estar ciente sobre o não envio de boleto!</h3>
							</Col>
							<Col xs="12" sm="2" md="2" lg="2"></Col>
						</Row>
					</div>
					<Row style={{ marginTop: '-40px' }}>
						<Col md="3" lg="3"></Col>
						<Col xs="12" sm="12" md="6" lg="6">
							<div className="button_plans" onClick={this.closeAlertBoleto.bind(this)}>
								<span>OK</span>
							</div>
						</Col>
						<Col md="3" lg="3"></Col>
					</Row>

				</Dialog>


				{/************** Modais do formulario abaixo **********/}
				{/************** Modal dados invalidos *******  ***/}
				<Dialog
					open={this.state.open}
					onRequestClose={this.onCloseModal.bind(this)}
				>
					<p className="form_p_client">ATENÇÃO</p>
					<div className="subtitle_dependents">
						Por favor, verifique o formulário,<br />
						preencha os campos obrigatórios e informe dados válidos.
					</div>

					<div className="button_modal1" onClick={this.onCloseModal.bind(this)}>
						<span>OK</span>
					</div>
				</Dialog>
				{/************** Modal sem dependentes **********/}
				<Dialog
					open={this.state.modalNoDependent}
					onRequestClose={this.onCloseModalNoDependent.bind(this)} center showCloseIcon={false}
					title={
						<div>
							<i
								id="form_client_close_modal"
								className="fas fa-times-circle color_fa"
								onClick={this.onCloseModalNoDependent.bind(this)}
							>{''}</i>
							<p className="form_p_client">ATENÇÃO</p>
						</div>
					}
					contentStyle={{ width: '85%', maxWidth: 500 }}
				//contentClassName="custom-modal-dependets"
				>
					<div className="subtitle_dependents">
						Deseja prosseguir sem adicionar dependentes?
					</div>
					<Row>
						<Col xs="6" sm="6" md="6" lg="6" xl="6" style={{ textAlign: 'right' }}>
							<Button className="modal_dependentes_button_n" onClick={this.onCloseModalNoDependent.bind(this)}>NÃO</Button>
						</Col>
						<Col xs="6" sm="6" md="6" lg="6" xl="6" style={{ textAlign: 'left' }}>
							<Button className="modal_dependentes_button_s" onClick={this.onOpenModalPhases.bind(this)}>SIM</Button>
						</Col>
					</Row>
				</Dialog>
				{/************** Modal após 2° etapa do form status do form **********/}
				<Dialog
					open={this.state.modalPhases}
					onClose={this.onCloseModalPhases.bind(this)}
					center showCloseIcon={false}
					contentStyle={{ width: '85%', maxWidth: 550 }}
				//contentClassName={{ modal: 'custom-modal-docs' }}
				>
					<i
						id="form_client_close_modal"
						className="fas fa-times-circle color_fa"
						onClick={this.onCloseModalPhases.bind(this)}
					>{''}</i>
					<p className="form_p_client">FALTA POUCO!</p>
					<div className="subtitle_dependents">
						<p>Você está a duas etapas de concluir a compra</p>
						<p>do seu plano. Agora é hora de anexar os</p>
						<p>documentos necessários.</p>
					</div>
					<Row>
						<Col xs="12" sm="12" md="12" lg="6" xl="6" style={{ textAlign: 'center' }}>
							<div className="button-grey" onClick={this.onOpenModalPhasesResume.bind(this)}>
								<div>
									RESUMO DA PROPOSTA
								</div>
							</div>
						</Col>
						<Col xs="12" sm="12" md="12" lg="6" xl="6" style={{ textAlign: 'center' }}>
							<div className="gradient-box-form" onClick={this.phases3NoDependentModal.bind(this)}>
								<div>
									ANEXAR DOCUMENTOS
								</div>
							</div>
						</Col>
					</Row>
				</Dialog>

				{/************** Modal após 2° etapa RESUMO DA PROPOSTA **********/}
				<Dialog
					id="aaa"
					open={this.state.modalPhasesResume}
					onRequestClose={this.onCloseModalPhasesResume.bind(this)}
					autoScrollBodyContent={true}
					contentStyle={this.styles.modal}
					//classNames={{modal: 'custom-resume-proposal custom-resume-proposal-form'}}
					className="modal_print"
					title={
						<div className="print_resume">
							<div className="logo_modal_resume navbar-brand">&nbsp;</div>
							<div style={{ display: 'inline-block', verticalAlign: 'bottom', marginLeft: 10 }}>
								<h2 className="title_modal_resume">RESUMO DA PROPOSTA</h2>
								{this.state.type_plan == 'super' ? (//super
									<h3 className="title_modal_resume2">PLANO DENTAL SUPER</h3>
								) : (
									this.state.type_plan == 'vip' ? (//vip
										<h3 className="title_modal_resume2">PLANO DENTAL VIP</h3>
									) : (//digital
										this.state.type_plan == 'digital' ? (
											<h3 className="title_modal_resume2">PLANO DENTAL DIGITAL</h3>
										) : (//orto
											<h3 className="title_modal_resume2">PLANO DENTAL ORTO</h3>
										)
									)
								)
								}
							</div>
							<i
								id="modal_wallet_slip_close_modal"
								className="fas fa-times-circle color_fa"
								onClick={this.onCloseModalPhasesResume.bind(this)}
							>{''}</i>
						</div>
					}
				>
					<div id="print_resume">
						<div className="print_resume" id="modal_resume_parcial">
							<div className="modal_resume">
								<div className="resume_title"><span>RESPONSÁVEL FINANCEIRO</span></div>
								<Row style={{ marginBottom: 15 }}>
									<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
										<label className="label_bold2">Nome: </label>
										<p className="p_text_resume">
											{this.state.financialManager.firstName + ' ' + this.state.financialManager.lastName}
										</p>
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">CPF: </label>
										<p className="p_text_resume">
											{this.state.financialManager.cpf}
										</p>
									</Col>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">RG: </label>
										<p className="p_text_resume">
											{this.state.financialManager.rg + " / " + this.state.financialManager.rgEmitter}
										</p>
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">Data de Nasc.: </label>
										<p className="p_text_resume">
											{this.state.financialManager.dateOfBirth}
										</p>
									</Col>
								</Row>

								<Row style={{ marginBottom: 15 }}>
									<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
										<label className="label_bold2">Mãe: </label>
										<p className="p_text_resume">
											{this.state.financialManager.motherName}
										</p>
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">Estado civil: </label>
										<p className="p_text_resume">
											{this.state.financialManager.maritalStatus}
										</p>
									</Col>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">Cartão do SUS: </label>
										{this.state.financialManager.susNumber == "" ? (
											<p className="p_text_resume">Não informado</p>
										) : (
											<p className="p_text_resume">{this.state.financialManager.susNumber}</p>
										)}
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">Telefone: </label>
										{this.state.financialManager.homePhone == "" ? (
											<p className="p_text_resume">Não informado</p>
										) : (
											<p className="p_text_resume">{this.state.financialManager.homePhone}</p>
										)}
									</Col>
								</Row>

								<Row style={{ marginBottom: 15 }}>
									<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
										<label className="label_bold2">Email: </label>
										<p className="p_text_resume">
											{this.state.financialManager.email}
										</p>
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">Celular 1: </label>
										<p className="p_text_resume">
											{this.state.financialManager.cellPhone}
										</p>
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">Celular 2: </label>
										{this.state.financialManager.cellPhone2 == "" ? (
											<p className="p_text_resume">Não informado</p>
										) : (
											<p className="p_text_resume">{this.state.financialManager.cellPhone2}</p>
										)}
									</Col>
								</Row>
							</div>

							<hr className="hr-modal-resume" />

							<div className="modal_resume">
								<div className="resume_title"><span>ENDEREÇO</span></div>
								<Row style={{ marginBottom: 15 }}>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">Tipo de Lograd.: </label>
										{this.state.addressTypeList.map((item, index) =>
											item.Id == this.state.financialManager.addressType ? (
												<p key={index} className="p_text_resume">
													{" " + item.Nome}
												</p>
											) : ("")
										)}
									</Col>
									<Col className="col-print-9" xs="12" sm="12" md="6" lg="9" xl="9">
										<label className="label_bold2">Rua: </label>
										<p className="p_text_resume">
											{this.state.financialManager.address + ", N°: " + this.state.financialManager.addressNumber}
										</p>
									</Col>
								</Row>

								<Row style={{ marginBottom: 15 }}>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">Complemento: </label>
										{this.state.financialManager.addressComplement == "" ? (
											<p className="p_text_resume">
												Não informado
											</p>
										) : (
											<p className="p_text_resume">
												{this.state.financialManager.addressComplement}
											</p>
										)}
									</Col>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">Bairro: </label>
										<p className="p_text_resume">
												{this.state.districtDescription}
											</p>	
									</Col>
									<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
										<label className="label_bold2">Cidade: </label>
										{this.state.cityList.map((item, index) =>
											item.Id == this.state.idCidade ? (
												<p key={index} className="p_text_resume">
													{" " + item.Nome}
												</p>
											) : ("")
										)}
									</Col>
									<Col className="col-print-1" xs="12" sm="12" md="6" lg="1" xl="1">
										<label className="label_bold2">U.F.: </label>
										{this.state.stateList.map((item, index) =>
											item.Id == this.state.idUf ? (
												<p key={index} className="p_text_resume">
													{" " + item.Sigla}
												</p>
											) : ("")
										)}
									</Col>
									<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
										<label className="label_bold2">CEP: </label>
										<p className="p_text_resume">
											{this.state.financialManager.cep}
										</p>
									</Col>
								</Row>
							</div>


							<div style={{ pageBreakAfter: 'always' }}>
								<hr className="hr-modal-resume" />
							</div>

							{
								this.state.dependentsList.length > 0 ? (
									<div className="modal_resume">
										<div className="resume_title"><span>TITULAR</span></div>

										<Row style={{ marginBottom: 15 }}>
											<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
												<label className="label_bold2">Nome: </label>
												<p className="p_text_resume">
													{this.state.dependentsList[0].firstName + " " + this.state.dependentsList[0].lastName}
												</p>
											</Col>
											<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
												<label className="label_bold2">CPF: </label>
												<p className="p_text_resume">
													{this.state.dependentsList[0].cpf}
												</p>
											</Col>
											<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
												<label className="label_bold2">Data de Nasc.: </label>
												<p className="p_text_resume">
													{this.state.dependentsList[0].dateOfBirth}

												</p>
											</Col>
											<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
												<label className="label_bold2">Estado civil: </label>
												<p className="p_text_resume">
													{this.state.dependentsList[0].maritalStatus}
												</p>
											</Col>
										</Row>

										<Row style={{ marginBottom: 15 }}>
											<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
												<label className="label_bold2">Mãe: </label>
												<p className="p_text_resume">
													{this.state.dependentsList[0].motherName}
												</p>
											</Col>
											<Col className="col-print-3" xs="12" sm="12" md="12" lg="3" xl="3">
												<label className="label_bold2">Valor Individual:</label>
												<p style={{ fontFamily: "RobotoBold" }} className="p_text_resume">
												{/*  {' R$ ' + this.state.objectPlan.value} */}
												{' R$ ' + this.state.valueIndividualPlan}
												</p>
											</Col>
										</Row>
										<hr className="hr-modal-resume" />
									</div>
								) : ('')
							}

							{
								this.state.dependentsList.length > 1 ? (
									<div style={{ marginTop: 30 }}>
										<div className="resume_title"><span>DEPENDENTES</span></div>
										{
											this.state.dependentsList.map((item, index) =>
												index > 0 ? (
													<div className="modal_resume">
														<Row style={{ marginBottom: 15 }}>
															<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
																<label className="label_bold2">Nome: </label>
																<p className="p_text_resume">
																	{item.firstName + " " + item.lastName}
																</p>
															</Col>
															<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
																<label className="label_bold2">CPF: </label>
																<p className="p_text_resume">
																	{item.cpf}
																</p>
															</Col>
															<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
																<label className="label_bold2">Data de Nasc.: </label>
																<p className="p_text_resume">
																	{item.dateOfBirth}
																
																</p>
															</Col>
															<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
																<label className="label_bold2">Estado civil: </label>
																<p className="p_text_resume">
																	{item.maritalStatus}
																</p>
															</Col>
														</Row>

														<Row>
															<Col className="col-print-5" xs="12" sm="12" md="6" lg="5" xl="5">
																<label className="label_bold2">Mãe: </label>
																<p className="p_text_resume">
																	{item.motherName}
																</p>
															</Col>
															<Col className="col-print-3" xs="12" sm="12" md="12" lg="3" xl="3">
																<label className="label_bold2">Valor Individual:</label>
																<p style={{ fontFamily: "RobotoBold" }} className="p_text_resume">
																	{"R$ " + this.state.valueIndividualPlan}
																</p>
															</Col>
															<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
																{index == 0 ? ("") : (
																	<div>
																		<label className="label_bold2">Parentesco: </label>
																		<p className="p_text_resume">
																			{item.parentage}
																		</p>
																	</div>
																)}
															</Col>
														</Row>
														<hr style={{ width: "75%", margin: '30px auto' }} />
													</div>
												) : ('')
											)}
									</div>
								) : ('')
							}
							{/**********exibe mais informações da carência ***************/}

							<div className="modal_resume">
									<div className="resume_title"><span>INFORMAÇÕES DO PLANO</span></div>
									<Row>
										<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
											<label className="label_bold2">Nome do plano:</label>
											<p className="p_text_resume">
												PLANO DENTAL { this.state.type_plan }
											</p>
										</Col>
										<Col className="col-print-2" xs="12" sm="12" md="6" lg="2" xl="2">
											<label className="label_bold2">Valor total:</label>
											<p style={{ fontFamily: "RobotoBold" }} className="p_text_resume">
												{"R$ " + this.state.value_total}
											</p>
										</Col>

										<Col className="col-print-3" xs="12" sm="12" md="6" lg="3" xl="3">
											<label className="label_bold2">Nome da corretora:</label>
											<p className="p_text_resume">
												{this.state.nameModalValidateCardBroker}
											</p>
										</Col>
										<Col className="col-print-4" xs="12" sm="12" md="6" lg="4" xl="4">
											<label className="label_bold2">Nome do vendedor:</label>
											<p className="p_text_resume">
												{this.state.nameSalesman}
											</p>
										</Col>
									</Row>

									<hr className="hr-modal-resume" />

									<div className="modal_resume">
										<div className="resume_title"><span>TERMO ADITIVO DE REDUÇÃO DE CARÊNCIA</span></div>
										<Row>
											<Col xs="12" sm="12" md="12" lg="12" xl="12">
												<table className="table-modal-resume">
													<thead>
														<tr>
															<th style={{ borderTopLeftRadius: 15 }}>COBERTURAS</th>
															{this.state.payment_plan == 'true' ? (
																<th style={{ borderTopRightRadius: 15 }}>CARTÃO DE CRÉDITO</th>
															) : (
																<th style={{ borderTopRightRadius: 15 }}>BOLETO BANCÁRIO</th>
															)
															}
														</tr>
													</thead>
													<tbody>
														<tr>
														<td className="text_table_family3">{this.state.cobertura.linha_1} </td>
														<td className="text_table_family3 td_border_left">{this.state.cobertura.urgencia}</td>
														</tr>	
														<tr>
														<td className="text_table_family3">{this.state.cobertura.linha_2} </td>
														<td className="text_table_family3 td_border_left td_border_top">{this.state.cobertura.dentistica}</td>
														</tr>
														<tr>
														<td className="text_table_family3 td_border_top">PERIODONTIA</td>
														<td className="text_table_family3 td_border_left td_border_top">{this.state.cobertura.periodontia}</td>
														</tr>    
														<tr>
														<td className="text_table_family3 td_border_top">ENDODONTIA (canal)</td>
														<td className="text_table_family3 td_border_left td_border_top">{this.state.cobertura.endodontia}</td>
														</tr>                                              

														<tr>
														<td style={{borderBottomLeftRadius: 10}} className="text_table_family3 td_border_top">CIRURGIAS</td>
														<td style={{borderBottomRightRadius: 10}} className="text_table_family3 td_border_left td_border_top">{this.state.cobertura.cirurgias}</td>

														</tr>
														<tr>
															<td style={{borderBottomLeftRadius: 10}} className="text_table_family3 td_border_top">COROA</td>
																<td style={{borderBottomRightRadius: 10}} className="text_table_family3 td_border_left td_border_top">{this.state.cobertura.coroa}</td>
														</tr>  														
													</tbody>
												</table>
											</Col>
										</Row>
									</div>
								</div>

							{/**********exibe mais informações do resumo - COMPLETO ***************/}
							{this.state.resumeFinal == true ? (
								<div>
									<hr className="hr-modal-resume" />
									{this.state.payment_plan == "true" ? (//cartao de credito
										<div>
											{/* <div className="modal_resume">
												<div className="resume_title"><span>DOCUMENTOS</span></div>
												<Row>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">CPF:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">RG:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Comprovante de Residência:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Cartão de Crédito:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
												</Row>
											</div> 

											<hr className="hr-modal-resume" />
*/}
											<div className="modal_resume">
												<div className="resume_title"><span>TERMOS</span></div>
												<Row style={{ marginBottom: 15 }}>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Li e aceito os termos de contratação</label>
														<p className="p_text_resume">
															Sim
														</p>
													</Col>
													{/* <Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Quero acompanhar o andamento da minha proposta</label>
														{this.state.followProposal == true ? (
															<p className="p_text_resume">
																Sim
															</p>
														) : (
															<p className="p_text_resume">
																Não
															</p>
														)
														}
													</Col> */}
												</Row>
												<Row style={{ marginBottom: 15 }}>
													{/* <Col xs="12" sm="12" md="12" lg="12" xl="12">
														<label className="label_bold2">
															Desejo receber a rede credenciada, resumo do contrato e aditivos de carência
														</label>
														<p className="p_text_resume">
															Sim
														</p>
													</Col> */}
												</Row>
											</div>

											<hr className="hr-modal-resume" />

											<div className="modal_resume">
												<div className="resume_title"><span>DADOS FINANCEIROS</span></div>
												<Row>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Cartão de crédito:</label>
														<p className="p_text_resume">
															{this.state.flagCardPayment}
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Final do cartão:</label>
														<p className="p_text_resume">
															{" XXXX.XXXX.XXXX." + this.state.cardNumberFourFinal}
														</p>
													</Col>
												</Row>
												<Row>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Nome do titular do cartão:</label>
														<p className="p_text_resume">
															{document.getElementById('cardHolderName').value}
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Validade do cartão:</label>
														<p className="p_text_resume">
															{this.state.dateExpirationCard}
														</p>
													</Col>
												</Row>
												{/* 
										<Row>
											<Col xs="12" sm="12" md="6" lg="6" xl="6">
												<label className="label_bold2">Dia do vencimento:</label>
												<p className="p_text_resume">
													{this.state.chosenDateCard}
												</p>
											</Col>

										</Row>
									*/}
												<Row>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">O lançamento da parcela em sua fatura será todo dia:</label>
														<p className="p_text_resume">
															{this.state.effectiveDate}
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Cartão pertencente a algum usuário do plano? </label>
														{this.state.habilitaCpfCartao == true ? (
															[<p className="p_text_resume">Não</p>,
															<label className="label_bold2">CPF do dono do cartão:</label>,
															<p className="p_text_resume"> {this.state.financialManager.cpfCard}</p>
															]

														) : (
															<p className="p_text_resume">
																Sim
															</p>
														)
														}
													</Col>
												</Row>

											</div>
										</div>
									) : (//boleto bancario
										<div>
											<div className="modal_resume">
												<div className="resume_title"><span>DOCUMENTOS</span></div>
												<Row>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">CPF:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">RG:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Comprovante de Residência:</label>
														<p className="p_text_resume">
															Em anexo
														</p>
													</Col>
												</Row>
											</div>

											<hr className="hr-modal-resume" />

											<div className="modal_resume">
												<div className="resume_title"><span>TERMOS</span></div>
												<Row style={{ marginBottom: 15 }}>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Li e aceito os termos de contratação</label>
														<p className="p_text_resume">
															Sim
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="6" xl="6">
														<label className="label_bold2">Quero acompanhar o andamento da minha proposta</label>
														{this.state.followProposal == true ? (
															<p className="p_text_resume">
																Sim
															</p>
														) : (
															<p className="p_text_resume">
																Não
															</p>
														)
														}
													</Col>
												</Row>
												<Row style={{ marginBottom: 15 }}>
													<Col xs="12" sm="12" md="12" lg="12" xl="12">
														<label className="label_bold2">
															Desejo receber a rede credenciada, resumo do contrato e aditivos de carência
														</label>
														<p className="p_text_resume">
															Sim
														</p>
													</Col>
												</Row>
											</div>

											<hr className="hr-modal-resume" />

											<div className="modal_resume">
												<div className="resume_title"><span>FORMAS DE PAGAMENTO</span></div>
												<Row style={{ marginBottom: 15 }}>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Pagamento:</label>
														<p className="p_text_resume">
															BOLETO BANCÁRIO
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Início da vigência:</label>
														<p className="p_text_resume">
															{this.state.effectiveDate}
														</p>
													</Col>
													<Col xs="12" sm="12" md="6" lg="4" xl="4">
														<label className="label_bold2">Primeira parcela:</label>
														<p className="p_text_resume">
															{this.state.maturityDate}
														</p>
													</Col>
												</Row>
											</div>
										</div>
									)
									}

									<hr className="hr-modal-resume" />

									<div className="modal_resume">
										<div className="resume_title"><span>PAGAMENTO DA ADESÃO</span></div>
										{
											this.state.pagSeguroData.success == true ? (
												<div>
													<Row>
														<Col xs="12" sm="12" md="12" lg="12" xl="12">
															<label className="label_bold2">PagSeguro:</label>
															<p className="p_text_resume">
																Transação efetuada com sucesso
															</p>
														</Col>
														<Col xs="12" sm="12" md="12" lg="12" xl="12">
															<label className="label_bold2">Código da transação:</label>
															<p className="p_text_resume">
																{this.state.pagSeguroData.transactionCode}
															</p>
														</Col>
													</Row>
													<Row>
														<Col xs="12" sm="12" md="12" lg="12" xl="12">
															<label className="label_bold2">Valor:</label>
															<span style={{ fontFamily: "RobotoBold", fontSize: 22 }}>{" R$ " + this.state.value_total}</span>
														</Col>
													</Row>
												</div>
											) : (
												this.state.payPalApprovedData.paid == true ? (
													<div>
														<Row>
															<Col xs="12" sm="12" md="12" lg="12" xl="12">
																<label className="label_bold2">PayPal:</label>
																<p className="p_text_resume">
																	Transação efetuada com sucesso
																</p>
															</Col>
															<Col xs="12" sm="12" md="12" lg="12" xl="12">
																<label className="label_bold2">Código do pagamento:</label>
																<p className="p_text_resume">
																	{" " + this.state.payPalApprovedData.paymentID}
																</p>
															</Col>
														</Row>
														<Row>
															<Col xs="12" sm="12" md="12" lg="12" xl="12">
																<label className="label_bold2">Valor:</label>
																<span style={{ fontFamily: "RobotoBold", fontSize: 22 }}>{" R$ " + this.state.value_total}</span>
															</Col>
														</Row>
													</div>
												) : (
													<div>
														<Row>
															<Col xs="12" sm="12" md="12" lg="12" xl="12">
																<label className="label_bold2">A combinar:</label>
																<p className="p_text_resume">
																	Pagamento a combinar com o vendedor...
																</p>
															</Col>
														</Row>
													</div>
												)
											)
										}
									</div>

									{/* <Row style={{width:'100%'}}>
									<Col xs="6" sm="6" md="6" lg="8">
										<p className="footer_resume">
											<strong>Matriz</strong> - Rua Desembargador José Peregrino, 230, Centro, João Pessoa - PB | CEP: 58013-500
										</p>
									</Col>
									<Col xs="6" sm="6" md="6" lg="4" >
										<div className="secundary_footer_ans_resume">&nbsp;</div>
									</Col>
								</Row> 
								   PAULO
								*/}

									<div id="no_print">
										<hr />
										<Row>
										<Col md='2'></Col>
											<Col md='3' className='text-center'>
												<Link onClick={this.openPDF} >
													<div className="button_plans">IMPRIMIR</div>                            					</Link>
												{/*}										
												<div onClick={this.onResumePrint.bind(this)}>
													<div className="button_plans">IMPRIMIR</div>
												</div>
												*/}
											</Col>
											<Col md='3' className='text-center'>
												{this.state.btnFinishSales == 'enable' ? (
													<div onClick={this.onSubmitForm.bind(this, this.state.dental_v_i)}
														ref={btn => { this.btn = btn; }}
														>
														<div className="button_plans">FINALIZAR</div>
													</div>
												) : (
													<div className='no-active'>
														<div className="button_plans">ENVIANDO</div>
													</div>
												)}

											</Col>
											<Col md='3' className='text-center'>
												{
													this.state.combineWithSalesman == true ? (
														<div className="button_plans"
															onClick={this.onCloseModalPhasesResume.bind(this)}>
															FECHAR
														</div>
													) : ('')
												}
											</Col>
										</Row>
									</div>
								</div>
							) : (
								<div id="no_print2">
									<hr />
									<Row>
										<Col md='2'></Col>
										<Col md='4' className='text-center'>
											<Button onClick={this.onCloseModalPhasesResume.bind(this)}>
												<div className="button_plans">FECHAR</div>
											</Button>
										</Col>
										<Col md='4'>
											<Button onClick={this.onResumePrint.bind(this)}>
												<div className="button_plans">IMPRIMIR</div>
											</Button>
										</Col>
										<Col md='2'></Col>
									</Row>
								</div>
							)
							}
						</div>
					</div>
				</Dialog>

				{/************** Modal termo **********/}
				<Dialog
					open={this.state.openTerms}
					onRequestClose={this.onCloseModalTerms}
					title={
						<h2 style={{ color: "#696969" }}>TERMOS DE CONTRATAÇÃO</h2>
					}
					autoScrollBodyContent={true}
					actions={
						<Button className="button_modal2"
							onClick={this.onCloseModalTerms.bind(this)}>
							Confirmar
						</Button>
					}
				>
					<iframe src={`../../assets/docs/${this.state.contractFile}`} style={{ minHeight: "500px", height: '100%', width: "100%" }}>
						&nbsp;
					</iframe>

{/*
					{this.state.planCodeS4E == 1098 && this.state.stateMASLZ ? (
						<iframe src="../../assets/docs/CONTRATO_PLANO_ORTO_SLZ.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}
					{this.state.planCodeS4E == 1108 ? (
						<iframe src="../../assets/docs/DENTAL DIGITAL CLINICO SLZ.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}
					{this.state.stateMASLZ && this.state.payment_plan == "true" && this.state.planCodeS4E != 1108 && this.state.planCodeS4E != 1098 ? (
						<iframe src="../../assets/docs/CONTRATO_SLZ_CARTAO.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}

					{this.state.stateMASLZ && this.state.payment_plan == "false" ? (
						<iframe src="../../assets/docs/CONTRATO_SLZ_BOLETO.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}

					{this.state.planCodeS4E == 1069 || this.state.planCodeS4E == 1068 ? (
						<iframe src="../../assets/docs/CONTRATO_JP_ORTO.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}

					{this.state.planCodeS4E != 1069 && this.state.planCodeS4E != 1068 && !this.state.stateMASLZ ? (
						<iframe src="../../assets/docs/CONTRATO_JP_CLINICO.pdf" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
							&nbsp;
						</iframe>
					) : ('')}
*/}
				</Dialog>

				{/************** Modal Loading **********/}
				<Dialog
					open={this.state.openLoading}
					contentStyle={{ width: '40%', minWidth: 400 }}
					onRequestClose={this.onCloseModalSuccess}
				>
					<div id="loading_progress">
						<p className="p_success" style={{ textAlign: 'center', fontWeight: 700, fontSize: 18 }}>
							ENVIO DA PROPOSTA
						</p>
						<p id="modal_success" className="p_text_resume" style={{ textAlign: 'center', margin: '20px 0 5px 0' }}>
							Anexando arquivos
						</p>
						<p id="modal_success2" className="p_text_resume" style={{ textAlign: 'center', margin: '20px 0 5px 0', display: 'none' }}>
							Validando dados
						</p>
						<p id="modal_success3" className="p_text_resume" style={{ textAlign: 'center', margin: '20px 0 5px 0', display: 'none' }}>
							Enviando proposta
						</p>

						<Progress striped color="success" value={this.state.progress} />
					</div>
				</Dialog>

				{/************** Modal SUCCESS **********/}
				<Dialog
					open={this.state.openSuccess}
					//open={true}
					onRequestClose={this.onCloseModalSuccess}
					contentStyle={{ width: '40%', minWidth: 400 }}
					title={
						<div>
							<i
								id="form_client_close_modal"
								className="fas fa-times-circle color_fa"
								onClick={this.onCloseModalSuccess.bind(this)}
							>{''}</i>
							<p className="form_p_client">PARABÉNS</p>
						</div>
					}
				>
					<div
						id="close_success"
					>
					
						<div>
							<p className="msg_success">
								Sua proposta já foi encaminhada para a Dental Center. Enviamos um link para seu email, clique nele para confirmar sua proposta.
							</p>
						</div>
	
							<Row >
								<Col  md='1' >
								</Col>									
								<Col md='4' className='button_next_dependents'>
									<div  onClick={this.openPDF}>
										IMPRIMIR RESUMO
									</div>								
								</Col>
								<Col  md='4' className='button_next_dependents'>
									<div  onClick={this.onCloseModalSuccess.bind(this)}>
										FECHAR
									</div>							
								</Col>							
								<Col  md='1' >
								</Col>	

							</Row>

			
					</div>
				</Dialog>
				<Dialog      
						open={this.state.modalOpenUF}
						onClick={this.onCloseModalUF.bind(this)}
						modal={true}
						title={
						<div>
							<i
							id="form_client_close_modal"
							className="fas fa-times-circle color_fa"
							>{''}</i>
							<p className="form_p_client">INFORME O ESTADO</p>
							
						</div>
						}
						contentStyle={{minWidth: '49%', borderRadius: 12}}

					>
								<Row >
								<Col xs="2" sm="2" md="2" lg="2" xl="2">  </Col>                               

								<Col xs="10" sm="10" md="10" lg="10" xl="10">  </Col>                               

								{ window.screen.width > 426 ? (
										<Col xs="12" sm="12" md="12" lg="12" xl="12">                                 
										<div className="acrylic_dentist choose_city_dentist" style={{width:'50%'}}>

											<FormGroup className="arrow_dentist" style={{margin: 0, textAlign: 'center'}}>
											<Input
												type="select" style={{ backgroundColor: 'transparent !important', border: '0px !important' }} name="select" id="i_select_states"
												onChange={this.selecionaEstado.bind(this, null, null)} >
											
												<option value={-1}>SELECIONE SEU ESTADO </option>
												{ 
												this.state.listOfStates.map(item =>
													<option key={item.Id} value={item.Id}>{item.Sigla}</option>
												)
												}
											</Input>
											</FormGroup>
										</div>
										</Col>
								) : (
									<Col xs="12" sm="12" md="12" lg="12" xl="12">                                 
									<div className="acrylic_dentist choose_city_dentist" style={{width:'100%'}}>

									<FormGroup className="arrow_dentist" style={{margin: 0, textAlign: 'center'}}>
										<Input
										type="select" style={{ backgroundColor: 'transparent !important', border: '0px !important' }} name="select" id="i_select_states"
										onChange={this.selecionaEstado.bind(this, null, null)} >
										
										<option value={-1}>SELECIONE SEU ESTADO </option>
										{ 
											this.state.listOfStates.map(item =>
											<option key={item.Id} value={item.Id}>{item.Sigla}</option>
											)
										}
										</Input>
									</FormGroup>
									</div>
								</Col>
								)
							}
								<Col xs="2" sm="2" md="2" lg="2" xl="2">  </Col>                               

								</Row>                                   
		
				</Dialog>				
			</div>
		);

	}
}

FormPlan.defaultProps = {
	admin: false,
	onClickFn: null
};


FormPlan.propTypes = {
	admin: PropTypes.bool,
	onClickFn: PropTypes.func
};

export default FormPlan;



/** WEBPACK FOOTER **
 ** ./src/components/FormMakeYourPlanNew/FormPlan.js
 **/